import * as React from 'react';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useTheme, styled, experimental_sx, alpha } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import Menu$1 from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Drawer from '@mui/material/Drawer';
import List$1 from '@mui/material/List';
import ListItem$1 from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import qs from 'qs';
import fileSaver from 'file-saver';
import { parseTemplate } from 'url-template';
import { Client } from 'ketting';
import { DataGridPro, useGridApiContext, useGridSelector, gridFilteredDescendantCountLookupSelector, gridPageSelector, gridPageCountSelector, gridPageSizeSelector, gridPaginationRowRangeSelector, enUS, esES, GridRowModes, GridActionsCellItem } from '@mui/x-data-grid-pro';
import { useDrag, useDrop } from 'react-dnd';
import Pagination from '@mui/material/Pagination';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Decimal from 'decimal.js';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Tooltip, Menu as Menu$2, MenuItem as MenuItem$1, ListItemIcon as ListItemIcon$1, ListItemText as ListItemText$1, Dialog as Dialog$1, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, Box as Box$1, Typography as Typography$1, FormHelperText } from '@mui/material';
import { caES as caES$1 } from '@mui/material/locale';
import { getGridLocalization } from '@mui/x-data-grid/utils/getGridLocalization';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import NumberFormat from 'react-number-format';
import debounce from 'lodash.debounce';
import Autocomplete from '@mui/material/Autocomplete';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import ContentState from 'draft-js/lib/ContentState';
import clsx from 'clsx';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import sx from '@mui/system/sx';
import { TimePicker } from '@mui/x-date-pickers';
import Grid$1 from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import { GridActionsCellItem as GridActionsCellItem$1, DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Keycloak from 'keycloak-js';
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var AuthContext = /*#__PURE__*/React.createContext({
  initialized: false
});
var useAuthContext = function useAuthContext() {
  var context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return context;
};

var SESSION_KEY = 'BASE_REACT_SESSION_ID';
var SessionContext = /*#__PURE__*/React.createContext();
var useSessionContext = function useSessionContext() {
  var context = React.useContext(SessionContext);

  if (context === undefined) {
    throw new Error('useSessionContext must be used within a SessionProvider');
  }

  return context;
};
var SessionProvider = function SessionProvider(props) {
  var initialSession = props.initialSession,
      children = props.children,
      localStorageActive = props.localStorageActive;
  var authContext = useAuthContext();

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      session = _React$useState2[0],
      setSession = _React$useState2[1];

  React.useEffect(function () {
    if ((!authContext || authContext.initialized) && localStorageActive) {
      var _authContext$userProf;

      var currentUserId = authContext === null || authContext === void 0 ? void 0 : (_authContext$userProf = authContext.userProfile) === null || _authContext$userProf === void 0 ? void 0 : _authContext$userProf.id;
      var currentSessionKey = currentUserId ? SESSION_KEY + '_' + currentUserId : SESSION_KEY;
      var storageSession = window.localStorage.getItem(currentSessionKey);

      if (storageSession) {
        var parsedSession = JSON.parse(storageSession);
        setSession(initialSession ? _objectSpread2(_objectSpread2({}, initialSession), parsedSession) : parsedSession);
      }
    } else if (initialSession) {
      setSession(initialSession);
    }
  }, [localStorageActive, initialSession, authContext]);
  React.useEffect(function () {
    if ((!authContext || authContext.initialized) && localStorageActive && session) {
      var _authContext$userProf2;

      var currentUserId = authContext === null || authContext === void 0 ? void 0 : (_authContext$userProf2 = authContext.userProfile) === null || _authContext$userProf2 === void 0 ? void 0 : _authContext$userProf2.id;
      var currentSessionKey = currentUserId ? SESSION_KEY + '_' + currentUserId : SESSION_KEY;
      window.localStorage.setItem(currentSessionKey, JSON.stringify(session));
    }
  }, [localStorageActive, session, authContext]);
  var setSessionAttribute = React.useCallback(function (name, value) {
    var newAttribute = _defineProperty({}, name, value);

    setSession(function (session) {
      return session ? _objectSpread2(_objectSpread2({}, session), newAttribute) : newAttribute;
    });
  }, [setSession]);
  return /*#__PURE__*/React.createElement(SessionContext.Provider, {
    value: {
      session: session,
      setSessionAttribute: setSessionAttribute
    }
  }, children);
};

var BaseAppContext = /*#__PURE__*/React.createContext({});
var useBaseAppContext = function useBaseAppContext() {
  var context = React.useContext(BaseAppContext);

  if (context === undefined) {
    throw new Error('useBaseAppContext must be used within a BaseAppProvider');
  }

  return context;
};
var BaseAppProvider = function BaseAppProvider(props) {
  var temporalMessageHandler = props.temporalMessageHandler,
      popupButtons = props.popupButtons,
      children = props.children;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      message = _React$useState4[0],
      setMessage = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      severity = _React$useState6[0],
      setSeverity = _React$useState6[1];

  var _React$useState7 = React.useState(navigator.language || navigator.userLanguage),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      currentLanguage = _React$useState8[0],
      setCurrentLanguage = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      disconnected = _React$useState10[0],
      setDisconnected = _React$useState10[1];

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var showTemporalMessage = function showTemporalMessage(message, severity) {
    if (temporalMessageHandler) {
      temporalMessageHandler(message, severity !== null && severity !== void 0 ? severity : 'success');
    } else {
      setMessage(message);
      setSeverity(severity);
      setOpen(true);
    }
  };

  var getPopupButton = function getPopupButton(code, value, description, contained, disabled) {
    var _popupButtons$code;

    var config = (_popupButtons$code = popupButtons === null || popupButtons === void 0 ? void 0 : popupButtons[code]) !== null && _popupButtons$code !== void 0 ? _popupButtons$code : {
      contained: code !== 'cancel' && code !== 'close'
    };
    return _objectSpread2(_objectSpread2({
      contained: contained
    }, config), {}, {
      value: value,
      description: description,
      disabled: disabled
    });
  };

  var temporalMessageComponent = /*#__PURE__*/React.createElement(Snackbar, {
    open: open,
    onClose: handleClose,
    autoHideDuration: 2000,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  }, 'error' === severity ? /*#__PURE__*/React.createElement(Alert, {
    onClose: handleClose,
    severity: "error",
    sx: {
      width: '100%'
    }
  }, message) : /*#__PURE__*/React.createElement(Alert, {
    onClose: handleClose,
    severity: "success",
    sx: {
      width: '100%'
    }
  }, message));
  var contextValue = {
    temporalMessageComponent: temporalMessageComponent,
    showTemporalMessage: showTemporalMessage,
    currentLanguage: currentLanguage,
    setCurrentLanguage: setCurrentLanguage,
    disconnected: disconnected,
    setDisconnected: setDisconnected,
    getPopupButton: getPopupButton
  };
  return /*#__PURE__*/React.createElement(BaseAppContext.Provider, {
    value: contextValue
  }, children);
};

var stringToColor = function stringToColor(string) {
  var hash = 0;
  var i;
  /* eslint-disable no-bitwise */

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  var color = '#';

  for (i = 0; i < 3; i += 1) {
    var value = hash >> i * 8 & 0xff;
    color += "00".concat(value.toString(16)).slice(-2);
  }
  /* eslint-enable no-bitwise */


  return color;
};

var TextAvatar = function TextAvatar(props) {
  var text = props.text;
  var textSplit = text.split(' ');
  var avatarText0 = textSplit[0][0].toUpperCase();
  var avatarText1 = textSplit.length > 1 ? textSplit[1][0].toUpperCase() : textSplit[0][1].toUpperCase();
  return /*#__PURE__*/React.createElement(Avatar, {
    alt: text,
    title: text,
    sx: {
      bgcolor: stringToColor(text)
    }
  }, avatarText0 + avatarText1);
};
var IconAvatar = function IconAvatar(props) {
  var icon = props.icon,
      title = props.title;
  return /*#__PURE__*/React.createElement(Avatar, {
    alt: title,
    title: title,
    sx: {
      bgcolor: stringToColor(icon)
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    title: title
  }, icon));
};

var UserAvatar = function UserAvatar(props) {
  var _useAuthContext = useAuthContext(),
      userProfile = _useAuthContext.userProfile;

  if (userProfile !== null && userProfile !== void 0 && userProfile.imageUrl) {
    return /*#__PURE__*/React.createElement(Avatar, {
      alt: userProfile === null || userProfile === void 0 ? void 0 : userProfile.name,
      title: userProfile === null || userProfile === void 0 ? void 0 : userProfile.name,
      src: userProfile.imageUrl
    });
  } else if (userProfile !== null && userProfile !== void 0 && userProfile.name) {
    return /*#__PURE__*/React.createElement(TextAvatar, {
      text: userProfile.name
    });
  } else {
    return /*#__PURE__*/React.createElement(Icon, props, "account_circle");
  }
};

var Auth = function Auth() {
  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _useAuthContext = useAuthContext(),
      initialized = _useAuthContext.initialized,
      loggedIn = _useAuthContext.loggedIn,
      userProfile = _useAuthContext.userProfile,
      login = _useAuthContext.login,
      logout = _useAuthContext.logout;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleOpen = function handleOpen(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var id = open ? 'auth-menu' : undefined;
  var authButton = loggedIn ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    id: "auth-button",
    size: userProfile ? 'small' : undefined,
    "aria-label": "auth menu",
    "aria-controls": open ? id : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleOpen
  }, /*#__PURE__*/React.createElement(UserAvatar, null)), /*#__PURE__*/React.createElement(Menu$1, {
    id: id,
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'auth-button'
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disableRipple: true,
    sx: {
      "&.MuiButtonBase-root:hover": {
        bgcolor: "transparent",
        cursor: "default"
      }
    }
  }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(UserAvatar, null)), /*#__PURE__*/React.createElement(ListItemText, {
    primary: userProfile === null || userProfile === void 0 ? void 0 : userProfile.name,
    secondary: userProfile === null || userProfile === void 0 ? void 0 : userProfile.email
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: function onClick() {
      handleClose();
      logout();
    }
  }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, "logout")), /*#__PURE__*/React.createElement(ListItemText, null, t('baseapp.auth.logout'))))) : /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "inherit",
    onClick: login
  }, "Login");
  return initialized ? authButton : null;
};

var Header = function Header(props) {
  var title = props.title,
      icon = props.icon,
      image = props.image,
      style = props.style,
      disconnected = props.disconnected,
      handleMenuClose = props.handleMenuClose,
      handleMenuSwitch = props.handleMenuSwitch,
      additionalHeaderComponent = props.additionalHeaderComponent;
  var theme = useTheme();
  var navigate = useNavigate();
  var isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  React.useEffect(function () {
    if (!isSmallScreen) {
      handleMenuClose();
    }
  }, [isSmallScreen]); // eslint-disable-line

  var goHome = function goHome() {
    navigate('/');
  };

  return /*#__PURE__*/React.createElement(AppBar, {
    position: "fixed",
    sx: {
      zIndex: function zIndex(theme) {
        return theme.zIndex.drawer + 1;
      }
    }
  }, /*#__PURE__*/React.createElement(Toolbar, {
    style: style
  }, !disconnected && /*#__PURE__*/React.createElement(IconButton, {
    size: "large",
    edge: "start",
    color: "inherit",
    "aria-label": "open drawer",
    onClick: handleMenuSwitch,
    sx: {
      mr: 1,
      display: {
        sm: 'flex',
        md: 'none'
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "menu")), image ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      mr: 2,
      pr: 2,
      cursor: 'pointer',
      borderRight: '1px solid white'
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      height: '32px'
    },
    onClick: goHome,
    src: image,
    alt: "logo"
  })) : null, icon ? /*#__PURE__*/React.createElement(Icon, {
    onClick: goHome,
    sx: {
      mr: 1,
      cursor: 'pointer'
    }
  }, icon) : null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    noWrap: true,
    component: "div",
    sx: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement("span", {
    onClick: goHome,
    style: {
      cursor: 'pointer'
    }
  }, title)), additionalHeaderComponent, /*#__PURE__*/React.createElement(Auth, null)));
};

var envVariable = function envVariable(name) {
  var runtimeConfig = window.__RUNTIME_CONFIG__;

  if (runtimeConfig && runtimeConfig.hasOwnProperty(name)) {
    return runtimeConfig[name];
  } else {
    return process.env[name];
  }
};

var KettingContext = /*#__PURE__*/React.createContext({});
var useKettingContext = function useKettingContext() {
  var context = React.useContext(KettingContext);

  if (context === undefined) {
    throw new Error('useKettingContext must be used within a KettingProvider');
  }

  return context;
};
var KettingProvider = function KettingProvider(props) {
  var children = props.children;

  var _useAuthContext = useAuthContext(),
      authToken = _useAuthContext.authToken;

  var _useBaseAppContext = useBaseAppContext(),
      currentLanguage = _useBaseAppContext.currentLanguage;

  var _useSessionContext = useSessionContext(),
      session = _useSessionContext.session;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      client = _React$useState2[0],
      setClient = _React$useState2[1];

  var contextRef = React.useRef();
  contextRef.current = {
    authToken: authToken,
    session: session,
    currentLanguage: currentLanguage
  };
  React.useEffect(function () {
    var envApiUrl = envVariable('REACT_APP_API_URL');
    var newClient = new Client(envApiUrl !== null && envApiUrl !== void 0 ? envApiUrl : "".concat(window.location.protocol, "//").concat(window.location.host));
    newClient.use(function (request, next) {
      var _contextRef$current = contextRef.current,
          authToken = _contextRef$current.authToken,
          session = _contextRef$current.session,
          currentLanguage = _contextRef$current.currentLanguage;

      if (authToken) {
        request.headers.set('Authorization', 'Bearer ' + authToken);
      }

      if (session) {
        request.headers.set('Bb-Session', JSON.stringify(session));
      }

      if (currentLanguage) {
        request.headers.set('Accept-Language', currentLanguage);
      }

      return next(request);
    });
    setClient(newClient);
  }, []);
  return /*#__PURE__*/React.createElement(KettingContext.Provider, {
    value: {
      client: client
    }
  }, children);
};

var ASYNC_STATUS_IDLE = 'idle';
var ASYNC_STATUS_PENDING = 'pending';
var ASYNC_STATUS_SUCCESS = 'success';
var ASYNC_STATUS_ERROR = 'error';

var logAsync = function logAsync(instanceId, msg) {

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
};

var useAsync = function useAsync(asyncFunction, immediate, immediateArgs) {
  var instanceId = React.useId();

  var _React$useState = React.useState(ASYNC_STATUS_IDLE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      status = _React$useState2[0],
      setStatus = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      value = _React$useState4[0],
      setValue = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1]; // The execute function wraps asyncFunction and
  // handles setting state for pending, value, and error.
  // useCallback ensures the below useEffect is not called
  // on every render, but only if asyncFunction changes.


  var execute = React.useCallback(function (args, callbacks) {
    var _callbacks$setStatus;

    logAsync(instanceId, 'Executant cridada async', args, callbacks); //callbacks?.setError?.(null);
    //callbacks?.setResponse?.(null);

    callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setStatus = callbacks.setStatus) === null || _callbacks$setStatus === void 0 ? void 0 : _callbacks$setStatus.call(callbacks, ASYNC_STATUS_PENDING);
    setValue(null);
    setStatus(ASYNC_STATUS_PENDING);
    setError(null);
    return asyncFunction.apply(void 0, _toConsumableArray(args)).then(function (response) {
      var _callbacks$setRespons, _callbacks$setStatus2;

      logAsync(instanceId, 'Resposta cridada async', response);
      callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setRespons = callbacks.setResponse) === null || _callbacks$setRespons === void 0 ? void 0 : _callbacks$setRespons.call(callbacks, response);
      callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setStatus2 = callbacks.setStatus) === null || _callbacks$setStatus2 === void 0 ? void 0 : _callbacks$setStatus2.call(callbacks, ASYNC_STATUS_SUCCESS);
      setValue(response);
      setStatus(ASYNC_STATUS_SUCCESS);
    }).catch(function (error) {
      if (error !== null && error !== void 0 && error.response) {
        logAsync(instanceId, 'Error cridada async amb response', error);
        error.response.json().then(function (errorJson) {
          var _callbacks$setError, _callbacks$setStatus3;

          callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setError = callbacks.setError) === null || _callbacks$setError === void 0 ? void 0 : _callbacks$setError.call(callbacks, errorJson);
          callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setStatus3 = callbacks.setStatus) === null || _callbacks$setStatus3 === void 0 ? void 0 : _callbacks$setStatus3.call(callbacks, ASYNC_STATUS_ERROR);
          setError(errorJson);
          setStatus(ASYNC_STATUS_ERROR);
        });
      } else {
        var _callbacks$setError2, _callbacks$setStatus4;

        logAsync(instanceId, 'Error cridada async sense response', error, callbacks);
        callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setError2 = callbacks.setError) === null || _callbacks$setError2 === void 0 ? void 0 : _callbacks$setError2.call(callbacks, error);
        callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setStatus4 = callbacks.setStatus) === null || _callbacks$setStatus4 === void 0 ? void 0 : _callbacks$setStatus4.call(callbacks, ASYNC_STATUS_ERROR);
        setError(error);
        setStatus(ASYNC_STATUS_ERROR);
      }
    });
  }, [asyncFunction]); // Call execute if we want to fire it right away.
  // Otherwise execute can be called later, such as
  // in an onClick handler.

  React.useEffect(function () {
    if (immediate) {
      execute(immediateArgs);
    }
  }, [execute, immediate]);
  return {
    execute: execute,
    status: status,
    response: value,
    error: error
  };
};

var logCallQueue = function logCallQueue(instanceId, msg) {

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
};

var useCallQueue = function useCallQueue(callback) {
  var instanceId = React.useId();

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      pendingCalls = _React$useState2[0],
      setPendingCalls = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      processingCall = _React$useState4[0],
      setProcessingCall = _React$useState4[1];

  React.useEffect(function () {
    var processNextCall = !processingCall && pendingCalls && pendingCalls.length;
    logCallQueue(instanceId, 'Pending calls effect', !!processNextCall, processingCall, pendingCalls);

    if (processNextCall) {
      var currentCallArgs = pendingCalls[0];
      logCallQueue(instanceId, 'Executant cridada', currentCallArgs);
      var result = callback.apply(void 0, _toConsumableArray(currentCallArgs));

      if (result instanceof Promise) {
        logCallQueue(instanceId, 'Resposta de tipus Promise');
        setProcessingCall(true);
        result.then(function (result) {
          logCallQueue(instanceId, '\tPromise success', result);

          if (result) {
            setPendingCalls(function (pendingCalls) {
              return [result].concat(_toConsumableArray(pendingCalls.slice(1)));
            });
          } else {
            setPendingCalls(function (pendingCalls) {
              return pendingCalls.slice(1);
            });
          }

          setProcessingCall(false);
        }).catch(function (error) {
          logCallQueue(instanceId, '\tPromise error', error, _typeof(error));
          setPendingCalls(function (pendingCalls) {
            return pendingCalls.slice(1);
          });
          setProcessingCall(false);

          if (error instanceof Error) {
            throw error;
          }
        });
      } else {
        logCallQueue(instanceId, 'Resposta normal', result);

        if (result) {
          setPendingCalls(function (pendingCalls) {
            return [result].concat(_toConsumableArray(pendingCalls.slice(1)));
          });
        } else {
          setPendingCalls(function (pendingCalls) {
            return pendingCalls.slice(1);
          });
        }
      }
    }
  }, [processingCall, pendingCalls]);
  React.useEffect(function () {
    logCallQueue(instanceId, 'Pending calls changed', pendingCalls);
  }, [pendingCalls]);
  var addPendingCall = React.useCallback(function () {
    for (var _len2 = arguments.length, callArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      callArgs[_key2] = arguments[_key2];
    }

    logCallQueue(instanceId, 'Add pending call', callArgs);
    setPendingCalls(function (pendingCalls) {
      return [].concat(_toConsumableArray(pendingCalls), [callArgs]);
    });
  }, [instanceId]);
  return addPendingCall;
};

var logResourceApi = function logResourceApi(instanceId, msg) {

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
};

function ApiNotInitializedError(resourceName) {
  this.resourceName = resourceName;
  this.name = 'ApiNotInitializedError(resourceName=' + resourceName + ')';
  this.message = 'API for resource "' + resourceName + '" not initialized';
}

ApiNotInitializedError.prototype = Error.prototype;

function LinkNotAvailableError(resourceName, link, id) {
  this.resourceName = resourceName;
  this.link = link;
  this.id = id;
  this.name = 'LinkNotAvailableError(resourceName=' + resourceName + ', link=' + link + (id ? ', id=' + id : '') + ')';
  this.message = 'Link ' + link + ' for resource ' + resourceName + (id ? ' and id ' + id : '') + ' not available';
}

LinkNotAvailableError.prototype = Error.prototype; // Clone of Ketting's Action.submit() function (https://github.com/badgateway/ketting/blob/version-7.x/src/action.ts#L109)
// with a new parameter to allow custom HTTP request headers.

var kettingActionSubmit = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(action, formData, headers) {
    var uri, resource, body, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            uri = new URL(action.uri);

            if (!(action.method === 'GET')) {
              _context.next = 5;
              break;
            }

            uri.search = qs.stringify(formData);
            resource = action.client.go(uri.toString());
            return _context.abrupt("return", resource.get());

          case 5:
            _context.t0 = action.contentType;
            _context.next = _context.t0 === 'application/x-www-form-urlencoded' ? 8 : _context.t0 === 'application/json' ? 10 : 12;
            break;

          case 8:
            body = qs.stringify(formData);
            return _context.abrupt("break", 13);

          case 10:
            body = JSON.stringify(formData);
            return _context.abrupt("break", 13);

          case 12:
            throw new Error("Serializing mimetype ".concat(action.contentType, " is not yet supported in actions"));

          case 13:
            _context.next = 15;
            return action.client.fetcher.fetchOrThrow(uri.toString(), {
              method: action.method,
              body: body,
              headers: _objectSpread2({
                'Content-Type': action.contentType
              }, headers)
            });

          case 15:
            response = _context.sent;
            return _context.abrupt("return", action.client.getStateForResponse(uri.toString(), response));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function kettingActionSubmit(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getStateLink = function getStateLink(state, link) {
  return state.links.get(link);
};

var getStateAction = function getStateAction(state, action) {
  var linkFromState = getStateLink(state, action);

  try {
    return state.action(action);
  } catch (error) {
    try {
      var defaultAction = state.action('default');

      if (defaultAction.title === linkFromState.title && defaultAction.uri === linkFromState.href) {
        return defaultAction;
      }
    } catch (error) {}
  }
};

var getPromiseFromLink = function getPromiseFromLink(resource, resourceName, link, id, data, headers, refresh) {
  if (link) {
    var linkFromState = getStateLink(resource, link);

    if (linkFromState) {
      var actionFromState = getStateAction(resource, link);

      if (actionFromState) {
        return kettingActionSubmit(actionFromState, data, headers);
      } else {
        return refresh ? resource.follow(link, data).refresh() : resource.follow(link, data).get();
      }
    } else {
      throw new LinkNotAvailableError(resourceName, link, id);
    }
  } else {
    return refresh ? resource.refresh() : resource.get();
  }
};

var useResourceApi = function useResourceApi(resourceName, openAnswerRequiredDialog) {
  var instanceId = React.useId();

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _useKettingContext = useKettingContext(),
      client = _useKettingContext.client;

  var _useAuthContext = useAuthContext(),
      authInitialized = _useAuthContext.initialized;

  var _useBaseAppContext = useBaseAppContext(),
      setDisconnected = _useBaseAppContext.setDisconnected,
      getPopupButton = _useBaseAppContext.getPopupButton;

  var _useAsync = useAsync(getPromiseFromLink),
      indexExec = _useAsync.execute,
      indexStatus = _useAsync.status,
      index = _useAsync.response,
      indexError = _useAsync.error;

  var _useAsync2 = useAsync(getPromiseFromLink),
      currentExec = _useAsync2.execute,
      currentStatus = _useAsync2.status,
      current = _useAsync2.response,
      currentError = _useAsync2.error;

  var _useAsync3 = useAsync(getPromiseFromLink),
      requestExec = _useAsync3.execute,
      requestStatus = _useAsync3.status,
      requestResponse = _useAsync3.response,
      requestError = _useAsync3.error;

  var apiInitialized = currentStatus === ASYNC_STATUS_SUCCESS;
  React.useEffect(function () {
    if (client && authInitialized) {
      logResourceApi(instanceId, 'Consulta index per recurs', resourceName);
      indexExec([client.go('/api'), resourceName], {
        setError: function setError() {
          setDisconnected === null || setDisconnected === void 0 ? void 0 : setDisconnected(true);
        },
        setResponse: function setResponse() {
          setDisconnected === null || setDisconnected === void 0 ? void 0 : setDisconnected(false);
        }
      });
    }
  }, [client, authInitialized, indexExec]);
  React.useEffect(function () {
    if (indexStatus === ASYNC_STATUS_SUCCESS && index) {
      logResourceApi(instanceId, 'Consulta current per recurs', resourceName);
      currentExec([index, resourceName, resourceName]);
    }
  }, [indexStatus, index, currentExec, resourceName]);
  var execCallbackWithCurrentState = React.useCallback(function (id, getOneData, execCallback, errorCallback) {
    if (id) {
      requestExec([current, resourceName, 'getOne', id, getOneData !== null && getOneData !== void 0 ? getOneData : {
        resourceId: id
      }], {
        setResponse: function setResponse(response) {
          if (response) {
            execCallback(response);
          }
        },
        setError: function setError(error) {
          errorCallback(error);
        }
      });
    } else {
      execCallback(current);
    }
  }, [current]);
  var exec = React.useCallback(function (link, _ref2, answers) {
    var id = _ref2.id,
        getOneData = _ref2.getOneData,
        data = _ref2.data,
        callbacks = _ref2.callbacks,
        headers = _ref2.headers,
        refresh = _ref2.refresh;

    if (apiInitialized && current) {
      return new Promise(function (resolve, reject) {
        return execCallbackWithCurrentState(id, getOneData, function (state) {
          logResourceApi(instanceId, 'Executant', link, 'per recurs', resourceName, id ? 'amb id ' + id : 'sense id', state);
          var action = getStateAction(state, link);
          var isUpdateAction = action && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(action.method);

          if (isUpdateAction && openAnswerRequiredDialog) {
            logResourceApi(instanceId, '\tDetectada acció de tipus update', action);
            var headersWithAnswers = answers ? _objectSpread2(_objectSpread2({}, headers !== null && headers !== void 0 ? headers : {}), {}, _defineProperty({}, 'Bb-Answers', JSON.stringify(answers))) : headers;
            requestExec([state, resourceName, link, id, data, headersWithAnswers, refresh], {
              setStatus: callbacks === null || callbacks === void 0 ? void 0 : callbacks.setStatus,
              setError: function setError(error) {
                if (error.status === 422 && error.answerRequiredError) {
                  logResourceApi(instanceId, '\tError response tipus answerRequired', error);
                  var _error$answerRequired = error.answerRequiredError,
                      answerCode = _error$answerRequired.answerCode,
                      question = _error$answerRequired.question,
                      trueFalseAnswerRequired = _error$answerRequired.trueFalseAnswerRequired,
                      availableAnswers = _error$answerRequired.availableAnswers;
                  var options;

                  if (trueFalseAnswerRequired) {
                    options = [getPopupButton('cancel', false, t('hook.resourceApi.options.cancel')), getPopupButton('done', true, t('hook.resourceApi.options.ok'), true)];
                  } else if (availableAnswers) {
                    options = availableAnswers.map(function (a) {
                      return [a.value, a.description];
                    });
                  } else {
                    options = [getPopupButton('done', true, t('hook.resourceApi.options.ok'), true)];
                  }

                  openAnswerRequiredDialog(t('hook.resourceApi.options.title'), 'warning', 'error', question, options, function (answerValue) {
                    var updatedAnswers = _objectSpread2(_objectSpread2({}, answers), {}, _defineProperty({}, answerCode, answerValue));

                    resolve([link, {
                      id: id,
                      data: data,
                      callbacks: callbacks,
                      headers: headers,
                      refresh: refresh
                    }, updatedAnswers]);
                  }, true);
                } else {
                  logResourceApi(instanceId, '\tError response normal', error);
                  reject(error);
                  callbacks === null || callbacks === void 0 ? void 0 : callbacks.setError(error);
                }
              },
              setResponse: function setResponse(response) {
                logResourceApi(instanceId, '\tSuccess response', response);
                resolve();
                callbacks === null || callbacks === void 0 ? void 0 : callbacks.setResponse(response);
              }
            });
          } else {
            logResourceApi(instanceId, '\tDetectada acció de tipus consulta', action);
            requestExec([state, resourceName, link, id, data, headers, refresh], {
              setStatus: callbacks === null || callbacks === void 0 ? void 0 : callbacks.setStatus,
              setError: function setError(error) {
                var _callbacks$setError;

                logResourceApi(instanceId, '\tError response', error);
                reject(error);
                callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setError = callbacks.setError) === null || _callbacks$setError === void 0 ? void 0 : _callbacks$setError.call(callbacks, error);
              },
              setResponse: function setResponse(response) {
                var _callbacks$setRespons;

                logResourceApi(instanceId, '\tSuccess response', response);
                resolve();
                callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setRespons = callbacks.setResponse) === null || _callbacks$setRespons === void 0 ? void 0 : _callbacks$setRespons.call(callbacks, response);
              }
            });
          }
        }, reject);
      });
    } else {
      throw new ApiNotInitializedError(resourceName);
    }
  }, [resourceName, apiInitialized, current]);
  var execWithAnswerRequiredErrorProcessing = useCallQueue(exec);

  var execHref = function execHref(href, templateData, _ref3) {
    var data = _ref3.data,
        callbacks = _ref3.callbacks,
        headers = _ref3.headers,
        refresh = _ref3.refresh;
    requestExec([client.go(parseTemplate(href).expand(templateData)), resourceName, null, null, data, headers, refresh], callbacks);
  };

  var execDownload = function execDownload(link, _ref4) {
    var id = _ref4.id,
        data = _ref4.data,
        callbacks = _ref4.callbacks;
    var saveBlob = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var processedCallbacks = {
      setStatus: callbacks === null || callbacks === void 0 ? void 0 : callbacks.setStatus,
      setError: callbacks === null || callbacks === void 0 ? void 0 : callbacks.setError,
      setResponse: function setResponse(response) {
        var _callbacks$setRespons2;

        if (saveBlob) {
          var contentDispositionHeader = response.headers.get('Content-Disposition');
          var fileNameIndex = contentDispositionHeader.indexOf('filename=');
          var fileName = fileNameIndex !== -1 ? contentDispositionHeader.substring(fileNameIndex + 'filename='.length) : undefined;
          var responseData = response.data;

          if (typeof responseData === 'string' || responseData instanceof String) {
            var _response$headers;

            var contentType = (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('Content-Type');
            fileSaver(new Blob([responseData], {
              type: contentType
            }), fileName);
          } else {
            fileSaver(response.data, fileName);
          }
        }

        callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$setRespons2 = callbacks.setResponse) === null || _callbacks$setRespons2 === void 0 ? void 0 : _callbacks$setRespons2.call(callbacks, response);
      }
    };
    execWithAnswerRequiredErrorProcessing(link, {
      id: id,
      data: data,
      callbacks: processedCallbacks
    });
  };

  var isLinkAvailable = function isLinkAvailable(link, state) {
    return !!getStateLink(state !== null && state !== void 0 ? state : current, link);
  };

  return {
    apiInitialized: apiInitialized,
    apiStatus: indexStatus !== ASYNC_STATUS_SUCCESS ? indexStatus : currentStatus,
    apiResource: current,
    apiResourceRefresh: function apiResourceRefresh() {
      return apiInitialized && currentExec([index, resourceName, resourceName, null, null, null, true]);
    },
    apiError: indexError || currentError,
    exec: execWithAnswerRequiredErrorProcessing,
    execHref: execHref,
    execDownload: execDownload,
    isLinkAvailable: isLinkAvailable,
    isActionAvailable: function isActionAvailable(action, state) {
      return isLinkAvailable('exec_' + action, state);
    },
    isReportAvailable: function isReportAvailable(report, state) {
      return isLinkAvailable('generate_' + report, state);
    },
    execStatus: requestStatus,
    execResponse: requestResponse,
    execError: requestError
  };
};

var AppMenusContext = /*#__PURE__*/React.createContext({});
var useAppMenusContext = function useAppMenusContext() {
  var context = React.useContext(AppMenusContext);

  if (context === undefined) {
    throw new Error('useAppMenuContext must be used within a AppMenuProvider');
  }

  return context;
};
var AppMenusProvider = function AppMenusProvider(props) {
  var children = props.children;

  var _useSessionContext = useSessionContext(),
      session = _useSessionContext.session;

  var _useBaseAppContext = useBaseAppContext(),
      currentLanguage = _useBaseAppContext.currentLanguage;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      appMenus = _React$useState2[0],
      setAppMenus = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      menuId = _React$useState4[0],
      setMenuId = _React$useState4[1];

  var _useResourceApi = useResourceApi('appmenu'),
      apiResource = _useResourceApi.apiResource,
      apiResourceRefresh = _useResourceApi.apiResourceRefresh;

  var hasMenu = function hasMenu(menu) {
    var found = appMenus === null || appMenus === void 0 ? void 0 : appMenus.find(function (m) {
      return m.id === menu;
    });
    return !!found;
  };

  React.useEffect(function () {
    if (apiResource) {
      var _apiResource$getEmbed;

      var _appMenus = (_apiResource$getEmbed = apiResource.getEmbedded()) === null || _apiResource$getEmbed === void 0 ? void 0 : _apiResource$getEmbed.map(function (e) {
        return e.data;
      });

      setAppMenus(_appMenus);
    }
  }, [apiResource]);
  React.useEffect(function () {
    if (currentLanguage) {
      apiResourceRefresh();
    }
  }, [session, currentLanguage]);
  var contextValue = {
    menus: appMenus,
    hasMenu: hasMenu,
    menuId: menuId,
    setMenuId: setMenuId
  };
  return /*#__PURE__*/React.createElement(AppMenusContext.Provider, {
    value: contextValue
  }, children);
};

var _excluded$5 = ["to", "icon", "primary", "selected", "level"],
    _excluded2$2 = ["icon", "primary", "selected", "level", "hasChildren", "expanded"],
    _excluded3 = ["header", "entries", "menuItemAsHome", "level", "onMenuItemClick", "setMenuId"];
var drawerWidth = 240;

var getMenuEntryPath = function getMenuEntryPath(menuEntry) {
  return menuEntry.resource ? '/' + menuEntry.resource : null;
};

var isMenuEntrySelected = function isMenuEntrySelected(routerLocation, menuEntry) {
  var entryPath = getMenuEntryPath(menuEntry);
  var menuEntrySelected = routerLocation.pathname.startsWith(entryPath);

  if (!menuEntrySelected && menuEntry.children) {
    return menuEntry.children.find(function (e) {
      return isMenuEntrySelected(routerLocation, e);
    });
  } else {
    return menuEntrySelected;
  }
};

var menuFindChildWithResource = function menuFindChildWithResource(menu, resource) {
  if (menu.children) {
    var found = menu.children.find(function (c) {
      if (c.resource === resource) {
        return true;
      } else {
        return menuFindChildWithResource(c, resource);
      }
    });
    return found ? menu : null;
  }
};

var getCurrentMenu = function getCurrentMenu(menus, menuId, pathname) {
  if (menus) {
    if (menuId) {
      return menus.find(function (m) {
        return m.id === menuId;
      });
    } else {
      var resource = pathname.split('/')[1];
      var found = menus.find(function (m) {
        return menuFindChildWithResource(m, resource);
      });
      return found ? found : menus.find(function (m) {
        return m.id === 'user';
      });
    }
  }
};

var ListItemLink = function ListItemLink(props) {
  var to = props.to,
      icon = props.icon,
      primary = props.primary,
      selected = props.selected;
      props.level;
      var otherProps = _objectWithoutProperties(props, _excluded$5);

  var renderLink = React.useMemo(function () {
    return /*#__PURE__*/React.forwardRef(function (itemProps, ref) {
      return /*#__PURE__*/React.createElement(Link, _extends({
        to: to,
        ref: ref
      }, itemProps, {
        role: undefined
      }));
    });
  }, [to]);
  return /*#__PURE__*/React.createElement(ListItem$1, _extends({
    button: !!to,
    selected: selected,
    component: to && renderLink
  }, otherProps), icon ? /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, icon)) : null, /*#__PURE__*/React.createElement(ListItemText, {
    primary: primary
  }));
};

var ListItemEntry = function ListItemEntry(props) {
  var icon = props.icon,
      primary = props.primary,
      selected = props.selected;
      props.level;
      var hasChildren = props.hasChildren,
      expanded = props.expanded,
      otherProps = _objectWithoutProperties(props, _excluded2$2);

  return /*#__PURE__*/React.createElement(ListItem$1, _extends({
    button: true,
    selected: selected
  }, otherProps), icon ? /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, icon)) : null, /*#__PURE__*/React.createElement(ListItemText, {
    primary: primary
  }), hasChildren && /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, expanded ? 'expand_more' : 'chevron_right'));
};

var MenuEntry = function MenuEntry(props) {
  var _entry$children;

  var entry = props.entry,
      level = props.level,
      onMenuItemClick = props.onMenuItemClick;
  var routerLocation = useLocation();
  var selected = isMenuEntrySelected(routerLocation, entry);

  var _React$useState = React.useState(selected),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleItemClick = function handleItemClick() {
    if (hasChildren) {
      setExpanded(function (expanded) {
        return !expanded;
      });
    } else {
      onMenuItemClick === null || onMenuItemClick === void 0 ? void 0 : onMenuItemClick();
    }
  };

  var entryPath = getMenuEntryPath(entry);
  var hasChildren = (_entry$children = entry.children) === null || _entry$children === void 0 ? void 0 : _entry$children.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, entryPath ? /*#__PURE__*/React.createElement(ListItemLink, {
    to: entryPath,
    icon: entry.icon,
    primary: entry.title,
    selected: !!selected,
    level: level,
    onClick: handleItemClick,
    sx: {
      pl: 2 + level * 3
    }
  }) : /*#__PURE__*/React.createElement(ListItemEntry, {
    icon: entry.icon,
    primary: entry.title,
    selected: !!selected,
    level: level,
    hasChildren: hasChildren,
    expanded: expanded,
    onClick: handleItemClick,
    sx: {
      pl: 2 + level * 3
    }
  }), hasChildren && expanded && /*#__PURE__*/React.createElement(MenuEntries, {
    level: level + 1,
    entries: entry.children,
    onMenuItemClick: onMenuItemClick,
    sx: {
      mt: -1,
      mb: -1
    }
  }));
};

var MenuEntries = function MenuEntries(props) {
  var header = props.header,
      entries = props.entries,
      menuItemAsHome = props.menuItemAsHome,
      level = props.level,
      onMenuItemClick = props.onMenuItemClick,
      setMenuId = props.setMenuId,
      otherProps = _objectWithoutProperties(props, _excluded3);

  var routerLocation = useLocation();

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var keyPrefix = level === 0 ? '' : '' + level + '_';
  var homeMenuEntry = menuItemAsHome ? entries === null || entries === void 0 ? void 0 : entries.find(function (e) {
    return e.page === menuItemAsHome;
  }) : undefined;
  var hideHome = !!header || menuItemAsHome && !homeMenuEntry;
  return /*#__PURE__*/React.createElement(List$1, _extends({
    sx: {
      pt: 0,
      pb: 0
    }
  }, otherProps), level === 0 && header ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$1, {
    disablePadding: true,
    secondaryAction: /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      edge: "end",
      "aria-label": "comments",
      onClick: function onClick() {
        return setMenuId('user');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      fontSize: "inherit"
    }, "clear"))
  }, /*#__PURE__*/React.createElement(ListItemButton, {
    disableRipple: true,
    sx: {
      pointerEvents: 'none',
      cursor: 'default'
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: header,
    primaryTypographyProps: {
      fontSize: 20,
      fontWeight: 'medium',
      letterSpacing: 0
    }
  }))), /*#__PURE__*/React.createElement(Divider, null)) : null, level === 0 && !hideHome && /*#__PURE__*/React.createElement(ListItemLink, {
    key: keyPrefix + 0,
    to: "/",
    icon: homeMenuEntry ? homeMenuEntry.icon ? homeMenuEntry.icon : undefined : 'home',
    primary: homeMenuEntry ? homeMenuEntry.title : t('baseapp.menu.home'),
    selected: routerLocation.pathname === '/',
    onClick: onMenuItemClick
  }), entries === null || entries === void 0 ? void 0 : entries.filter(function (e) {
    return !menuItemAsHome || menuItemAsHome !== e.page;
  }).map(function (entry, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: keyPrefix + (index + 1)
    }, /*#__PURE__*/React.createElement(MenuEntry, {
      entry: entry,
      level: level,
      onMenuItemClick: onMenuItemClick
    }));
  }));
};

var Menu = function Menu(props) {
  var open = props.open,
      handleClose = props.handleClose,
      menuItemAsHome = props.menuItemAsHome;
  var routerLocation = useLocation();

  var _useAppMenusContext = useAppMenusContext(),
      menus = _useAppMenusContext.menus,
      menuId = _useAppMenusContext.menuId,
      setMenuId = _useAppMenusContext.setMenuId;

  var currentMenu = getCurrentMenu(menus, menuId, routerLocation.pathname);
  var drawerContent = /*#__PURE__*/React.createElement(MenuEntries, {
    level: 0,
    header: currentMenu && (currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.id) !== 'user' ? currentMenu.title : undefined,
    entries: currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.children,
    onMenuItemClick: function onMenuItemClick() {
      return handleClose && handleClose();
    },
    setMenuId: setMenuId,
    menuItemAsHome: menuItemAsHome
  });
  return /*#__PURE__*/React.createElement(Box, {
    component: "nav"
  }, /*#__PURE__*/React.createElement(Drawer, {
    variant: "permanent",
    open: open,
    onClose: handleClose,
    sx: {
      flexShrink: 0,
      width: drawerWidth,
      display: {
        sm: 'none',
        xs: 'none',
        md: 'block'
      },
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: drawerWidth
      }
    }
  }, /*#__PURE__*/React.createElement(Toolbar, null), /*#__PURE__*/React.createElement(Box, {
    sx: {
      overflow: 'auto'
    }
  }, drawerContent)), /*#__PURE__*/React.createElement(Drawer, {
    variant: "temporary",
    open: open,
    onClose: handleClose,
    ModalProps: {
      keepMounted: true
    },
    sx: {
      display: {
        sm: 'block',
        md: 'none'
      },
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: drawerWidth
      }
    }
  }, /*#__PURE__*/React.createElement(Toolbar, null), /*#__PURE__*/React.createElement(Box, {
    sx: {
      overflow: 'auto'
    }
  }, drawerContent)));
};

var ServiceUnavailable = function ServiceUnavailable() {
  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1"
  }, "503"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('baseapp.error.503')));
};

var BaseApp = function BaseApp(props) {
  var name = props.name,
      icon = props.icon,
      image = props.image,
      headerStyle = props.headerStyle,
      additionalHeaderComponent = props.additionalHeaderComponent,
      noAuthComponent = props.noAuthComponent,
      menuItemAsHome = props.menuItemAsHome,
      sessionRequired = props.sessionRequired,
      authActive = props.authActive;

  var _useAuthContext = useAuthContext(),
      loggedIn = _useAuthContext.loggedIn;

  var _useSessionContext = useSessionContext(),
      session = _useSessionContext.session;

  var _useBaseAppContext = useBaseAppContext(),
      temporalMessageComponent = _useBaseAppContext.temporalMessageComponent,
      disconnected = _useBaseAppContext.disconnected;

  var _useAuthContext2 = useAuthContext(),
      initialized = _useAuthContext2.initialized;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuOpen = _React$useState2[0],
      setMenuOpen = _React$useState2[1];

  var content = noAuthComponent ? loggedIn ? props.children : noAuthComponent : props.children;
  var showContentSessionCheck = sessionRequired ? !!session : true;
  var showContentAuthCheck = authActive ? !!initialized : true;
  return showContentAuthCheck ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(Header, {
    title: name,
    icon: icon,
    image: image,
    style: headerStyle,
    disconnected: disconnected,
    handleMenuClose: function handleMenuClose() {
      return setMenuOpen(false);
    },
    handleMenuSwitch: function handleMenuSwitch() {
      return setMenuOpen(!menuOpen);
    },
    additionalHeaderComponent: additionalHeaderComponent
  }), !disconnected && /*#__PURE__*/React.createElement(Menu, {
    open: menuOpen,
    handleClose: function handleClose() {
      return setMenuOpen(false);
    },
    menuItemAsHome: menuItemAsHome
  }), /*#__PURE__*/React.createElement(Box, {
    component: "main",
    sx: {
      pr: 3,
      pl: 3,
      pb: 1,
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Toolbar, null), disconnected && /*#__PURE__*/React.createElement(ServiceUnavailable, null), showContentSessionCheck && content, temporalMessageComponent)) : null;
};

BaseApp.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string,
  image: PropTypes.string,
  headerStyle: PropTypes.object,
  additionalHeaderComponent: PropTypes.element,
  noAuthComponent: PropTypes.element,
  menuItemAsHome: PropTypes.string,
  sessionRequired: PropTypes.bool,
  authActive: PropTypes.bool
};

var NotFound = function NotFound() {
  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1"
  }, "404"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('baseapp.error.404')));
};

var OptionsDialog = function OptionsDialog(props) {
  var open = props.open,
      size = props.size,
      loading = props.loading,
      title = props.title,
      titleIcon = props.titleIcon,
      titleIconColor = props.titleIconColor,
      additionalTitleButtons = props.additionalTitleButtons,
      showClose = props.showClose,
      message = props.message,
      options = props.options,
      onOptionClick = props.onOptionClick,
      onClose = props.onClose,
      children = props.children;
  var option0IsArray = options && options.length && Array.isArray(options[0]);
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: size !== null && size !== void 0 ? size : 'md',
    open: open,
    onClose: onClose,
    sx: {
      filter: loading ? "brightness(70%)" : undefined
    }
  }, title && /*#__PURE__*/React.createElement(DialogTitle, {
    sx: {
      display: 'flex'
    }
  }, titleIcon && /*#__PURE__*/React.createElement(IconButton, {
    color: titleIconColor,
    disableRipple: true,
    sx: {
      cursor: 'default',
      top: '-4px'
    }
  }, /*#__PURE__*/React.createElement(Icon, null, titleIcon)), title, /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexGrow: 1
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      top: -4,
      right: -4
    }
  }, additionalTitleButtons, showClose && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, null, "close"))))), /*#__PURE__*/React.createElement(DialogContent, null, message && /*#__PURE__*/React.createElement(DialogContentText, null, message), children, loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 50,
    sx: {
      position: 'absolute',
      top: "calc(50% - 25px)",
      left: "calc(50% - 25px)"
    }
  })), options && options.length && option0IsArray && /*#__PURE__*/React.createElement(DialogActions, null, options === null || options === void 0 ? void 0 : options.map(function (o) {
    return /*#__PURE__*/React.createElement(Button, {
      key: 'action_' + o[0],
      variant: o[2] ? 'contained' : 'text',
      disabled: o[3],
      onClick: function onClick() {
        return onOptionClick(o[0]);
      }
    }, o[1]);
  })), options && options.length && !option0IsArray && /*#__PURE__*/React.createElement(DialogActions, null, options === null || options === void 0 ? void 0 : options.map(function (o) {
    return /*#__PURE__*/React.createElement(Button, {
      key: 'action_' + o.value,
      variant: o.contained ? 'contained' : 'outlined',
      disabled: o.disabled,
      startIcon: o.startIcon ? /*#__PURE__*/React.createElement(Icon, null, o.startIcon) : undefined,
      endIcon: o.endIcon ? /*#__PURE__*/React.createElement(Icon, null, o.endIcon) : undefined,
      onClick: function onClick() {
        return onOptionClick(o.value);
      }
    }, o.description);
  })));
};

var useMessageDialog = function useMessageDialog(size) {
  var showClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      title = _React$useState2[0],
      setTitle = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      titleIcon = _React$useState4[0],
      setTitleIcon = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      titleIconColor = _React$useState6[0],
      setTitleIconColor = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      message = _React$useState8[0],
      setMessage = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      options = _React$useState10[0],
      setOptions = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      callback = _React$useState12[0],
      setCallback = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      open = _React$useState14[0],
      setOpen = _React$useState14[1];

  var _React$useState15 = React.useState(),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      disableClose = _React$useState16[0],
      setDisableClose = _React$useState16[1];

  var openDialog = function openDialog(title, titleIcon, titleIconColor, message, options, callback, disableClose) {
    setTitle(title);
    setTitleIcon(titleIcon);
    setTitleIconColor(titleIconColor);
    setMessage(message);
    setOptions(options);
    setCallback(function () {
      return callback;
    });
    setOpen(true);
    setDisableClose(disableClose);
  };

  var handleOptionClick = React.useCallback(function (value) {
    setOpen(false);
    callback && callback(value);
  }, [callback]);

  var handleClose = function handleClose() {
    if (!disableClose) {
      handleOptionClick();
    }
  };

  var dialog = /*#__PURE__*/React.createElement(OptionsDialog, {
    open: open,
    size: size,
    title: title,
    titleIcon: titleIcon,
    titleIconColor: titleIconColor,
    showClose: showClose,
    message: message,
    options: options,
    onOptionClick: handleOptionClick,
    onClose: handleClose
  });
  return {
    dialog: dialog,
    openDialog: openDialog
  };
};

var dateFormatInput = function dateFormatInput(date) {
  return new Date(date).toISOString();
};
var dateFormatLocale = function dateFormatLocale(date) {
  return new Date(date).toLocaleDateString();
};

var countDecimalPositions = function countDecimalPositions(number) {
  if (number !== undefined && number !== null && number % 1 != 0) {
    if (Math.floor(number.valueOf()) === number.valueOf()) return 0;
    var str = number.toString();

    if (str.startsWith('1e-')) {
      return str.split('-')[1] || 0;
    } else {
      return str.split('.')[1].length || 0;
    }
  } else {
    return 0;
  }
};
var numberFormat = function numberFormat(number, formatOptions, locale) {
  return new Intl.NumberFormat(locale, formatOptions).format(number);
};
var numberFormatEur = function numberFormatEur(number, formatOptions, locale) {
  var eurFormatOptions = _objectSpread2({
    style: 'currency',
    currency: 'EUR'
  }, formatOptions !== null && formatOptions !== void 0 ? formatOptions : {});

  return numberFormat(number, eurFormatOptions, locale);
};
var numberFormatCurrency = function numberFormatCurrency(number, currency, decimalPlaces, locale) {
  var formatOptions = _objectSpread2({
    style: currency ? 'currency' : undefined,
    currency: currency
  }, decimalPlaces ? {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  } : {});

  return numberFormat(number, formatOptions, locale);
};
var numberFormatField = function numberFormatField(number, field, locale) {
  if (field) {
    var numDecimals = field.step ? countDecimalPositions(field.step) : undefined;
    var formatOptions = numDecimals ? {
      minimumFractionDigits: numDecimals,
      maximumFractionDigits: numDecimals
    } : undefined;
    return numberFormat(number, formatOptions, locale);
  } else {
    return numberFormat(number, locale);
  }
};
var getDecimalSeparator = function getDecimalSeparator(locale) {
  return Intl.NumberFormat(locale === 'es' ? 'ca' : locale).formatToParts(1.1).find(function (p) {
    return p.type === 'decimal';
  }).value;
};
var getThousandSeparator = function getThousandSeparator(locale) {
  return Intl.NumberFormat(locale === 'es' ? 'ca' : locale).formatToParts(10000.1).find(function (p) {
    return p.type === 'group';
  }).value;
};
var tryParseDecimal = function tryParseDecimal(value) {
  try {
    return new Decimal(value);
  } catch (_unused) {
    return undefined;
  }
};

var DownloadButton = function DownloadButton(props) {
  var handleExport = props.handleExport;

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: t('grid.toolbar.download')
  }, /*#__PURE__*/React.createElement(IconButton, {
    id: "basic-button",
    "aria-controls": open ? 'basic-menu' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Icon, null, "file_download"))), /*#__PURE__*/React.createElement(Menu$2, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, /*#__PURE__*/React.createElement(MenuItem$1, {
    onClick: function onClick() {
      handleExport('CSV');
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemIcon$1, null, /*#__PURE__*/React.createElement(Icon, null, "sim_card_download")), /*#__PURE__*/React.createElement(ListItemText$1, null, "CSV")), /*#__PURE__*/React.createElement(MenuItem$1, {
    onClick: function onClick() {
      handleExport('ODS');
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemIcon$1, null, /*#__PURE__*/React.createElement(Icon, null, "sim_card_download")), /*#__PURE__*/React.createElement(ListItemText$1, null, "ODS")), /*#__PURE__*/React.createElement(MenuItem$1, {
    onClick: function onClick() {
      handleExport('XLSX');
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemIcon$1, null, /*#__PURE__*/React.createElement(Icon, null, "sim_card_download")), /*#__PURE__*/React.createElement(ListItemText$1, null, "XLSX")), /*#__PURE__*/React.createElement(MenuItem$1, {
    onClick: function onClick() {
      handleExport('PDF');
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemIcon$1, null, /*#__PURE__*/React.createElement(Icon, null, "sim_card_download")), /*#__PURE__*/React.createElement(ListItemText$1, null, "PDF"))));
};

var GridHeaderToolbar = function GridHeaderToolbar(props) {
  var title = props.title,
      readOnly = props.readOnly,
      handleRefresh = props.handleRefresh,
      handleExport = props.handleExport,
      handleCreate = props.handleCreate,
      createDisabled = props.createDisabled,
      createHidden = props.createHidden,
      handleQuickFilterChange = props.handleQuickFilterChange,
      quickFilter = props.quickFilter,
      extraActions = props.extraActions;

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      quickFilterValue = _React$useState4[0],
      setQuickFilterValue = _React$useState4[1];

  var quickFilterShown = quickFilter === undefined ? true : quickFilter;

  var _useTranslation2 = useTranslation('components'),
      t = _useTranslation2.t;

  return /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true,
    sx: {
      display: 'flex',
      ml: -3,
      mr: -3,
      mb: 2,
      pl: 3,
      pr: 3,
      backgroundColor: '#efefef'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      flexGrow: 1
    }
  }, title), handleExport && /*#__PURE__*/React.createElement(DownloadButton, {
    handleExport: handleExport
  }), handleRefresh ? /*#__PURE__*/React.createElement(Tooltip, {
    title: t('grid.toolbar.refresh')
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleRefresh
  }, /*#__PURE__*/React.createElement(Icon, null, "refresh"))) : null, handleCreate && !readOnly && !createHidden ? /*#__PURE__*/React.createElement(Tooltip, {
    title: t('grid.toolbar.create')
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleCreate,
    disabled: createDisabled
  }, /*#__PURE__*/React.createElement(Icon, null, "add"))) : null, extraActions, quickFilterShown && /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    value: quickFilterValue,
    onChange: function onChange(event) {
      var value = event.target.value;
      setQuickFilterValue(value);
      handleQuickFilterChange && handleQuickFilterChange(value);
    },
    sx: {
      ml: 1
    },
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(Icon, null, "search"))
    }
  }));
};
var GridFormToolbar = function GridFormToolbar(props) {
  var title = props.title,
      readOnly = props.readOnly,
      handleRefresh = props.handleRefresh,
      handleExport = props.handleExport,
      handleCreate = props.handleCreate,
      createDisabled = props.createDisabled,
      createHidden = props.createHidden,
      handleQuickFilterChange = props.handleQuickFilterChange,
      quickFilter = props.quickFilter,
      extraActions = props.extraActions,
      lovMode = props.lovMode;

  var _React$useState5 = React.useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      quickFilterValue = _React$useState6[0],
      setQuickFilterValue = _React$useState6[1];

  var quickFilterShown = quickFilter === undefined ? true : quickFilter;

  var _useTranslation3 = useTranslation('components'),
      t = _useTranslation3.t;

  return /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true,
    sx: {
      display: 'flex',
      ml: !!lovMode ? -4 : 0,
      mr: !!lovMode ? -3 : 0
    }
  }, !lovMode ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      flexGrow: 1,
      ml: 2
    }
  }, title), handleExport && /*#__PURE__*/React.createElement(DownloadButton, {
    handleExport: handleExport
  }), handleRefresh ? /*#__PURE__*/React.createElement(Tooltip, {
    title: t('grid.toolbar.refresh')
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleRefresh
  }, /*#__PURE__*/React.createElement(Icon, null, "refresh"))) : null, handleCreate && !readOnly && !createHidden ? /*#__PURE__*/React.createElement(Tooltip, {
    title: t('grid.toolbar.create')
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleCreate,
    disabled: createDisabled
  }, /*#__PURE__*/React.createElement(Icon, null, "add"))) : null, extraActions) : null, quickFilterShown && /*#__PURE__*/React.createElement(TextField, {
    fullWidth: !!lovMode,
    size: "small",
    value: quickFilterValue,
    onChange: function onChange(event) {
      var value = event.target.value;
      setQuickFilterValue(value);
      handleQuickFilterChange && handleQuickFilterChange(value);
    },
    sx: {
      ml: 1
    },
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(Icon, null, "search"))
    }
  }));
};

var GridNoRowsOverlay = function GridNoRowsOverlay() {
  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    color: "disabled"
  }, "block"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "text.secondary"
  }, t('grid.empty'))));
};

var GridErrorOverlay = function GridErrorOverlay(error) {
  var _useTranslation = useTranslation('components');
      _useTranslation.t;

  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    color: "error"
  }, "errorOutline"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "text.secondary"
  }, error.message)));
};

var caESGrid = {
  // Root
  noRowsLabel: 'Sense files',
  noResultsOverlayLabel: "No s'han trobat resultats.",
  errorOverlayDefaultLabel: 'Ha ocorregut un error.',
  // Density selector toolbar button text
  toolbarDensity: 'Densitat',
  toolbarDensityLabel: 'Densitat',
  toolbarDensityCompact: 'Compacta',
  toolbarDensityStandard: 'Standard',
  toolbarDensityComfortable: 'Comoda',
  // Columns selector toolbar button text
  toolbarColumns: 'Columnes',
  toolbarColumnsLabel: 'Seleccionar columnes',
  // Filters toolbar button text
  toolbarFilters: 'Filtres',
  toolbarFiltersLabel: 'Mostrar filtres',
  toolbarFiltersTooltipHide: 'Ocultar filtres',
  toolbarFiltersTooltipShow: 'Mostrar filtres',
  toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(count) {
    return count > 1 ? "".concat(count, " filtres actius") : "".concat(count, " filtre actiu");
  },
  // Quick filter toolbar field
  // toolbarQuickFilterPlaceholder: 'Search…',
  // toolbarQuickFilterLabel: 'Search',
  // toolbarQuickFilterDeleteIconLabel: 'Clear',
  // Export selector toolbar button text
  toolbarExport: 'Exportar',
  toolbarExportLabel: 'Exportar',
  toolbarExportCSV: 'Descarregar com CSV',
  // toolbarExportPrint: 'Print',
  toolbarExportExcel: 'Descarregar com Excel',
  // Columns panel text
  columnsPanelTextFieldLabel: 'Columna de cerca',
  columnsPanelTextFieldPlaceholder: 'Títol de columna',
  columnsPanelDragIconLabel: 'Reordenar columna',
  columnsPanelShowAllButton: 'Mostrar tot',
  columnsPanelHideAllButton: 'Ocultar tot',
  // Filter panel text
  filterPanelAddFilter: 'Agregar filtre',
  filterPanelDeleteIconLabel: 'Esborrar',
  // filterPanelLinkOperator: 'Logic operator',
  filterPanelOperators: 'Operadors',
  // TODO v6: rename to filterPanelOperator
  filterPanelOperatorAnd: 'Y',
  filterPanelOperatorOr: 'O',
  filterPanelColumns: 'Columnes',
  filterPanelInputLabel: 'Valor',
  filterPanelInputPlaceholder: 'Valor de filtre',
  // Filter operators text
  filterOperatorContains: 'conté',
  filterOperatorEquals: 'és igual',
  filterOperatorStartsWith: 'comença amb',
  filterOperatorEndsWith: 'acaba amb',
  filterOperatorIs: 'és',
  filterOperatorNot: 'no és',
  filterOperatorAfter: 'és posterior',
  filterOperatorOnOrAfter: 'és en o posterior',
  filterOperatorBefore: 'és anterior',
  filterOperatorOnOrBefore: 'és en o anterior',
  filterOperatorIsEmpty: 'està buit',
  filterOperatorIsNotEmpty: 'no estè buit',
  // filterOperatorIsAnyOf: 'is any of',
  // Filter values text
  // filterValueAny: 'any',
  // filterValueTrue: 'true',
  // filterValueFalse: 'false',
  // Column menu text
  columnMenuLabel: 'Menú',
  columnMenuShowColumns: 'Mostrar columnes',
  columnMenuFilter: 'Filtre',
  columnMenuHideColumn: 'Ocultar',
  columnMenuUnsort: 'Desordenar',
  columnMenuSortAsc: 'Ordenar ASC',
  columnMenuSortDesc: 'Ordenar DESC',
  // Column header text
  columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(count) {
    return count > 1 ? "".concat(count, " filtres actius") : "".concat(count, " filtre actiu");
  },
  columnHeaderFiltersLabel: 'Mostrar filtres',
  columnHeaderSortIconLabel: 'Ordenar',
  // Rows selected footer text
  footerRowSelected: function footerRowSelected(count) {
    return count > 1 ? "".concat(count.toLocaleString(), " files seleccionades") : "".concat(count.toLocaleString(), " fila seleccionada");
  },
  // Total row amount footer text
  footerTotalRows: 'Files Totals:',
  // Total visible row amount footer text
  footerTotalVisibleRows: function footerTotalVisibleRows(visibleCount, totalCount) {
    return "".concat(visibleCount.toLocaleString(), " de ").concat(totalCount.toLocaleString());
  },
  // Checkbox selection text
  // checkboxSelectionHeaderName: 'Checkbox selection',
  // checkboxSelectionSelectAllRows: 'Select all rows',
  // checkboxSelectionUnselectAllRows: 'Unselect all rows',
  // checkboxSelectionSelectRow: 'Select row',
  // checkboxSelectionUnselectRow: 'Unselect row',
  // Boolean cell text
  // booleanCellTrueLabel: 'yes',
  // booleanCellFalseLabel: 'no',
  // Actions cell more text
  actionsCellMore: 'més',
  // Column pinning text
  pinToLeft: "Pin a l'esquerra",
  pinToRight: "Pin a l'dreta" // unpin: 'Unpin',
  // Tree Data
  // treeDataGroupingHeaderName: 'Group',
  // treeDataExpand: 'see children',
  // treeDataCollapse: 'hide children',
  // Grouping columns
  // groupingColumnHeaderName: 'Group',
  // groupColumn: name => `Group by ${name}`,
  // unGroupColumn: name => `Stop grouping by ${name}`,
  // Master/detail
  // detailPanelToggle: 'Detail panel toggle',
  // expandDetailPanel: 'Expand',
  // collapseDetailPanel: 'Collapse',
  // Row reordering text
  // rowReorderingHeaderName: 'Row reordering',
  // Aggregation
  // aggregationMenuItemHeader: 'Aggregation',
  // aggregationFunctionLabelSum: 'sum',
  // aggregationFunctionLabelAvg: 'avg',
  // aggregationFunctionLabelMin: 'min',
  // aggregationFunctionLabelMax: 'max',
  // aggregationFunctionLabelSize: 'size',

};
var caES = getGridLocalization(caESGrid, caES$1);

var _excluded$4 = ["name", "editable", "align", "renderCell", "valueFormatter"],
    _excluded2$1 = ["columns", "resourceName", "resourceFieldName", "title", "rows", "fixedQuery", "sortable", "fixedSortModel", "defaultSortModel", "selectable", "onSelectionChange", "paginable", "quickFilter", "perspectives", "height", "autoHeight", "density", "striped", "lovMode", "findQueryHref", "apiRef", "inlineEditable", "inlineFormApiRef", "inlineRenderEditCell", "inlineOnEditIdChange", "formPopupEditable", "formPopupTitleCreate", "formPopupTitleUpdate", "formPopupSize", "formPopupStaticData", "formPopupOpenFormDialog", "formRoutePath", "actionExecEnabled", "actionExecOpenActionDialog", "actionExecPopupSize", "onRowClick", "onRefresh", "onCreate", "onUpdate", "onDelete", "onExec", "toolbar", "toolbarType", "toolbarExtraActions", "toolbarHideExportAction", "toolbarHideCreateAction", "toolbarHideRefreshAction", "rowActionsColumnProps", "rowAdditionalActions", "rowHideEditAction", "rowHideDeleteAction", "rowReordering", "rowReorderingField", "rowReorderingOnOrderChange", "treeData", "treeDataStructureHandleRefresh", "treeDataStructureIcon", "treeDataPathAttribute", "treeDataProcessPath", "treeDataGroupRowDataFromPath", "treeDataGroupColumnProps", "treeDataRowReordering", "treeDataRowReorderingField", "treeDataRowReorderingSameParentOnly", "treeDataRowReorderingGetDragType", "treeDataRowReorderingGetDropType", "treeDataRowReorderingOnStructureOrderChange", "sx"];
var ROW_CREATE_ID = '#';
var TREE_PATH_ID_SEPARATOR = '#@#';
var TOOLBAR_TYPE_HEADER = 'header';
var TOOLBAR_TYPE_FORM = 'form';

var GridTreeDataGroupingCell = function GridTreeDataGroupingCell(props) {
  var _filteredDescendantCo;

  var id = props.id,
      field = props.field,
      rowNode = props.rowNode,
      row = props.row,
      value = props.value,
      treeDataRowReordering = props.treeDataRowReordering,
      treeDataPathAttribute = props.treeDataPathAttribute,
      treeDataStructureIcon = props.treeDataStructureIcon,
      treeDataRowReorderingField = props.treeDataRowReorderingField,
      treeDataRowReorderingSameParentOnly = props.treeDataRowReorderingSameParentOnly,
      treeDataRowReorderingGetDragType = props.treeDataRowReorderingGetDragType,
      treeDataRowReorderingGetDropType = props.treeDataRowReorderingGetDropType,
      handleReordering = props.handleReordering,
      treeDataRowReorderingOnStructureOrderChange = props.treeDataRowReorderingOnStructureOrderChange;
  var apiRef = useGridApiContext();
  var filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);
  var filteredDescendantCount = (_filteredDescendantCo = filteredDescendantCountLookup[rowNode.id]) !== null && _filteredDescendantCo !== void 0 ? _filteredDescendantCo : 0;
  var isStructure = !!row['_structure'];

  var getDragDropType = function getDragDropType(dragOrDrop) {
    if (treeDataRowReorderingSameParentOnly) {
      var _rowNode$parent;

      return (_rowNode$parent = rowNode.parent) !== null && _rowNode$parent !== void 0 ? _rowNode$parent : 'ROOT';
    } else {
      var _type;

      var type;

      switch (dragOrDrop) {
        case 'drag':
          type = treeDataRowReorderingGetDragType && typeof treeDataRowReorderingGetDragType === 'function' ? treeDataRowReorderingGetDragType(row[treeDataPathAttribute], row) : treeDataRowReorderingGetDragType;

        case 'drop':
        default:
          type = treeDataRowReorderingGetDropType && typeof treeDataRowReorderingGetDropType === 'function' ? treeDataRowReorderingGetDropType(row[treeDataPathAttribute], row) : treeDataRowReorderingGetDropType;
      }

      return (_type = type) !== null && _type !== void 0 ? _type : 'ROOT';
    }
  };

  var _useDrag = useDrag(function () {
    return {
      type: getDragDropType('drag'),
      item: row,
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      }
    };
  }, [row]),
      _useDrag2 = _slicedToArray(_useDrag, 3);

  _objectDestructuringEmpty(_useDrag2[0]);

  var drag = _useDrag2[1],
      dragPreview = _useDrag2[2];

  var _useDrop = useDrop(function () {
    return {
      accept: getDragDropType('drop'),
      drop: function drop(item) {
        if (item.id !== row.id) {
          var newIndex = row[treeDataRowReorderingField];

          if (isStructure) {
            treeDataRowReorderingOnStructureOrderChange(item, _defineProperty({}, treeDataRowReorderingField, newIndex));
          } else {
            handleReordering(item.id, treeDataRowReorderingField, newIndex);
          }
        }
      }
    };
  }, [row]),
      _useDrop2 = _slicedToArray(_useDrop, 2);

  _objectDestructuringEmpty(_useDrop2[0]);

  var drop = _useDrop2[1];

  var handleClick = function handleClick(event) {
    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  var setDragDropRef = function setDragDropRef(element) {
    if (element) {
      drag(element);
      dragPreview(element === null || element === void 0 ? void 0 : element.parentNode.parentNode);
      drop(element === null || element === void 0 ? void 0 : element.parentNode.parentNode);
    }
  };

  var structureIcon = isStructure ? treeDataStructureIcon && typeof treeDataStructureIcon === 'function' ? treeDataStructureIcon(row) : treeDataStructureIcon : undefined;
  var processedValue = value && value.includes(TREE_PATH_ID_SEPARATOR) ? value.split(TREE_PATH_ID_SEPARATOR)[0] : value;
  var content = /*#__PURE__*/React.createElement(Box, {
    sx: {
      ml: rowNode.depth * 2
    }
  }, isStructure ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClick,
    disabled: filteredDescendantCount === 0,
    size: "small",
    sx: structureIcon ? {} : {
      mr: 1
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, rowNode.childrenExpanded ? 'expand_more' : 'chevron_right')), structureIcon ? /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    disableRipple: true,
    sx: {
      cursor: 'default',
      mr: 1
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, structureIcon)) : null, processedValue) : null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, treeDataRowReordering && /*#__PURE__*/React.createElement(IconButton, {
    ref: setDragDropRef,
    size: "small",
    disableRipple: true,
    sx: {
      cursor: 'move'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small"
  }, "drag_indicator")), content);
};

var GridPagination = function GridPagination(props) {
  var pageInfo = props.pageInfo;
  var apiRef = useGridApiContext();
  var page = useGridSelector(apiRef, gridPageSelector);
  var pageCount = useGridSelector(apiRef, gridPageCountSelector);
  var pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  var firstElementIndex = page * pageSize + 1;
  var rowRange = useGridSelector(apiRef, gridPaginationRowRangeSelector);
  return /*#__PURE__*/React.createElement(Box, {
    style: {
      display: 'flex',
      justifContent: 'flex-end',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Box, null, pageInfo && rowRange ? firstElementIndex + ' a ' + (firstElementIndex + rowRange.lastRowIndex) + ' de ' + pageInfo.totalElements : ''), /*#__PURE__*/React.createElement(Pagination, {
    color: "primary",
    count: pageCount,
    page: page + 1,
    onChange: function onChange(event, value) {
      return apiRef.current.setPage(value - 1);
    }
  }));
};

var useLanguage = function useLanguage() {
  var _useBaseAppContext = useBaseAppContext(),
      currentLanguage = _useBaseAppContext.currentLanguage;

  switch (currentLanguage) {
    case 'es':
      return esES.components.MuiDataGrid.defaultProps.localeText;

    case 'ca':
      return caES.components.MuiDataGrid.defaultProps.localeText;

    default:
      return enUS.components.MuiDataGrid.defaultProps.localeText;
  }
};

var gridRowModesModelReducer = function gridRowModesModelReducer(state, action) {
  var _state$action$payload, _action$payload, _action$payload2, _action$payload3, _action$payload4;

  switch (action.type) {
    case 'clear':
      return {};

    case 'update':
      return _objectSpread2(_objectSpread2({}, state), action.payload);

    case 'switch':
      var currentMode = state === null || state === void 0 ? void 0 : (_state$action$payload = state[(_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id]) === null || _state$action$payload === void 0 ? void 0 : _state$action$payload.mode;
      var actionMode = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.mode;
      var newMode = actionMode !== null && actionMode !== void 0 ? actionMode : currentMode === GridRowModes.Edit ? GridRowModes.View : GridRowModes.Edit;
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.id, {
        mode: newMode,
        ignoreModifications: (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.ignoreModifications
      }));

    default:
      throw new Error();
  }
};

var useInlineEdit = function useInlineEdit(pageSize, gridRows, firstEditableColumn, lastEditableColumn, setGridRows, inlineFormApiRef, setCurrentEditingId, onCreate, onUpdate, triggerRefresh) {
  var _React$useReducer = React.useReducer(gridRowModesModelReducer),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      rowModesModel = _React$useReducer2[0],
      rowModesModelDispatch = _React$useReducer2[1];

  var editInitialColumn = React.useRef();
  var nextRowToEdit = React.useRef();
  var setRowEditMode = React.useCallback(function (id, mode, clearCurrentEditingId, clear, ignoreModifications) {
    setCurrentEditingId(clearCurrentEditingId ? null : id);
    clear && rowModesModelDispatch({
      type: 'clear'
    });
    rowModesModelDispatch({
      type: 'switch',
      payload: {
        id: id,
        mode: mode,
        ignoreModifications: ignoreModifications
      }
    });
  }, []);
  var resetInlineFormData = React.useCallback(function (data) {
    inlineFormApiRef.current.doReset(data, true);
  }, [inlineFormApiRef]);
  var endInlineEdit = React.useCallback(function (rowId, isCancel) {
    if (isCancel) {
      setRowEditMode(rowId, GridRowModes.View, true, true, true);
    } else {
      if (nextRowToEdit !== null && nextRowToEdit !== void 0 && nextRowToEdit.current) {
        // Si descomentam la línia següent, al canviar la fila amb edició activa
        // mitjançant tabulador, es mostren durant un instant els valors del camps
        // de la nova fila a la fila antiga.
        // resetInlineFormData(nextRowToEdit.current);
        setRowEditMode(nextRowToEdit.current.id, GridRowModes.Edit, false, true);
        nextRowToEdit.current = null; // Si descomentam la línia següent, al canviar la fila amb edició activa
        // mitjançant tabulador, els valors del camps de la nova fila es mostren
        // en blanc durant un instant.

        resetInlineFormData(nextRowToEdit.current);
      } else {
        setRowEditMode(rowId, GridRowModes.View, true);
        resetInlineFormData({});
      }
    }

    var isCreate = rowId === ROW_CREATE_ID;

    if (isCreate) {
      if (isCancel) {
        // setGridRows(gridRows => gridRows.slice(0, gridRows.length - 1));
        // TODO Restaurar fila esborrada en comptes de refrescar
        triggerRefresh();
      } else {
        triggerRefresh();
      }
    }
  }, [resetInlineFormData, setRowEditMode, nextRowToEdit.current, triggerRefresh]);
  var handleRowActionInlineCreate = React.useCallback(function () {
    var newRow = {
      id: ROW_CREATE_ID
    };

    if (gridRows.length) {
      if (gridRows.length === pageSize) {
        setGridRows(function (gridRows) {
          return [].concat(_toConsumableArray(gridRows.slice(0, gridRows.length - 1)), [newRow]);
        });
      } else {
        setGridRows(function (gridRows) {
          return [].concat(_toConsumableArray(gridRows), [newRow]);
        });
      }
    } else {
      setGridRows([newRow]);
    }

    resetInlineFormData({});
    setRowEditMode(ROW_CREATE_ID, GridRowModes.Edit, true);
    editInitialColumn.current = firstEditableColumn;
  }, [gridRows, pageSize, setGridRows, resetInlineFormData, setRowEditMode, editInitialColumn, firstEditableColumn]);
  var handleRowActionInlineUpdate = React.useCallback(function (id, row) {
    resetInlineFormData(row);
    setRowEditMode(id);
    editInitialColumn.current = firstEditableColumn;
  }, [resetInlineFormData, setRowEditMode, editInitialColumn, firstEditableColumn]);
  var handleRowActionInlineEditCancel = React.useCallback(function (params) {
    endInlineEdit(params.id, true);
  }, [endInlineEdit]);
  var handleRowActionInlineEditSave = React.useCallback(function (params) {
    setRowEditMode(params.id, GridRowModes.View, params.id === ROW_CREATE_ID);
  }, [setRowEditMode]);
  var handleRowEditStart = React.useCallback(function (params, event) {
    /*if (params.reason === 'cellDoubleClick') {
        event.defaultMuiPrevented = true;
    } else {*/
    var currentEditingRowMode = rowModesModel ? Object.entries(rowModesModel).find(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2);
          _ref2[0];
          var value = _ref2[1];

      return (value === null || value === void 0 ? void 0 : value.mode) === GridRowModes.Edit;
    }) : null;

    if (currentEditingRowMode) {
      event.defaultMuiPrevented = true;
    } else {
      resetInlineFormData(params.row);
      setRowEditMode(params.id);
      editInitialColumn.current = params.field;
    } //}

  }, [rowModesModel, resetInlineFormData, editInitialColumn]);
  var handleRowEditStop = React.useCallback(function (params) {
    if (params.reason === 'escapeKeyDown') {
      endInlineEdit(params.id, true);
    }

    if (params.reason === 'tabKeyDown' || params.reason === 'shiftTabKeyDown') {
      var currentRowIndex = gridRows.findIndex(function (r) {
        return r.id === params.id;
      });

      if (params.reason === 'tabKeyDown') {
        nextRowToEdit.current = currentRowIndex < gridRows.length - 1 ? gridRows[currentRowIndex + 1] : null;
        editInitialColumn.current = firstEditableColumn;
      } else {
        nextRowToEdit.current = currentRowIndex > 0 ? gridRows[currentRowIndex - 1] : null;
        editInitialColumn.current = lastEditableColumn;
      }
    }
  }, [gridRows, editInitialColumn, nextRowToEdit, endInlineEdit]);
  var processRowUpdate = React.useCallback(function (updated) {
    return new Promise(function (resolve, reject) {
      if (inlineFormApiRef !== null && inlineFormApiRef !== void 0 && inlineFormApiRef.current.modified) {
        inlineFormApiRef.current.doSave(function (data) {
          endInlineEdit(updated.id);
          resolve(data);

          if (updated.id === ROW_CREATE_ID) {
            onCreate === null || onCreate === void 0 ? void 0 : onCreate(data);
          } else {
            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(data);
          }
        }, function (error) {
          setRowEditMode(updated.id, GridRowModes.Edit, updated.id === ROW_CREATE_ID);
          reject(error);
        });
      } else {
        endInlineEdit(updated.id);
        resolve(updated);
      }
    });
  }, [inlineFormApiRef, endInlineEdit, setRowEditMode]);
  var handleProcessRowUpdateError = React.useCallback(function (error) {
    console.error('Error al guardar informació de la fila:', error);
  }, []);
  var handleRowModesModelChange = React.useCallback(function (change, details) {
    rowModesModelDispatch({
      type: 'update',
      payload: change
    });
  }, [rowModesModelDispatch]);
  return {
    rowModesModel: rowModesModel,
    editInitialColumn: editInitialColumn,
    handleRowActionInlineCreate: handleRowActionInlineCreate,
    handleRowActionInlineUpdate: handleRowActionInlineUpdate,
    handleRowActionInlineEditCancel: handleRowActionInlineEditCancel,
    handleRowActionInlineEditSave: handleRowActionInlineEditSave,
    handleRowEditStart: handleRowEditStart,
    handleRowEditStop: handleRowEditStop,
    processRowUpdate: processRowUpdate,
    handleProcessRowUpdateError: handleProcessRowUpdateError,
    handleRowModesModelChange: handleRowModesModelChange,
    cancelEditingAll: function cancelEditingAll() {
      rowModesModel && Object.entries(rowModesModel).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            id = _ref4[0],
            value = _ref4[1];

        if ((value === null || value === void 0 ? void 0 : value.mode) === GridRowModes.Edit) {
          endInlineEdit(id, true);
        }
      });
    }
  };
};

var useColumns = function useColumns(columns, readOnly, inlineEditable, inlineRenderEditCell, actionExecEnabled, sortActive, apiInitialized, apiResource, apiExec, resourceFieldName, rowModesModel, editInitialColumn, rowActionsColumnProps, rowAdditionalActions, rowHideEditAction, rowHideDeleteAction, handleRowActionEdit, handleRowActionDelete, handleRowActionExec, handleRowActionInlineEditCancel, handleRowActionInlineEditSave) {
  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fieldsStatus = _React$useState2[0],
      setFieldsStatus = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2);
      _React$useState4[0];
      var setFieldsError = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      fields = _React$useState6[0],
      setFields = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      createAllowed = _React$useState8[0],
      setCreateAllowed = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      gridColumns = _React$useState10[0],
      setGridColumns = _React$useState10[1];

  var _useBaseAppContext2 = useBaseAppContext(),
      currentLanguage = _useBaseAppContext2.currentLanguage;

  React.useEffect(function () {
    if (apiInitialized) {
      apiExec(resourceFieldName ? 'optionFields' : 'fields', {
        data: resourceFieldName ? {
          fieldName: resourceFieldName
        } : undefined,
        callbacks: {
          setStatus: setFieldsStatus,
          setResponse: function setResponse(response) {
            if (response) {
              var _response$getEmbedded;

              var _fields = (_response$getEmbedded = response.getEmbedded()) === null || _response$getEmbedded === void 0 ? void 0 : _response$getEmbedded.map(function (d) {
                return d.data;
              });

              setFields(_fields);
            }
          },
          setError: setFieldsError
        },
        refresh: true
      });
      setCreateAllowed(!!apiResource.links.get('create'));
    }
  }, [apiInitialized, currentLanguage]);
  React.useEffect(function () {
    if (fields) {
      var cols = columns === null || columns === void 0 ? void 0 : columns.map(function (c) {
        var cname = c.name,
            ceditable = c.editable,
            align = c.align,
            _renderCell = c.renderCell,
            _valueFormatter = c.valueFormatter,
            cother = _objectWithoutProperties(c, _excluded$4);

        var field = fields === null || fields === void 0 ? void 0 : fields.find(function (f) {
          return f.name === cname;
        });
        var isNumberType = (field === null || field === void 0 ? void 0 : field.type) === 'number' || (field === null || field === void 0 ? void 0 : field.type) === 'decimal' || (field === null || field === void 0 ? void 0 : field.type) === 'currency';
        return _objectSpread2({
          field: cname,
          headerName: field !== null && field !== void 0 && field.prompt ? field.prompt : cname,
          editable: !readOnly ? ceditable !== null && ceditable !== void 0 ? ceditable : inlineEditable : false,
          apiField: field,
          align: isNumberType ? 'right' : align,
          sortable: sortActive,
          renderCell: function renderCell(params) {
            var isCreatingRow = params.id === ROW_CREATE_ID;

            if (!isCreatingRow) {
              var _column$apiField;

              var column = params.api.getColumn(params.field);

              if (((_column$apiField = column.apiField) === null || _column$apiField === void 0 ? void 0 : _column$apiField.type) === 'checkbox') {
                if (params.value !== undefined) {
                  return params.value ? /*#__PURE__*/React.createElement(Icon, {
                    color: "action"
                  }, "check") : /*#__PURE__*/React.createElement(Icon, {
                    color: "disabled"
                  }, "clear");
                } else {
                  return null;
                }
              } else {
                return _renderCell ? _renderCell(params) : null;
              }
            } else {
              return null;
            }
          },
          valueFormatter: function valueFormatter(params) {
            var _c$type, _column$apiField2;

            var column = params.api.getColumn(params.field);
            var type = (_c$type = c.type) !== null && _c$type !== void 0 ? _c$type : (_column$apiField2 = column.apiField) === null || _column$apiField2 === void 0 ? void 0 : _column$apiField2.type;
            var formattedValue;

            if (type === 'date') {
              formattedValue = params.value ? dateFormatLocale(params.value) : params.value;
            } else if (type === 'number' || type === 'decimal') {
              formattedValue = params.value ? numberFormatField(params.value, field, currentLanguage) : params.value;
            } else if (type === 'currency') {
              var _column$currencyCode, _column$currencyLocal;

              var currency = (_column$currencyCode = column.currencyCode) !== null && _column$currencyCode !== void 0 ? _column$currencyCode : 'EUR';
              var decimalPlaces = column.decimalPlaces;
              var currencyLocale = (_column$currencyLocal = column.currencyLocale) !== null && _column$currencyLocal !== void 0 ? _column$currencyLocal : currentLanguage;
              formattedValue = params.value ? numberFormatCurrency(params.value, currency, decimalPlaces, currencyLocale) : params.value;
            } else if (type === 'reference') {
              var _params$value;

              formattedValue = (_params$value = params.value) === null || _params$value === void 0 ? void 0 : _params$value.description;
            } else if (type === 'enum') {
              var _column$apiField3, _column$apiField3$opt, _column$apiField3$opt2;

              var enumOption = (_column$apiField3 = column.apiField) === null || _column$apiField3 === void 0 ? void 0 : (_column$apiField3$opt = _column$apiField3.options) === null || _column$apiField3$opt === void 0 ? void 0 : (_column$apiField3$opt2 = _column$apiField3$opt.inline) === null || _column$apiField3$opt2 === void 0 ? void 0 : _column$apiField3$opt2.find(function (o) {
                return o.id === params.value;
              });
              formattedValue = enumOption ? enumOption.description : params.value;
            } else {
              formattedValue = params.value;
            }

            return _valueFormatter ? _valueFormatter(_objectSpread2(_objectSpread2({}, params), {}, {
              value: formattedValue
            })) : formattedValue;
          },
          renderEditCell: function renderEditCell(params) {
            return inlineRenderEditCell === null || inlineRenderEditCell === void 0 ? void 0 : inlineRenderEditCell(params, editInitialColumn);
          }
        }, cother);
      });

      if (!readOnly || rowAdditionalActions) {
        cols === null || cols === void 0 ? void 0 : cols.push(_objectSpread2({
          field: ' ',
          type: 'actions',
          getActions: function getActions(params) {
            var actions = [];

            if (!readOnly) {
              var editActiveId = rowModesModel ? Object.keys(rowModesModel).find(function (key) {
                var _rowModesModel$key;

                return ((_rowModesModel$key = rowModesModel[key]) === null || _rowModesModel$key === void 0 ? void 0 : _rowModesModel$key.mode) === GridRowModes.Edit;
              }) : undefined;
              var isInlineEditModeActiveForCurrentRow = '' + editActiveId === '' + params.id;

              if (isInlineEditModeActiveForCurrentRow) {
                actions.push( /*#__PURE__*/React.createElement(GridActionsCellItem, {
                  icon: /*#__PURE__*/React.createElement(Icon, null, "close"),
                  label: t('grid.button.cancel'),
                  onClick: function onClick() {
                    return handleRowActionInlineEditCancel(params);
                  }
                }));
                actions.push( /*#__PURE__*/React.createElement(GridActionsCellItem, {
                  icon: /*#__PURE__*/React.createElement(Icon, null, "save"),
                  label: t('grid.button.save'),
                  onClick: function onClick() {
                    return handleRowActionInlineEditSave(params);
                  }
                }));
              } else {
                var _params$row;

                var links = (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row._links;
                var showUpdateAction = (links === null || links === void 0 ? void 0 : links.get('update')) && !rowHideEditAction;
                var showDeleteAction = (links === null || links === void 0 ? void 0 : links.get('delete')) && !rowHideDeleteAction;
                var execLinks = actionExecEnabled ? links === null || links === void 0 ? void 0 : links.getAll().filter(function (l) {
                  var _l$rel, _l$rel2;

                  return ((_l$rel = l.rel) === null || _l$rel === void 0 ? void 0 : _l$rel.startsWith('exec_')) && !((_l$rel2 = l.rel) !== null && _l$rel2 !== void 0 && _l$rel2.endsWith('/fields'));
                }) : null;

                if (showUpdateAction || showDeleteAction || execLinks) {
                  showUpdateAction && actions.push( /*#__PURE__*/React.createElement(GridActionsCellItem, {
                    icon: /*#__PURE__*/React.createElement(Icon, null, "edit"),
                    label: t('grid.button.update'),
                    onClick: function onClick() {
                      return handleRowActionEdit(params);
                    },
                    disabled: !!editActiveId
                  }));
                  execLinks === null || execLinks === void 0 ? void 0 : execLinks.forEach(function (l) {
                    actions.push( /*#__PURE__*/React.createElement(GridActionsCellItem, {
                      icon: l.icon ? /*#__PURE__*/React.createElement(Icon, null, l.icon) : undefined,
                      label: l.title,
                      onClick: function onClick() {
                        return handleRowActionExec(params, l.rel);
                      },
                      disabled: !!editActiveId,
                      showInMenu: true
                    }));
                  });
                  showDeleteAction && actions.push( /*#__PURE__*/React.createElement(GridActionsCellItem, {
                    icon: /*#__PURE__*/React.createElement(Icon, null, "delete"),
                    label: t('grid.button.delete'),
                    onClick: function onClick() {
                      return handleRowActionDelete(params);
                    },
                    disabled: !!editActiveId,
                    showInMenu: true
                  }));
                }
              }
            }

            var processedRowAdditionalActions = rowAdditionalActions && typeof rowAdditionalActions === 'function' ? rowAdditionalActions(params) : rowAdditionalActions;

            if (processedRowAdditionalActions) {
              processedRowAdditionalActions.forEach(function (a) {
                actions.push( /*#__PURE__*/React.createElement(GridActionsCellItem, {
                  icon: a.icon && /*#__PURE__*/React.createElement(Icon, null, a.icon),
                  label: a.label,
                  title: a.icon && a.label,
                  onClick: function onClick() {
                    var _a$onClick;

                    return (_a$onClick = a.onClick) === null || _a$onClick === void 0 ? void 0 : _a$onClick.call(a, params);
                  },
                  showInMenu: a.showInMenu
                }));
              });
            }

            return actions;
          }
        }, rowActionsColumnProps));
      }

      setGridColumns(cols);
    }
  }, [fields, rowModesModel, editInitialColumn, columns]);
  return {
    gridColumns: gridColumns,
    fieldsLoading: fieldsStatus === ASYNC_STATUS_PENDING,
    createAllowed: createAllowed
  };
};

var GridCore = function GridCore(props) {
  var columns = props.columns,
      resourceName = props.resourceName,
      resourceFieldName = props.resourceFieldName,
      title = props.title,
      rows = props.rows,
      fixedQuery = props.fixedQuery,
      sortable = props.sortable,
      fixedSortModel = props.fixedSortModel,
      defaultSortModel = props.defaultSortModel,
      selectable = props.selectable,
      onSelectionChange = props.onSelectionChange,
      paginable = props.paginable,
      quickFilter = props.quickFilter,
      perspectives = props.perspectives,
      height = props.height,
      autoHeight = props.autoHeight,
      density = props.density;
      props.striped;
      var lovMode = props.lovMode,
      findQueryHref = props.findQueryHref,
      apiRef = props.apiRef,
      inlineEditable = props.inlineEditable,
      inlineFormApiRef = props.inlineFormApiRef,
      inlineRenderEditCell = props.inlineRenderEditCell,
      inlineOnEditIdChange = props.inlineOnEditIdChange,
      formPopupEditable = props.formPopupEditable,
      formPopupTitleCreate = props.formPopupTitleCreate,
      formPopupTitleUpdate = props.formPopupTitleUpdate,
      formPopupSize = props.formPopupSize,
      formPopupStaticData = props.formPopupStaticData,
      formPopupOpenFormDialog = props.formPopupOpenFormDialog,
      formRoutePath = props.formRoutePath,
      actionExecEnabled = props.actionExecEnabled,
      actionExecOpenActionDialog = props.actionExecOpenActionDialog,
      actionExecPopupSize = props.actionExecPopupSize,
      onRowClick = props.onRowClick,
      onRefresh = props.onRefresh,
      onCreate = props.onCreate,
      onUpdate = props.onUpdate,
      onDelete = props.onDelete;
      props.onExec;
      var toolbar = props.toolbar,
      toolbarType = props.toolbarType,
      toolbarExtraActions = props.toolbarExtraActions,
      toolbarHideExportAction = props.toolbarHideExportAction,
      toolbarHideCreateAction = props.toolbarHideCreateAction,
      toolbarHideRefreshAction = props.toolbarHideRefreshAction,
      rowActionsColumnProps = props.rowActionsColumnProps,
      rowAdditionalActions = props.rowAdditionalActions,
      rowHideEditAction = props.rowHideEditAction,
      rowHideDeleteAction = props.rowHideDeleteAction,
      rowReordering = props.rowReordering,
      rowReorderingField = props.rowReorderingField,
      rowReorderingOnOrderChange = props.rowReorderingOnOrderChange,
      treeData = props.treeData,
      treeDataStructureHandleRefresh = props.treeDataStructureHandleRefresh,
      treeDataStructureIcon = props.treeDataStructureIcon,
      treeDataPathAttribute = props.treeDataPathAttribute,
      treeDataProcessPath = props.treeDataProcessPath,
      treeDataGroupRowDataFromPath = props.treeDataGroupRowDataFromPath,
      treeDataGroupColumnProps = props.treeDataGroupColumnProps,
      treeDataRowReordering = props.treeDataRowReordering,
      treeDataRowReorderingField = props.treeDataRowReorderingField,
      treeDataRowReorderingSameParentOnly = props.treeDataRowReorderingSameParentOnly,
      treeDataRowReorderingGetDragType = props.treeDataRowReorderingGetDragType,
      treeDataRowReorderingGetDropType = props.treeDataRowReorderingGetDropType,
      treeDataRowReorderingOnStructureOrderChange = props.treeDataRowReorderingOnStructureOrderChange,
      sx = props.sx,
      otherProps = _objectWithoutProperties(props, _excluded2$1);

  var navigate = useNavigate();

  var _useTranslation2 = useTranslation('components'),
      t = _useTranslation2.t;

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      refreshPending = _React$useState12[0],
      setRefreshPending = _React$useState12[1];

  var _React$useState13 = React.useState(0),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      page = _React$useState14[0],
      setPage = _React$useState14[1];

  var _React$useState15 = React.useState(),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      pageSize = _React$useState16[0],
      setPageSize = _React$useState16[1];

  var _React$useState17 = React.useState(!fixedSortModel && !rowReordering && !treeData ? defaultSortModel : undefined),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      sortModel = _React$useState18[0],
      setSortModel = _React$useState18[1];

  var _React$useState19 = React.useState(),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      quickFilterValue = _React$useState20[0],
      setQuickFilterValue = _React$useState20[1];

  var _React$useState21 = React.useState(rows ? rows.length : 0),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      rowCount = _React$useState22[0],
      setRowCount = _React$useState22[1];

  var _React$useState23 = React.useState(),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      findStatus = _React$useState24[0],
      setFindStatus = _React$useState24[1];

  var _React$useState25 = React.useState(),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      findError = _React$useState26[0],
      setFindError = _React$useState26[1];

  var _React$useState27 = React.useState(rows !== null && rows !== void 0 ? rows : []),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      gridRows = _React$useState28[0],
      setGridRows = _React$useState28[1];

  var _React$useState29 = React.useState([]),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      processedGridRows = _React$useState30[0],
      setProcessedGridRows = _React$useState30[1];

  var _React$useState31 = React.useState(),
      _React$useState32 = _slicedToArray(_React$useState31, 2);
      _React$useState32[0];
      var setTreeDataStructureStatus = _React$useState32[1];

  var _React$useState33 = React.useState(),
      _React$useState34 = _slicedToArray(_React$useState33, 2);
      _React$useState34[0];
      var setTreeDataStructureError = _React$useState34[1];

  var _React$useState35 = React.useState([]),
      _React$useState36 = _slicedToArray(_React$useState35, 2),
      treeDataStructure = _React$useState36[0],
      setTreeDataStructure = _React$useState36[1];

  var _React$useState37 = React.useState(),
      _React$useState38 = _slicedToArray(_React$useState37, 2),
      gridPageInfo = _React$useState38[0],
      setGridPageInfo = _React$useState38[1];

  var _React$useState39 = React.useState(),
      _React$useState40 = _slicedToArray(_React$useState39, 2);
      _React$useState40[0];
      var setExportStatus = _React$useState40[1];

  var _React$useState41 = React.useState(),
      _React$useState42 = _slicedToArray(_React$useState41, 2);
      _React$useState42[0];
      var setExportError = _React$useState42[1];

  var _React$useState43 = React.useState(),
      _React$useState44 = _slicedToArray(_React$useState43, 2);
      _React$useState44[0];
      var setRowActionStatus = _React$useState44[1];

  var _React$useState45 = React.useState(),
      _React$useState46 = _slicedToArray(_React$useState45, 2);
      _React$useState46[0];
      var setRowActionError = _React$useState46[1];

  var _React$useState47 = React.useState(),
      _React$useState48 = _slicedToArray(_React$useState47, 2),
      currentEditingId = _React$useState48[0],
      setCurrentEditingId = _React$useState48[1];

  var _React$useState49 = React.useState([]),
      _React$useState50 = _slicedToArray(_React$useState49, 2),
      selectionModel = _React$useState50[0],
      setSelectionModel = _React$useState50[1];

  var _useBaseAppContext3 = useBaseAppContext(),
      showTemporalMessage = _useBaseAppContext3.showTemporalMessage,
      getPopupButton = _useBaseAppContext3.getPopupButton;

  var _useResourceApi = useResourceApi(resourceName),
      apiInitialized = _useResourceApi.apiInitialized,
      apiResource = _useResourceApi.apiResource,
      apiExec = _useResourceApi.exec,
      apiExecHref = _useResourceApi.execHref,
      apiExecDownload = _useResourceApi.execDownload;

  var dataGridlocaleText = useLanguage();
  var selectionActive = selectable === undefined ? false : selectable;
  var paginationActive = treeData ? false : paginable === undefined ? true : paginable;
  var sortActive = fixedSortModel || treeData ? false : sortable === undefined ? true : sortable;
  var readOnly = !inlineEditable && !formPopupEditable && !formRoutePath;
  var rowsLoading = findStatus === ASYNC_STATUS_PENDING;
  var createDisabled = inlineEditable && !!currentEditingId;
  var createHidden = toolbarHideCreateAction;

  var _useMessageDialog = useMessageDialog('sm'),
      confirmMessageDialog = _useMessageDialog.dialog,
      openConfirmMessageDialog = _useMessageDialog.openDialog;

  var activateRefreshPending = React.useCallback(function () {
    return setRefreshPending(true);
  }, []);
  var editableColumns = columns === null || columns === void 0 ? void 0 : columns.filter(function (c) {
    return c.editable === undefined || c.editable === true;
  });
  var firstEditableColumn = editableColumns && editableColumns.length ? editableColumns[0].name : undefined;
  var lastEditableColumn = editableColumns && editableColumns.length ? editableColumns[editableColumns.length - 1].name : undefined;

  var _useInlineEdit = useInlineEdit(pageSize, gridRows, firstEditableColumn, lastEditableColumn, setGridRows, inlineFormApiRef, setCurrentEditingId, onCreate, onUpdate, activateRefreshPending),
      rowModesModel = _useInlineEdit.rowModesModel,
      editInitialColumn = _useInlineEdit.editInitialColumn,
      handleRowActionInlineCreate = _useInlineEdit.handleRowActionInlineCreate,
      handleRowActionInlineUpdate = _useInlineEdit.handleRowActionInlineUpdate,
      handleRowActionInlineEditCancel = _useInlineEdit.handleRowActionInlineEditCancel,
      handleRowActionInlineEditSave = _useInlineEdit.handleRowActionInlineEditSave,
      handleRowEditStart = _useInlineEdit.handleRowEditStart,
      handleRowEditStop = _useInlineEdit.handleRowEditStop,
      processRowUpdate = _useInlineEdit.processRowUpdate,
      handleProcessRowUpdateError = _useInlineEdit.handleProcessRowUpdateError,
      handleRowModesModelChange = _useInlineEdit.handleRowModesModelChange,
      cancelEditingAll = _useInlineEdit.cancelEditingAll;

  var handleRefresh = React.useCallback(function () {
    cancelEditingAll();

    if (apiInitialized) {
      var _fixedSortModel$map;

      var findData = {
        page: paginationActive ? page : 'UNPAGED',
        size: paginationActive ? pageSize : undefined,
        sort: (_fixedSortModel$map = fixedSortModel === null || fixedSortModel === void 0 ? void 0 : fixedSortModel.map(function (s) {
          return s.field + ',' + s.sort;
        })) !== null && _fixedSortModel$map !== void 0 ? _fixedSortModel$map : sortModel === null || sortModel === void 0 ? void 0 : sortModel.map(function (s) {
          return s.field + ',' + s.sort;
        }),
        quickFilter: quickFilterValue,
        query: fixedQuery,
        perspective: perspectives
      };
      var findCallbacks = {
        setStatus: setFindStatus,
        setError: setFindError,
        setResponse: function setResponse(response) {
          var _response$data, _response$getEmbedded2;

          setGridPageInfo((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.page);
          var gridRows = (_response$getEmbedded2 = response.getEmbedded()) === null || _response$getEmbedded2 === void 0 ? void 0 : _response$getEmbedded2.map(function (d) {
            return _objectSpread2(_objectSpread2({}, d.data), {}, {
              _resource: d,
              _links: d.links,
              _templates: undefined
            });
          });
          setGridRows(gridRows !== null && gridRows !== void 0 ? gridRows : []);
          onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh(gridRows !== null && gridRows !== void 0 ? gridRows : []);
        }
      };

      if (findQueryHref) {
        apiExecHref(findQueryHref, findData, {
          callbacks: findCallbacks,
          refresh: true
        });
      } else {
        apiExec('find', {
          data: findData,
          callbacks: findCallbacks,
          refresh: true
        });
      }

      treeDataStructureHandleRefresh === null || treeDataStructureHandleRefresh === void 0 ? void 0 : treeDataStructureHandleRefresh({
        setStatus: setTreeDataStructureStatus,
        setError: setTreeDataStructureError,
        setResponse: setTreeDataStructure
      });
    }
  }, [apiInitialized, paginationActive, page, pageSize, fixedSortModel, sortModel, quickFilterValue, fixedQuery, perspectives, apiExec, cancelEditingAll, treeDataStructureHandleRefresh]);
  React.useEffect(function () {
    if (treeData) {
      if (treeDataStructure) {
        var treeExtraData = treeDataStructure.map(function (d) {
          return _objectSpread2(_objectSpread2({}, d), {}, {
            _structure: true
          });
        });
        setProcessedGridRows([].concat(_toConsumableArray(treeExtraData), _toConsumableArray(gridRows)));
      } else {
        var treeGroups = {};
        gridRows.forEach(function (row) {
          var groupRows = treeDataGroupRowDataFromPath ? treeDataGroupRowDataFromPath(row[treeDataPathAttribute], row) : undefined;

          if (groupRows && groupRows.length) {
            groupRows.forEach(function (groupRow) {
              treeGroups[groupRow[0]] = _objectSpread2({
                id: groupRow[0]
              }, groupRow[1]);
            });
          }
        });

        var _treeExtraData = Object.entries(treeGroups).map(function (d) {
          return _objectSpread2(_objectSpread2({}, d[1]), {}, {
            _structure: true
          });
        });

        setProcessedGridRows([].concat(_toConsumableArray(_treeExtraData), _toConsumableArray(gridRows)));
      }
    } else {
      setProcessedGridRows(gridRows);
    }
  }, [treeData, treeDataStructure, gridRows]);
  var handleQuickFilterChange = React.useCallback(function (value) {
    setQuickFilterValue(value || value !== '' ? value : null);
  }, [setQuickFilterValue]);
  var handleExport = React.useCallback(function (type) {
    if (apiInitialized) {
      var _fixedSortModel$map2;

      var exportData = {
        page: paginationActive ? page : 'UNPAGED',
        size: paginationActive ? pageSize : undefined,
        sort: (_fixedSortModel$map2 = fixedSortModel === null || fixedSortModel === void 0 ? void 0 : fixedSortModel.map(function (s) {
          return s.field + ',' + s.sort;
        })) !== null && _fixedSortModel$map2 !== void 0 ? _fixedSortModel$map2 : sortModel === null || sortModel === void 0 ? void 0 : sortModel.map(function (s) {
          return s.field + ',' + s.sort;
        }),
        quickFilter: quickFilterValue,
        query: fixedQuery,
        perspective: perspectives,
        field: columns.map(function (c) {
          return c.name;
        }),
        type: type
      };
      var exportCallbacks = {
        setStatus: setExportStatus,
        setError: setExportError
      };
      apiExecDownload('export', {
        data: exportData,
        callbacks: exportCallbacks
      });
    }
  }, [apiInitialized, paginationActive, page, pageSize, fixedSortModel, sortModel, quickFilterValue, fixedQuery, perspectives, columns, apiExecDownload]);
  var handleCreate = React.useCallback(function () {
    if (formPopupEditable) {
      formPopupOpenFormDialog(null, formPopupStaticData, formPopupTitleCreate, formPopupTitleUpdate, formPopupSize, function () {
        return setRefreshPending(true);
      });
    } else if (formRoutePath) {
      if (typeof formRoutePath === 'function') {
        navigate(formRoutePath());
      } else {
        navigate(formRoutePath);
      }
    } else if (inlineEditable) {
      handleRowActionInlineCreate();
    }
  }, [formPopupEditable, formRoutePath, inlineEditable, navigate, handleRowActionInlineCreate]);
  var handleRowActionEdit = React.useCallback(function (params) {
    if (formPopupEditable) {
      formPopupOpenFormDialog(params.id, formPopupStaticData, formPopupTitleCreate, formPopupTitleUpdate, formPopupSize, function () {
        return setRefreshPending(true);
      });
    } else if (formRoutePath) {
      if (typeof formRoutePath === 'function') {
        navigate(formRoutePath(params.id));
      } else {
        navigate(formRoutePath + '/' + params.id);
      }
    } else if (inlineEditable) {
      handleRowActionInlineUpdate(params.id, params.row);
    }
  }, [formPopupEditable, formRoutePath, inlineEditable, navigate, handleRowActionInlineUpdate]);
  var handleRowActionDelete = React.useCallback(function (params) {
    openConfirmMessageDialog(t('grid.action.delete.title'), null, null, t('grid.action.delete.confirm'), [getPopupButton('cancel', false, t('grid.action.delete.cancel')), getPopupButton('delete', true, t('grid.action.delete.ok'), true)], function (answerValue) {
      if (answerValue) {
        apiExec('delete', {
          id: params.id,
          callbacks: {
            setStatus: function setStatus(status) {
              setRowActionStatus(status);

              if (status === ASYNC_STATUS_SUCCESS) {
                showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('grid.action.delete.success'));
                setRefreshPending(true);
                onDelete === null || onDelete === void 0 ? void 0 : onDelete(params.id);
              }
            },
            setError: function setError(error) {
              if (error) {
                showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(error.message, 'error');
                setRowActionError(error);
              }
            }
          }
        });
      }
    });
  }, [apiExec, showTemporalMessage]);
  var handleRowActionExec = React.useCallback(function (params, rel) {
    var _actionLink$title;

    var links = params.row._links;
    var actionLink = links === null || links === void 0 ? void 0 : links.getAll().find(function (l) {
      return l.rel === rel;
    });
    actionExecOpenActionDialog(params.id, rel, null, (_actionLink$title = actionLink.title) !== null && _actionLink$title !== void 0 ? _actionLink$title : rel, actionExecPopupSize, function (response, actionExecuted) {
      actionExecuted && setRefreshPending(true);
    });
  }, [apiExec, actionExecOpenActionDialog, setRefreshPending]);
  var handleReordering = React.useCallback(function (rowId, reorderingField, newIndex) {
    apiExec('patch', {
      id: rowId,
      data: _defineProperty({}, reorderingField, newIndex),
      callbacks: {
        setStatus: function setStatus(status) {
          setRowActionStatus(status);

          if (status === ASYNC_STATUS_SUCCESS) {
            showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('grid.action.sort.success'));
            setRefreshPending(true);
          }
        },
        setError: function setError(error) {
          showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(error.message, 'error');
          setRowActionError(error);
        }
      }
    });
  }, [apiExec, showTemporalMessage]);
  var handleSelectAll = React.useCallback(function () {
    return setSelectionModel(processedGridRows === null || processedGridRows === void 0 ? void 0 : processedGridRows.map(function (r) {
      return r.id;
    }));
  }, [processedGridRows]);
  React.useEffect(function () {
    if (apiRef) {
      apiRef.current = {
        doRefresh: function doRefresh() {
          return setRefreshPending(true);
        },
        doSelectAll: handleSelectAll,
        doSelectNone: function doSelectNone() {
          return setSelectionModel([]);
        }
      };
    }
  }, [apiRef, setRefreshPending, handleSelectAll, setSelectionModel]);

  var handleRowOrderChange = function handleRowOrderChange(params) {
    if (params.oldIndex !== params.targetIndex) {
      var newIndex = gridRows[params.targetIndex][rowReorderingField];

      if (rowReorderingOnOrderChange) {
        rowReorderingOnOrderChange(params.row.id, newIndex);
      } else {
        handleReordering(params.row.id, rowReorderingField, newIndex);
      }
    }
  };

  var handleSelectionModelChange = React.useCallback(function (newSelectionModel, details) {
    if (treeData) {
      var added = newSelectionModel.length > selectionModel.length;
      var deleted = newSelectionModel.length < selectionModel.length;

      if (added) {
        var diff = newSelectionModel.filter(function (x) {
          return !selectionModel.includes(x);
        });
        var processedSelectionModel = diff.reduce(function (acc, cur) {
          return acc.concat(details.api.getRowGroupChildren({
            groupId: cur
          }));
        }, newSelectionModel !== null && newSelectionModel !== void 0 ? newSelectionModel : []);
        setSelectionModel(processedSelectionModel);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(processedSelectionModel);
      } else if (deleted) {
        var _diff = selectionModel.filter(function (x) {
          return !newSelectionModel.includes(x);
        });

        var _processedSelectionModel = _diff.reduce(function (acc, cur) {
          var children = details.api.getRowGroupChildren({
            groupId: cur
          });
          return acc.filter(function (x) {
            return !children.includes(x);
          });
        }, newSelectionModel);

        setSelectionModel(_processedSelectionModel);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(_processedSelectionModel);
      }
    } else {
      setSelectionModel(newSelectionModel);
      onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(newSelectionModel);
    }
  }, [treeData, selectionModel]);

  var _useColumns = useColumns(columns, readOnly, inlineEditable, inlineRenderEditCell, actionExecEnabled, sortActive, apiInitialized, apiResource, apiExec, resourceFieldName, rowModesModel, editInitialColumn, rowActionsColumnProps, rowAdditionalActions, rowHideEditAction, rowHideDeleteAction, handleRowActionEdit, handleRowActionDelete, handleRowActionExec, handleRowActionInlineEditCancel, handleRowActionInlineEditSave),
      gridColumns = _useColumns.gridColumns,
      fieldsLoading = _useColumns.fieldsLoading,
      createAllowed = _useColumns.createAllowed;

  React.useEffect(function () {
    if (!rows && apiInitialized && (!paginationActive || pageSize || autoHeight)) {
      handleRefresh();
      refreshPending && setRefreshPending(false);
    }
  }, [rows, apiInitialized, paginationActive, refreshPending, page, pageSize, autoHeight, sortModel, quickFilterValue, fixedQuery]);
  React.useEffect(function () {
    setRowCount(function (prevRowCount) {
      var _gridPageInfo$totalEl;

      return (_gridPageInfo$totalEl = gridPageInfo === null || gridPageInfo === void 0 ? void 0 : gridPageInfo.totalElements) !== null && _gridPageInfo$totalEl !== void 0 ? _gridPageInfo$totalEl : prevRowCount;
    });
  }, [gridPageInfo, setRowCount]);
  React.useEffect(function () {
    inlineOnEditIdChange === null || inlineOnEditIdChange === void 0 ? void 0 : inlineOnEditIdChange(currentEditingId);
  }, [currentEditingId]);
  var selectionAttributes = selectionActive ? {
    checkboxSelection: !!selectionActive,
    selectionModel: selectionModel,
    onSelectionModelChange: handleSelectionModelChange,
    keepNonExistentRowsSelected: true
  } : {};
  var paginationAttributes = paginationActive ? {
    pagination: paginationActive,
    page: page,
    autoPageSize: !autoHeight,
    paginationMode: 'server',
    onPageChange: function onPageChange(page) {
      return setPage(page);
    },
    onPageSizeChange: function onPageSizeChange(pageSize) {
      return setPageSize(pageSize);
    }
  } : {
    hideFooter: true
  };
  var sortAttributes = sortActive ? {
    sortingMode: 'server',
    sortModel: sortModel,
    onSortModelChange: setSortModel
  } : {};
  var reorderingAttributes = rowReordering ? {
    rowReordering: rowReordering,
    onRowOrderChange: handleRowOrderChange
  } : {};
  var getTreeDataPath = React.useCallback(function (row) {
    if (treeDataProcessPath) {
      var processedPath = treeDataProcessPath(row[treeDataPathAttribute], row); // Cada element de processedPath pot retornar un string o un array
      // d'strings. Això és per a evitar descripcions duplicades.
      // Si l'element és un array, per a formar el path es concatenarà
      // el contingut de l'array utilitzant un separador per a fer el
      // path únic. Després, a l'hora de mostrar-lo, es processarà i només
      // es mostrarà el primer element de l'array.

      return processedPath.map(function (p, i) {
        return Array.isArray(p) ? p.join(TREE_PATH_ID_SEPARATOR) : p;
      });
    } else {
      return row[treeDataPathAttribute];
    }
  }, [treeDataProcessPath, treeDataPathAttribute]);
  var memoizedGroupingColDef = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({
      headerName: t('grid.column.treeGroup')
    }, treeDataGroupColumnProps), {}, {
      renderCell: function renderCell(params) {
        return /*#__PURE__*/React.createElement(GridTreeDataGroupingCell, _extends({
          treeDataRowReordering: treeDataRowReordering,
          treeDataPathAttribute: treeDataPathAttribute,
          treeDataStructureIcon: treeDataStructureIcon,
          treeDataRowReorderingField: treeDataRowReorderingField,
          treeDataRowReorderingSameParentOnly: treeDataRowReorderingSameParentOnly,
          treeDataRowReorderingGetDragType: treeDataRowReorderingGetDragType,
          treeDataRowReorderingGetDropType: treeDataRowReorderingGetDropType,
          handleReordering: handleReordering,
          treeDataRowReorderingOnStructureOrderChange: treeDataRowReorderingOnStructureOrderChange
        }, params));
      }
    });
  }, [t, treeDataGroupColumnProps, treeDataRowReordering, treeDataPathAttribute, treeDataStructureIcon, treeDataRowReorderingField, treeDataRowReorderingSameParentOnly, treeDataRowReorderingGetDragType, treeDataRowReorderingGetDropType, handleReordering, treeDataRowReorderingOnStructureOrderChange]);
  var treeAttributes = treeData ? {
    treeData: treeData,
    getTreeDataPath: getTreeDataPath,
    groupingColDef: memoizedGroupingColDef
  } : {};
  var densityAttributes = density ? {
    density: density
  } : {};
  var toolbarActive = toolbar === undefined || toolbar;
  var formToolbarActive = lovMode || toolbarActive && (toolbarType ? toolbarType === TOOLBAR_TYPE_FORM : true);
  var headerToolbarActive = !lovMode && toolbarActive && (toolbarType ? toolbarType === TOOLBAR_TYPE_HEADER : false);
  var memoizedSx = React.useMemo(function () {
    return _objectSpread2({
      height: !autoHeight ? height !== null && height !== void 0 ? height : 300 : undefined
    }, sx);
  }, [autoHeight, height, sx]);
  var memoizedComponents = React.useMemo(function () {
    return {
      ErrorOverlay: GridErrorOverlay,
      NoRowsOverlay: GridNoRowsOverlay,
      Pagination: GridPagination
    };
  }, []);
  var memoizedComponentsProps = React.useMemo(function () {
    return {
      pagination: {
        pageInfo: gridPageInfo
      }
    };
  }, [gridPageInfo]);
  var memoizedExperimentalFeatures = React.useMemo(function () {
    return {
      newEditingApi: true
    };
  }, []);
  var getRowClassName = React.useCallback(function (params) {
    return params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-even' : 'striped-odd';
  }, []);
  var datagrid = gridColumns ? /*#__PURE__*/React.createElement(DataGridPro, _extends({
    columns: gridColumns,
    rows: processedGridRows,
    rowCount: rowCount,
    error: findError
  }, selectionAttributes, paginationAttributes, sortAttributes, reorderingAttributes, treeAttributes, densityAttributes, {
    loading: fieldsLoading || rowsLoading,
    disableColumnFilter: true,
    disableSelectionOnClick: true,
    editMode: "row",
    autoHeight: autoHeight,
    onRowClick: onRowClick,
    rowModesModel: rowModesModel,
    onRowModesModelChange: handleRowModesModelChange,
    onRowEditStart: handleRowEditStart,
    onRowEditStop: handleRowEditStop,
    processRowUpdate: processRowUpdate,
    onProcessRowUpdateError: handleProcessRowUpdateError,
    components: memoizedComponents,
    componentsProps: memoizedComponentsProps,
    localeText: dataGridlocaleText,
    getRowClassName: getRowClassName,
    experimentalFeatures: memoizedExperimentalFeatures,
    disableIgnoreModificationsIfProcessingProps: true
  }, otherProps, {
    sx: memoizedSx
  })) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, formToolbarActive && /*#__PURE__*/React.createElement(GridFormToolbar, {
    title: title,
    readOnly: readOnly,
    handleRefresh: !toolbarHideRefreshAction ? handleRefresh : undefined,
    handleExport: !toolbarHideExportAction ? handleExport : undefined,
    handleCreate: createAllowed ? handleCreate : undefined,
    createDisabled: createDisabled,
    createHidden: createHidden,
    handleQuickFilterChange: handleQuickFilterChange,
    quickFilter: quickFilter,
    extraActions: toolbarExtraActions,
    lovMode: lovMode
  }), headerToolbarActive && /*#__PURE__*/React.createElement(GridHeaderToolbar, {
    title: title,
    readOnly: readOnly,
    handleRefresh: !toolbarHideRefreshAction ? handleRefresh : undefined,
    handleExport: !toolbarHideExportAction ? handleExport : undefined,
    handleCreate: createAllowed ? handleCreate : undefined,
    createDisabled: createDisabled,
    createHidden: createHidden,
    handleQuickFilterChange: handleQuickFilterChange,
    quickFilter: quickFilter,
    extraActions: toolbarExtraActions
  }), datagrid, confirmMessageDialog);
};

var FormParentContext = /*#__PURE__*/React.createContext();
var useFormParentContext = function useFormParentContext() {
  var context = React.useContext(FormParentContext);
  return context;
};
var FormParentProvider = function FormParentProvider(props) {
  var id = props.id,
      action = props.action,
      report = props.report,
      staticData = props.staticData,
      onFormRegister = props.onFormRegister,
      onFieldsSuccess = props.onFieldsSuccess,
      onFieldsError = props.onFieldsError,
      onInitialDataChange = props.onInitialDataChange,
      onDataChange = props.onDataChange,
      onModifiedChange = props.onModifiedChange,
      onFieldValueChange = props.onFieldValueChange,
      onSaveSuccess = props.onSaveSuccess,
      onSaveError = props.onSaveError,
      onExecSuccess = props.onExecSuccess,
      onExecError = props.onExecError,
      onGenerateReportSuccess = props.onGenerateReportSuccess,
      onGenerateReportError = props.onGenerateReportError,
      onDeleteSuccess = props.onDeleteSuccess,
      onDeleteError = props.onDeleteError,
      onLockedChange = props.onLockedChange,
      children = props.children;
  var contextValue = {
    id: id,
    action: action,
    report: report,
    staticData: staticData,
    onFormRegister: onFormRegister,
    onFieldsSuccess: onFieldsSuccess,
    onFieldsError: onFieldsError,
    onInitialDataChange: onInitialDataChange,
    onDataChange: onDataChange,
    onModifiedChange: onModifiedChange,
    onFieldValueChange: onFieldValueChange,
    onSaveSuccess: onSaveSuccess,
    onSaveError: onSaveError,
    onExecSuccess: onExecSuccess,
    onExecError: onExecError,
    onGenerateReportSuccess: onGenerateReportSuccess,
    onGenerateReportError: onGenerateReportError,
    onDeleteSuccess: onDeleteSuccess,
    onDeleteError: onDeleteError,
    onLockedChange: onLockedChange
  };
  return /*#__PURE__*/React.createElement(FormParentContext.Provider, {
    value: contextValue
  }, children);
};

var FormButtons = function FormButtons(props) {
  var modified = props.modified,
      locked = props.locked,
      onRevertClick = props.onRevertClick,
      onSaveClick = props.onSaveClick,
      onDeleteClick = props.onDeleteClick,
      onLockClick = props.onLockClick;

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(React.Fragment, null, onRevertClick && /*#__PURE__*/React.createElement(IconButton, {
    title: t('form.buttons.revert.title'),
    onClick: function onClick() {
      return onRevertClick();
    },
    disabled: !modified
  }, /*#__PURE__*/React.createElement(Icon, null, "undo")), onLockClick && /*#__PURE__*/React.createElement(IconButton, {
    title: t('form.buttons.lock.title'),
    onClick: function onClick() {
      return onLockClick();
    }
  }, /*#__PURE__*/React.createElement(Icon, null, locked ? 'lock' : 'lock_open')), onSaveClick && /*#__PURE__*/React.createElement(IconButton, {
    title: t('form.buttons.save.title'),
    onClick: function onClick() {
      return onSaveClick();
    },
    disabled: !modified
  }, /*#__PURE__*/React.createElement(Icon, null, "save")), onDeleteClick && /*#__PURE__*/React.createElement(IconButton, {
    title: t('form.buttons.delete.title'),
    onClick: function onClick() {
      return onDeleteClick();
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "delete")));
};

var FormToolbar = function FormToolbar(props) {
  var onGoBackClick = props.onGoBackClick,
      title = props.title,
      modified = props.modified,
      locked = props.locked,
      onRevertClick = props.onRevertClick,
      onSaveClick = props.onSaveClick,
      onDeleteClick = props.onDeleteClick,
      onLockClick = props.onLockClick;
  var formButtonProps = {
    modified: modified,
    locked: locked,
    onRevertClick: onRevertClick,
    onSaveClick: onSaveClick,
    onDeleteClick: onDeleteClick,
    onLockClick: onLockClick
  };
  return /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true,
    sx: {
      display: 'flex',
      mt: 0,
      mb: 2,
      ml: -3,
      mr: -3,
      pl: 2,
      pr: 2,
      backgroundColor: '#efefef'
    }
  }, onGoBackClick ? /*#__PURE__*/React.createElement(IconButton, {
    sx: {
      mr: 1
    },
    onClick: function onClick() {
      return onGoBackClick();
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "arrow_back")) : null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title), /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexGrow: 1
    }
  }), /*#__PURE__*/React.createElement(FormButtons, formButtonProps));
};

var FormContext = /*#__PURE__*/React.createContext();
var useFormContext = function useFormContext() {
  return React.useContext(FormContext);
};

var _excluded$3 = ["name", "resourceName", "margin", "variant", "size", "disabled", "readOnly", "autoFocus", "hideLabel", "inputRef", "disableEnterKeyCapture", "advancedSearchColumns", "advancedSearchMaxWidth", "fixedQuery", "pageSize", "contextField", "contextValue", "contextResourceName", "contextHandleFieldChange", "contextFieldErrors", "contextHandleEnterKeyPress"];
var DEFAULT_PAGE_SIZE = 10;

var AdvancedSearch = function AdvancedSearch(props) {
  var resourceName = props.resourceName,
      field = props.field,
      columns = props.columns,
      maxWidth = props.maxWidth,
      open = props.open,
      onClose = props.onClose,
      onChange = props.onChange;

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var onRowClick = function onRowClick(data) {
    onChange === null || onChange === void 0 ? void 0 : onChange(data);
    onClose();
  };

  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 'sm'
  }, /*#__PURE__*/React.createElement(DialogTitle$1, null, t('form.field.reference.advanced.select') + (field.name ? ' ' + field.name : ''), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose,
    sx: {
      position: 'absolute',
      right: 8,
      top: 8
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "close"))), /*#__PURE__*/React.createElement(DialogContent$1, {
    sx: {
      height: '510px'
    }
  }, /*#__PURE__*/React.createElement(GridCore, {
    resourceName: resourceName,
    resourceFieldName: field.name,
    columns: columns,
    findQueryHref: field.options.link.href,
    readOnly: true,
    lovMode: true,
    onRowClick: onRowClick,
    height: 420
  })));
};

var FormFieldReference = function FormFieldReference(props) {
  var _contextField$prompt;

  var name = props.name,
      resourceName = props.resourceName,
      margin = props.margin,
      variant = props.variant,
      size = props.size,
      disabled = props.disabled,
      readOnly = props.readOnly,
      autoFocus = props.autoFocus,
      hideLabel = props.hideLabel,
      inputRef = props.inputRef,
      disableEnterKeyCapture = props.disableEnterKeyCapture,
      advancedSearchColumns = props.advancedSearchColumns,
      advancedSearchMaxWidth = props.advancedSearchMaxWidth,
      fixedQuery = props.fixedQuery,
      pageSize = props.pageSize,
      contextField = props.contextField,
      contextValue = props.contextValue,
      contextResourceName = props.contextResourceName,
      contextHandleFieldChange = props.contextHandleFieldChange,
      contextFieldErrors = props.contextFieldErrors,
      contextHandleEnterKeyPress = props.contextHandleEnterKeyPress,
      otherProps = _objectWithoutProperties(props, _excluded$3);

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      inputValueChanged = _React$useState6[0],
      setInputValueChanged = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      optionsStatus = _React$useState8[0],
      setOptionsStatus = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2);
      _React$useState10[0];
      var setOptionsError = _React$useState10[1];

  var _React$useState11 = React.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      options = _React$useState12[0],
      setOptions = _React$useState12[1];

  var _React$useState13 = React.useState(0),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      totalElements = _React$useState14[0],
      setTotalElements = _React$useState14[1];

  var _React$useState15 = React.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      advancedSearchOpened = _React$useState16[0],
      setAdvancedSearchOpened = _React$useState16[1];

  var _useResourceApi = useResourceApi(contextResourceName !== null && contextResourceName !== void 0 ? contextResourceName : resourceName),
      apiInitialized = _useResourceApi.apiInitialized,
      apiExecHref = _useResourceApi.execHref;

  var _useTranslation2 = useTranslation('components'),
      t = _useTranslation2.t;

  var requestOptionsDelayed = React.useCallback(debounce(function (text) {
    setOptions([]);
    setTotalElements(0);
    var valueField = contextField.options.valueField;
    var promptField = contextField.options.promptField;
    var href = contextField.options.link.href;
    apiExecHref(href, {
      quickFilter: text,
      query: fixedQuery,
      size: pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE
    }, {
      callbacks: {
        setStatus: setOptionsStatus,
        setResponse: function setResponse(response) {
          if (response) {
            var _response$getEmbedded, _response$data$page$t, _response$data$page;

            var responseData = (_response$getEmbedded = response.getEmbedded()) === null || _response$getEmbedded === void 0 ? void 0 : _response$getEmbedded.map(function (d) {
              return d.data;
            });
            var responseOptions = responseData === null || responseData === void 0 ? void 0 : responseData.map(function (d) {
              return {
                id: d[valueField],
                description: d[promptField]
              };
            });
            setOptions(responseOptions);
            setTotalElements((_response$data$page$t = (_response$data$page = response.data.page) === null || _response$data$page === void 0 ? void 0 : _response$data$page.totalElements) !== null && _response$data$page$t !== void 0 ? _response$data$page$t : 0);
          } else {
            setOptions([]);
            setTotalElements(0);
          }
        },
        setError: setOptionsError
      },
      refresh: true
    });
  }, 200), [fixedQuery]);
  React.useEffect(function () {
    if (apiInitialized && inputValueChanged) {
      requestOptionsDelayed(inputValue);
    }
  }, [apiInitialized, inputValueChanged, inputValue, requestOptionsDelayed]);
  React.useEffect(function () {
    if (open) requestOptionsDelayed(inputValue);
  }, [open]);
  React.useEffect(function () {
    var _contextValue$descrip;

    var inputValue = (_contextValue$descrip = contextValue === null || contextValue === void 0 ? void 0 : contextValue.description) !== null && _contextValue$descrip !== void 0 ? _contextValue$descrip : '';
    setInputValue(inputValue);
  }, []);

  var handleOnKeyPress = function handleOnKeyPress(event) {
    if (event.code === 'Enter' && !disableEnterKeyCapture) {
      contextHandleEnterKeyPress === null || contextHandleEnterKeyPress === void 0 ? void 0 : contextHandleEnterKeyPress();
    }
  };

  var handleOnChange = function handleOnChange(event, value, reason) {
    if (reason === 'clear') setOpen(true);
    contextHandleFieldChange === null || contextHandleFieldChange === void 0 ? void 0 : contextHandleFieldChange(name, value);
  };

  var handleAdvancedSearchOnChange = function handleAdvancedSearchOnChange(value) {
    var valueField = contextField.options.valueField;
    var promptField = contextField.options.promptField;
    var newValue = {
      id: value.row[valueField],
      description: value.row[promptField]
    };
    contextHandleFieldChange === null || contextHandleFieldChange === void 0 ? void 0 : contextHandleFieldChange(name, newValue);
  };

  var handleOnInputChange = function handleOnInputChange(event, value, reason) {
    setInputValue(value);
    setInputValueChanged(true);
  };

  var fieldLabel = hideLabel ? null : (_contextField$prompt = contextField === null || contextField === void 0 ? void 0 : contextField.prompt) !== null && _contextField$prompt !== void 0 ? _contextField$prompt : name;
  var fieldError = contextFieldErrors === null || contextFieldErrors === void 0 ? void 0 : contextFieldErrors.find(function (e) {
    return e.field === name;
  });
  var fieldRequired = contextField === null || contextField === void 0 ? void 0 : contextField.required;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Autocomplete, {
    open: open,
    onOpen: function onOpen(event) {
      if (event.type === 'change' || event.type === 'click' || contextValue == null) setOpen(true);
    },
    onClose: function onClose(event, reason) {
      var _contextValue$descrip2;

      if (reason === 'escape') handleOnInputChange(event, (_contextValue$descrip2 = contextValue === null || contextValue === void 0 ? void 0 : contextValue.description) !== null && _contextValue$descrip2 !== void 0 ? _contextValue$descrip2 : '');
      setOpen(false);
    },
    openOnFocus: true,
    fullWidth: true,
    loading: optionsStatus === ASYNC_STATUS_PENDING,
    loadingText: t('form.field.reference.loading'),
    noOptionsText: t('form.field.reference.noOptions'),
    clearText: t('form.field.reference.clear'),
    closeText: t('form.field.reference.close'),
    openText: t('form.field.reference.open'),
    isOptionEqualToValue: function isOptionEqualToValue(option, value) {
      return option.id === (value === null || value === void 0 ? void 0 : value.id);
    },
    getOptionLabel: function getOptionLabel(option) {
      var _option$description;

      return option ? (_option$description = option.description) !== null && _option$description !== void 0 ? _option$description : '' : '';
    },
    getOptionDisabled: function getOptionDisabled(option) {
      return option.disabled;
    } // The next prop fixes a bug in Firefox where the focus was put into the Listbox
    // container, and then lost focus of the form completely when navigating to the next input
    ,
    ListboxProps: {
      tabIndex: '-1'
    },
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/React.createElement("li", _extends({}, props, {
        key: option.id
      }), option.description);
    },
    options: options,
    disabled: disabled,
    filterOptions: function filterOptions(options, state) {
      if (totalElements > size) {
        options.push({
          id: '___pageLabel',
          description: t('form.field.reference.pageMessage', {
            size: size,
            totalElements: totalElements
          }),
          disabled: true
        });
      }

      return options;
    },
    value: contextValue !== null && contextValue !== void 0 ? contextValue : null,
    onChange: handleOnChange,
    inputValue: inputValue,
    onInputChange: handleOnInputChange,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, otherProps, {
        label: fieldLabel,
        required: fieldRequired,
        error: !!fieldError,
        helperText: fieldError ? fieldError.message : undefined,
        title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText,
        margin: margin,
        variant: variant,
        size: size,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        inputRef: inputRef,
        onKeyPress: handleOnKeyPress,
        InputProps: _objectSpread2(_objectSpread2({}, params.InputProps), {}, {
          startAdornment: advancedSearchColumns && !disabled ? /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick() {
              return setAdvancedSearchOpened(true);
            },
            sx: {
              p: 0
            }
          }, /*#__PURE__*/React.createElement(Icon, null, "search")) : undefined,
          endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, optionsStatus === ASYNC_STATUS_PENDING ? /*#__PURE__*/React.createElement(CircularProgress, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        })
      }));
    },
    componentsProps: {
      popper: {
        sx: {
          minWidth: "300px"
        }
      }
    }
  }), /*#__PURE__*/React.createElement(AdvancedSearch, {
    resourceName: contextResourceName !== null && contextResourceName !== void 0 ? contextResourceName : resourceName,
    field: contextField,
    columns: advancedSearchColumns,
    maxWidth: advancedSearchMaxWidth,
    open: advancedSearchOpened,
    onClose: function onClose() {
      return setAdvancedSearchOpened(false);
    },
    onChange: handleAdvancedSearchOnChange
  }));
};

var richTextEditorCa = {
  // Generic
  'generic.add': 'Afegir',
  'generic.cancel': 'Cancel·lar',
  // BlockType
  'components.controls.blocktype.h1': 'H1',
  'components.controls.blocktype.h2': 'H2',
  'components.controls.blocktype.h3': 'H3',
  'components.controls.blocktype.h4': 'H4',
  'components.controls.blocktype.h5': 'H5',
  'components.controls.blocktype.h6': 'H6',
  'components.controls.blocktype.blockquote': 'Blockquote',
  'components.controls.blocktype.code': 'Codi',
  'components.controls.blocktype.blocktype': 'Bloc',
  'components.controls.blocktype.normal': 'Normal',
  // Color Picker
  'components.controls.colorpicker.colorpicker': 'Selector de color',
  'components.controls.colorpicker.text': 'Text',
  'components.controls.colorpicker.background': 'Resaltar',
  // Embedded
  'components.controls.embedded.embedded': 'Embedded',
  'components.controls.embedded.embeddedlink': 'Enllaç Embedded',
  'components.controls.embedded.enterlink': "Introdueix l'enllaç",
  // Emoji
  'components.controls.emoji.emoji': 'Emoji',
  // FontFamily
  'components.controls.fontfamily.fontfamily': 'Font',
  // FontSize
  'components.controls.fontsize.fontsize': 'Tamany de font',
  // History
  'components.controls.history.history': 'Historial',
  'components.controls.history.undo': 'Desfer',
  'components.controls.history.redo': 'Refer',
  // Image
  'components.controls.image.image': 'Imatge',
  'components.controls.image.fileUpload': 'Pujada de fitxer',
  'components.controls.image.byURL': 'URL',
  'components.controls.image.dropFileText': 'Arrossegueu el fitxer o feu clic per pujar',
  // Inline
  'components.controls.inline.bold': 'Negreta',
  'components.controls.inline.italic': 'Cursiva',
  'components.controls.inline.underline': 'Subratllat',
  'components.controls.inline.strikethrough': 'Tachado',
  'components.controls.inline.monospace': 'Mono espai',
  'components.controls.inline.superscript': 'Superscript',
  'components.controls.inline.subscript': 'Subscript',
  // Link
  'components.controls.link.linkTitle': "Títol de l'enllaç",
  'components.controls.link.linkTarget': "Direcció de l'enllaç",
  'components.controls.link.linkTargetOption': "Obrir l'enllaç a una finestra nova",
  'components.controls.link.link': 'Enllaçar',
  'components.controls.link.unlink': 'Desenllaçar',
  // List
  'components.controls.list.list': 'LLista',
  'components.controls.list.unordered': 'No ordenada',
  'components.controls.list.ordered': 'Ordenada',
  'components.controls.list.indent': 'Identar',
  'components.controls.list.outdent': 'Desidentar',
  // Remove
  'components.controls.remove.remove': 'Eliminar',
  // TextAlign
  'components.controls.textalign.textalign': 'Alinear text',
  'components.controls.textalign.left': 'Esquerra',
  'components.controls.textalign.center': 'Centre',
  'components.controls.textalign.right': 'Dreta',
  'components.controls.textalign.justify': 'Justificat'
};

var generateTranslations = function generateTranslations(lang) {
  switch (lang) {
    case 'ca':
      return richTextEditorCa;

    default:
      return undefined;
  }
};

var Root = styled(Box$1)({
  '& .rdw-dropdown-selectedtext': {
    color: 'inherit'
  },
  '& .rdw-editor-toolbar': {
    borderWidth: '0 0 1px 0!important',
    margin: '0!important'
  },
  '& .rdw-editor-main': {
    padding: '8px 12px',
    maxHeight: 165
  },
  '& .labelPosition': {
    position: 'relative',
    top: '-16px',
    left: '10px',
    height: 0
  },
  '& .inputLabel': {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    margin: 0,
    padding: '0px 13px 0px 13px',
    background: 'white',
    color: '#6b7280'
  },
  '&.error': {
    '.container': {
      borderColor: '#f44336'
    },
    '.inputLabel, .helperText': {
      color: '#f44336'
    }
  }
}, sx({
  '& .container': {
    borderRadius: 1,
    border: 1,
    borderColor: '#c4c4c4',
    paddingTop: '5px'
  },
  '& .helperText': {
    marginLeft: 2
  }
}));
var FormFieldRichText = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
      onChange = props.onChange,
      value = props.value,
      className = props.className,
      error = props.error,
      helperText = props.helperText,
      title = props.title;

  var _React$useState = React.useState(EditorState.createEmpty()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editorState = _React$useState2[0],
      setEditorState = _React$useState2[1];

  var _useBaseAppContext = useBaseAppContext(),
      currentLanguage = _useBaseAppContext.currentLanguage;

  React.useEffect(function () {
    var contentBlock = htmlToDraft(value !== null && value !== void 0 ? value : '');

    if (contentBlock) {
      var contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);

      var _editorState = EditorState.createWithContent(contentState);

      setEditorState(_editorState);
    }
  }, [value]);

  var onEditorBlur = function onEditorBlur(event, _editorState) {
    onChange(draftToHtml(convertToRaw(_editorState.getCurrentContent())));
  };

  return /*#__PURE__*/React.createElement(Root, {
    className: clsx(className, error && 'error'),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelPosition"
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "caption",
    className: "inputLabel"
  }, label)), /*#__PURE__*/React.createElement(Editor, {
    editorState: editorState,
    onBlur: onEditorBlur,
    onEditorStateChange: setEditorState,
    localization: {
      locale: currentLanguage,
      translations: generateTranslations(currentLanguage)
    },
    toolbar: {
      options: ['inline', 'list', 'textAlign', 'remove', 'history'],
      inline: {
        inDropdown: false,
        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript']
      },
      list: {
        inDropdown: false,
        options: ['unordered', 'ordered', 'indent', 'outdent']
      },
      textAlign: {
        inDropdown: false,
        options: ['left', 'center', 'right', 'justify']
      },
      history: {
        inDropdown: false,
        options: ['undo', 'redo']
      }
    }
  })), helperText && /*#__PURE__*/React.createElement(FormHelperText, {
    className: "helperText"
  }, helperText));
});

var _excluded$2 = ["name", "margin", "variant", "size", "disabled", "readOnly", "autoFocus", "inline", "hideLabel", "onChange", "disableEnterKeyCapture", "fixedQuery", "pageSize", "advancedSearchColumns", "advancedSearchMaxWidth", "contextField", "contextValue", "contextResourceName", "contextHandleFieldChange", "contextFieldErrors", "contextHandleEnterKeyPress", "contextHandleOpenTextFieldDialog"],
    _excluded2 = ["name", "margin", "variant", "size", "disabled", "readOnly", "autoFocus", "inline", "onChange", "fixedQuery", "pageSize"];

var FormFieldWithRestrictedContext = function FormFieldWithRestrictedContext(props) {
  var _contextField$prompt, _contextField$options, _contextField$options2, _otherProps$InputProp3, _otherProps$InputProp4, _otherProps$InputProp5, _contextField$options3, _contextField$options4, _otherProps$InputProp6, _otherProps$InputProp7, _otherProps$InputProp8, _contextField$options5, _contextField$options6, _otherProps$inputProp, _otherProps$InputProp9, _otherProps$InputProp10, _otherProps$InputProp11;

  var name = props.name,
      margin = props.margin,
      variant = props.variant,
      size = props.size,
      disabled = props.disabled,
      readOnly = props.readOnly,
      autoFocus = props.autoFocus,
      inline = props.inline,
      hideLabel = props.hideLabel,
      onChange = props.onChange,
      disableEnterKeyCapture = props.disableEnterKeyCapture,
      fixedQuery = props.fixedQuery,
      pageSize = props.pageSize,
      advancedSearchColumns = props.advancedSearchColumns,
      advancedSearchMaxWidth = props.advancedSearchMaxWidth,
      contextField = props.contextField,
      contextValue = props.contextValue,
      contextResourceName = props.contextResourceName,
      contextHandleFieldChange = props.contextHandleFieldChange,
      contextFieldErrors = props.contextFieldErrors,
      contextHandleEnterKeyPress = props.contextHandleEnterKeyPress,
      contextHandleOpenTextFieldDialog = props.contextHandleOpenTextFieldDialog,
      otherProps = _objectWithoutProperties(props, _excluded$2);

  var inputRef = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showPassword = _React$useState2[0],
      setShowPassword = _React$useState2[1];

  var _useBaseAppContext = useBaseAppContext(),
      currentLanguage = _useBaseAppContext.currentLanguage;

  var fieldLabel = hideLabel ? null : (_contextField$prompt = contextField === null || contextField === void 0 ? void 0 : contextField.prompt) !== null && _contextField$prompt !== void 0 ? _contextField$prompt : name;
  var fieldError = contextFieldErrors === null || contextFieldErrors === void 0 ? void 0 : contextFieldErrors.find(function (e) {
    return e.field === name;
  });
  var fieldRequired = contextField === null || contextField === void 0 ? void 0 : contextField.required;
  var fieldMultiple = (contextField === null || contextField === void 0 ? void 0 : (_contextField$options = contextField.options) === null || _contextField$options === void 0 ? void 0 : _contextField$options.minItems) > 1 || (contextField === null || contextField === void 0 ? void 0 : (_contextField$options2 = contextField.options) === null || _contextField$options2 === void 0 ? void 0 : _contextField$options2.maxItems) > 1;
  var fieldErrorEndAdornment = fieldError && inline && /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end"
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "error",
    title: fieldError.message
  }, "warning"));

  var propagateChanges = function propagateChanges(name, value) {
    contextHandleFieldChange === null || contextHandleFieldChange === void 0 ? void 0 : contextHandleFieldChange(name, value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  };

  var handleTimeOnChange = function handleTimeOnChange(value) {
    if (value) {
      var processedValue = "".concat(String(value.getHours()).padStart(2, '0'), ":").concat(String(value.getMinutes()).padStart(2, '0'), ":").concat(String(value.getSeconds()).padStart(2, '0'));
      propagateChanges(name, processedValue);
    }
  };

  var handleDateOnChange = function handleDateOnChange(value, type) {
    if (value) {
      var isValid = value instanceof Date && !isNaN(value) && value.getFullYear() > 1000;

      if (isValid) {
        var processedValue;

        if (type === 'date') {
          processedValue = new Date(value.getFullYear(), value.getMonth(), value.getDate()).toISOString();
        } else {
          processedValue = value.toISOString();
        }

        propagateChanges(name, processedValue);
      }
    } else {
      propagateChanges(name, value);
    }
  };

  var handleNumberOnChange = function handleNumberOnChange(valueObj) {
    var value = valueObj.floatValue;
    propagateChanges(name, value);
  };

  var handleDecimalOnChange = function handleDecimalOnChange(valueObj) {
    var decimalValue = tryParseDecimal(valueObj.value);
    propagateChanges(name, decimalValue === null || decimalValue === void 0 ? void 0 : decimalValue.toFixed());
  };

  var handleEnumOnChange = function handleEnumOnChange(value, multiple) {
    if (multiple) {
      propagateChanges(name, value);
    } else {
      propagateChanges(name, value === '' ? null : value);
    }
  };

  var handleOnChange = function handleOnChange(event, type) {
    var value = event.target.value;

    if (type === 'checkbox') {
      propagateChanges(name, event.target.checked);
    } else {
      propagateChanges(name, value === '' ? null : value);
    }
  };

  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(!showPassword);
  };

  var handleMouseDownPassword = function handleMouseDownPassword(event) {
    event.preventDefault();
  };

  var handleOnKeyPress = function handleOnKeyPress(event) {
    if (event.code === 'Enter' && !disableEnterKeyCapture) {
      contextHandleEnterKeyPress === null || contextHandleEnterKeyPress === void 0 ? void 0 : contextHandleEnterKeyPress();
    }
  };

  var handleTextOnKeyDown = function handleTextOnKeyDown(event) {
    if (event.ctrlKey && (event.key === 'e' || event.key === 'E')) {
      event.preventDefault();
      contextHandleOpenTextFieldDialog(name);
    }
  }; // console.log('>>> FormField', name, fieldLabel, fieldError, contextValue, contextField)


  switch (contextField === null || contextField === void 0 ? void 0 : contextField.type) {
    case 'time':
      var splitTime = contextValue === null || contextValue === void 0 ? void 0 : contextValue.split(':');
      var formattedTime = splitTime ? _construct(Date, [null, null, null].concat(_toConsumableArray(splitTime))).toISOString() : null;
      return /*#__PURE__*/React.createElement(TimePicker, {
        label: fieldLabel,
        value: formattedTime !== null && formattedTime !== void 0 ? formattedTime : '',
        onChange: function onChange(value) {
          return handleTimeOnChange(value);
        },
        renderInput: function renderInput(params) {
          var _otherProps$InputProp, _params$InputProps;

          var TimeInputProps = _objectSpread2(_objectSpread2({}, (_otherProps$InputProp = otherProps === null || otherProps === void 0 ? void 0 : otherProps.InputProps) !== null && _otherProps$InputProp !== void 0 ? _otherProps$InputProp : {}), {}, {
            endAdornment: fieldErrorEndAdornment !== null && fieldErrorEndAdornment !== void 0 ? fieldErrorEndAdornment : (_params$InputProps = params.InputProps) === null || _params$InputProps === void 0 ? void 0 : _params$InputProps.endAdornment
          });

          return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
            fullWidth: true,
            required: fieldRequired,
            error: !!fieldError,
            helperText: fieldError && !inline ? fieldError.message : undefined,
            title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText,
            margin: margin,
            variant: variant,
            size: size,
            disabled: disabled,
            readOnly: readOnly,
            autoFocus: autoFocus,
            InputProps: TimeInputProps
          }, otherProps));
        }
      });

    case 'date':
    case 'datetime-local':
      var formatted = contextValue ? dateFormatInput(contextValue) : null;
      return /*#__PURE__*/React.createElement(DatePicker, {
        label: fieldLabel,
        value: formatted !== null && formatted !== void 0 ? formatted : '',
        onChange: function onChange(value) {
          return handleDateOnChange(value, contextField.type);
        },
        onKeyPress: handleOnKeyPress,
        inputRef: inputRef,
        renderInput: function renderInput(params) {
          var _otherProps$InputProp2, _params$InputProps2;

          var DateInputProps = _objectSpread2(_objectSpread2({}, (_otherProps$InputProp2 = otherProps === null || otherProps === void 0 ? void 0 : otherProps.InputProps) !== null && _otherProps$InputProp2 !== void 0 ? _otherProps$InputProp2 : {}), {}, {
            endAdornment: fieldErrorEndAdornment !== null && fieldErrorEndAdornment !== void 0 ? fieldErrorEndAdornment : (_params$InputProps2 = params.InputProps) === null || _params$InputProps2 === void 0 ? void 0 : _params$InputProps2.endAdornment
          });

          return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
            fullWidth: true,
            required: fieldRequired,
            error: !!fieldError,
            helperText: fieldError && !inline ? fieldError.message : undefined,
            title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText,
            margin: margin,
            variant: variant,
            size: size,
            disabled: disabled,
            readOnly: readOnly,
            autoFocus: autoFocus,
            InputProps: DateInputProps
          }, otherProps));
        }
      });

    case 'number':
    case 'decimal':
      var isDecimal = (contextField === null || contextField === void 0 ? void 0 : contextField.type) === 'decimal';
      var numberInputProps = {
        min: contextField.min,
        max: contextField.max,
        step: contextField.step
      };

      var NumberInputProps = _objectSpread2({
        endAdornment: (_otherProps$InputProp3 = otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$InputProp4 = otherProps.InputProps) === null || _otherProps$InputProp4 === void 0 ? void 0 : _otherProps$InputProp4.endAdornment) !== null && _otherProps$InputProp3 !== void 0 ? _otherProps$InputProp3 : fieldErrorEndAdornment
      }, (_otherProps$InputProp5 = otherProps === null || otherProps === void 0 ? void 0 : otherProps.InputProps) !== null && _otherProps$InputProp5 !== void 0 ? _otherProps$InputProp5 : {});

      return /*#__PURE__*/React.createElement(NumberFormat, _extends({
        fullWidth: true,
        label: fieldLabel,
        required: fieldRequired,
        error: !!fieldError,
        helperText: fieldError && !inline ? fieldError.message : undefined,
        margin: margin,
        variant: variant,
        size: size,
        disabled: disabled,
        autoFocus: autoFocus,
        inputProps: _objectSpread2({
          style: {
            textAlign: 'right'
          },
          readOnly: readOnly
        }, numberInputProps),
        value: contextValue !== null && contextValue !== void 0 ? contextValue : '',
        isNumericString: isDecimal,
        isAllowed: function isAllowed(valueObj) {
          var min = numberInputProps.min,
              max = numberInputProps.max;
          var _ref = [tryParseDecimal(min), tryParseDecimal(max)],
              minDecimal = _ref[0],
              maxDecimal = _ref[1];
          var decimalValue = tryParseDecimal(valueObj.value);
          var isDecimalValueInRange = decimalValue === undefined || (minDecimal === undefined || decimalValue.greaterThanOrEqualTo(minDecimal)) && (maxDecimal === undefined || decimalValue.lessThanOrEqualTo(maxDecimal));
          return isDecimalValueInRange;
        },
        onValueChange: function onValueChange(valueObj, sourceInfo) {
          if (sourceInfo.source !== 'event') return;

          if (isDecimal) {
            handleDecimalOnChange(valueObj);
          } else {
            handleNumberOnChange(valueObj);
          }
        },
        onKeyPress: handleOnKeyPress,
        customInput: TextField,
        decimalSeparator: getDecimalSeparator(currentLanguage),
        thousandSeparator: getThousandSeparator(currentLanguage),
        decimalScale: numberInputProps.step ? countDecimalPositions(numberInputProps.step) : undefined,
        allowNegative: numberInputProps.min && numberInputProps.min < 0,
        inputRef: inputRef,
        InputProps: NumberInputProps
      }, otherProps, {
        title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText
      }));

    case 'checkbox':
      return /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, _extends({
          checked: contextValue ? true : false,
          onChange: function onChange(event) {
            return handleOnChange(event, contextField.type);
          },
          onKeyPress: handleOnKeyPress,
          inputRef: inputRef,
          title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText
        }, otherProps)),
        label: fieldLabel
      });

    case 'enum':
      var enumValueField = (_contextField$options3 = contextField.options) === null || _contextField$options3 === void 0 ? void 0 : _contextField$options3.valueField;
      var enumPromptField = (_contextField$options4 = contextField.options) === null || _contextField$options4 === void 0 ? void 0 : _contextField$options4.promptField;

      var EnumInputProps = _objectSpread2({
        endAdornment: (_otherProps$InputProp6 = otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$InputProp7 = otherProps.InputProps) === null || _otherProps$InputProp7 === void 0 ? void 0 : _otherProps$InputProp7.endAdornment) !== null && _otherProps$InputProp6 !== void 0 ? _otherProps$InputProp6 : fieldErrorEndAdornment
      }, (_otherProps$InputProp8 = otherProps === null || otherProps === void 0 ? void 0 : otherProps.InputProps) !== null && _otherProps$InputProp8 !== void 0 ? _otherProps$InputProp8 : {});

      return /*#__PURE__*/React.createElement(TextField, _extends({
        select: true,
        fullWidth: true,
        label: fieldLabel,
        required: fieldRequired,
        error: !!fieldError,
        helperText: fieldError && !inline ? fieldError.message : undefined,
        title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText,
        margin: margin,
        variant: variant,
        size: size,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        value: contextValue !== null && contextValue !== void 0 ? contextValue : !!fieldMultiple ? [] : '',
        onChange: function onChange(event) {
          return handleEnumOnChange(event.target.value, !!fieldMultiple);
        },
        onKeyPress: handleOnKeyPress,
        inputRef: inputRef,
        SelectProps: {
          multiple: !!fieldMultiple
        },
        InputProps: EnumInputProps
      }, otherProps), !contextField.required && /*#__PURE__*/React.createElement(MenuItem, {
        key: "",
        value: ""
      }, "\xA0"), (_contextField$options5 = contextField.options) === null || _contextField$options5 === void 0 ? void 0 : (_contextField$options6 = _contextField$options5.inline) === null || _contextField$options6 === void 0 ? void 0 : _contextField$options6.map(function (option) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: enumValueField ? option[enumValueField] : option,
          value: enumValueField ? option[enumValueField] : option
        }, enumPromptField ? option[enumPromptField] : option);
      }));

    case 'reference':
      return /*#__PURE__*/React.createElement(FormFieldReference, _extends({
        name: name,
        margin: margin,
        variant: variant,
        size: size,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        hideLabel: hideLabel,
        inputRef: inputRef,
        disableEnterKeyCapture: disableEnterKeyCapture,
        fixedQuery: fixedQuery,
        pageSize: pageSize,
        advancedSearchColumns: advancedSearchColumns,
        advancedSearchMaxWidth: advancedSearchMaxWidth,
        contextField: contextField,
        contextValue: contextValue,
        contextResourceName: contextResourceName,
        contextHandleFieldChange: propagateChanges,
        contextFieldErrors: contextFieldErrors,
        contextHandleEnterKeyPress: contextHandleEnterKeyPress
      }, otherProps));

    case 'rich-text':
      if (!inline) {
        return /*#__PURE__*/React.createElement(FormFieldRichText, {
          label: fieldLabel,
          error: !!fieldError,
          helperText: fieldError && !inline ? fieldError.message : undefined,
          value: contextValue,
          title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText,
          onChange: function onChange(value) {
            return propagateChanges(name, value);
          }
        });
      }

    case 'text':
    case 'textarea':
    default:
      var isPasswordType = (contextField === null || contextField === void 0 ? void 0 : contextField.type) === 'password';
      var isTextAreaType = !inline && (contextField === null || contextField === void 0 ? void 0 : contextField.type) === 'textarea';
      var passwordEndAdornment = isPasswordType ? /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "toggle password visibility",
        onClick: handleClickShowPassword,
        onMouseDown: handleMouseDownPassword,
        edge: "end"
      }, showPassword ? /*#__PURE__*/React.createElement(Icon, null, "visibility_off") : /*#__PURE__*/React.createElement(Icon, null, "visibility"))) : null;
      var textEndAdornment = fieldErrorEndAdornment ? passwordEndAdornment ? /*#__PURE__*/React.createElement(React.Fragment, null, passwordEndAdornment, fieldErrorEndAdornment) : fieldErrorEndAdornment : passwordEndAdornment;
      var textInputProps = contextField !== null && contextField !== void 0 && contextField.maxLength ? _objectSpread2({
        maxLength: contextField === null || contextField === void 0 ? void 0 : contextField.maxLength
      }, (_otherProps$inputProp = otherProps === null || otherProps === void 0 ? void 0 : otherProps.inputProps) !== null && _otherProps$inputProp !== void 0 ? _otherProps$inputProp : {}) : otherProps === null || otherProps === void 0 ? void 0 : otherProps.inputProps;

      var TextInputProps = _objectSpread2({
        endAdornment: (_otherProps$InputProp9 = otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$InputProp10 = otherProps.InputProps) === null || _otherProps$InputProp10 === void 0 ? void 0 : _otherProps$InputProp10.endAdornment) !== null && _otherProps$InputProp9 !== void 0 ? _otherProps$InputProp9 : textEndAdornment
      }, (_otherProps$InputProp11 = otherProps === null || otherProps === void 0 ? void 0 : otherProps.InputProps) !== null && _otherProps$InputProp11 !== void 0 ? _otherProps$InputProp11 : {});

      var fieldType = isPasswordType ? showPassword ? 'text' : 'password' : contextField === null || contextField === void 0 ? void 0 : contextField.type;
      return /*#__PURE__*/React.createElement(TextField, _extends({
        fullWidth: true,
        label: fieldLabel,
        required: fieldRequired,
        type: fieldType,
        error: !!fieldError,
        helperText: fieldError && !inline ? fieldError.message : undefined,
        title: contextField === null || contextField === void 0 ? void 0 : contextField.helperText,
        margin: margin,
        variant: variant,
        size: size,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        value: contextValue !== null && contextValue !== void 0 ? contextValue : '',
        multiline: isTextAreaType,
        maxRows: 4,
        inputRef: inputRef,
        onChange: handleOnChange,
        onKeyPress: !isTextAreaType ? handleOnKeyPress : undefined,
        onKeyDown: contextHandleOpenTextFieldDialog ? handleTextOnKeyDown : undefined
      }, otherProps, {
        inputProps: textInputProps,
        InputProps: TextInputProps
      }));
  }
};

var FormField = function FormField(props) {
  var _formContext$fields, _formContext$data, _formContext$fieldErr;

  var name = props.name,
      margin = props.margin,
      variant = props.variant,
      size = props.size,
      disabled = props.disabled,
      readOnly = props.readOnly,
      autoFocus = props.autoFocus,
      inline = props.inline,
      onChange = props.onChange,
      fixedQuery = props.fixedQuery,
      pageSize = props.pageSize,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var formContext = useFormContext();
  var processedMargin = margin !== null && margin !== void 0 ? margin : formContext === null || formContext === void 0 ? void 0 : formContext.margin;
  var processedVariant = variant !== null && variant !== void 0 ? variant : formContext === null || formContext === void 0 ? void 0 : formContext.variant;
  var processedSize = size !== null && size !== void 0 ? size : formContext === null || formContext === void 0 ? void 0 : formContext.size;
  var contextField = formContext === null || formContext === void 0 ? void 0 : (_formContext$fields = formContext.fields) === null || _formContext$fields === void 0 ? void 0 : _formContext$fields.find(function (c) {
    return c.name === name;
  });
  var contextValue = formContext === null || formContext === void 0 ? void 0 : (_formContext$data = formContext.data) === null || _formContext$data === void 0 ? void 0 : _formContext$data[name];
  var contextResourceName = formContext === null || formContext === void 0 ? void 0 : formContext.resourceName;
  var contextHandleFieldChange = formContext === null || formContext === void 0 ? void 0 : formContext.handleFieldChange;
  var contextFieldErrors = formContext === null || formContext === void 0 ? void 0 : (_formContext$fieldErr = formContext.fieldErrors) === null || _formContext$fieldErr === void 0 ? void 0 : _formContext$fieldErr.filter(function (e) {
    return e.field === name;
  });
  var contextHandleEnterKeyPress = formContext === null || formContext === void 0 ? void 0 : formContext.handleEnterKeyPress;
  var contextHandleOpenTextFieldDialog = formContext === null || formContext === void 0 ? void 0 : formContext.handleOpenTextFieldDialog; //useWhatChanged([name, fixedQuery, contextValue, contextField, contextHandleFieldChange, contextFieldErrors]);

  return React.useMemo(function () {
    return /*#__PURE__*/React.createElement(FormFieldWithRestrictedContext, _extends({
      name: name,
      margin: processedMargin,
      variant: processedVariant,
      size: processedSize,
      disabled: disabled,
      readOnly: readOnly,
      autoFocus: autoFocus,
      inline: inline,
      onChange: onChange,
      fixedQuery: fixedQuery,
      pageSize: pageSize,
      contextField: contextField,
      contextValue: contextValue,
      contextResourceName: contextResourceName,
      contextHandleFieldChange: contextHandleFieldChange,
      contextFieldErrors: contextFieldErrors,
      contextHandleEnterKeyPress: contextHandleEnterKeyPress,
      contextHandleOpenTextFieldDialog: contextHandleOpenTextFieldDialog
    }, otherProps));
  }, [name, fixedQuery, contextValue, contextField, contextHandleFieldChange, contextFieldErrors]);
};

FormField.propTypes = {
  name: PropTypes.string.isRequired,
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  size: PropTypes.oneOf(['medium', 'small']),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  inline: PropTypes.bool,
  onChange: PropTypes.func
};

var TEXT_FIELD_SAVE_ACTION = 'save';
var TEXT_FIELD_CANCEL_ACTION = 'cancel';
var useTextFieldDialog = function useTextFieldDialog(size) {
  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      title = _React$useState2[0],
      setTitle = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      formData = _React$useState4[0],
      setFormData = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      callback = _React$useState6[0],
      setCallback = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      open = _React$useState8[0],
      setOpen = _React$useState8[1];

  var openDialog = function openDialog(title, value, callback) {
    setTitle(title);
    setFormData({
      field: value
    });
    setCallback(function () {
      return callback;
    });
    setOpen(true);
  };

  var handleOptionClick = React.useCallback(function (option) {
    setOpen(false);

    if (TEXT_FIELD_SAVE_ACTION === option) {
      callback && callback(formData === null || formData === void 0 ? void 0 : formData.field);
    }
  }, [callback, formData]);

  var handleClose = function handleClose() {
    handleOptionClick();
  };

  var handleFieldChange = function handleFieldChange(value) {
    setFormData({
      field: value
    });
  };

  var formContextValue = {
    data: formData
  };
  var dialog = /*#__PURE__*/React.createElement(OptionsDialog, {
    open: open,
    size: size,
    title: title,
    showClose: true,
    options: [[TEXT_FIELD_CANCEL_ACTION, t('dialog.textfield.action.cancel')], [TEXT_FIELD_SAVE_ACTION, t('dialog.textfield.action.save'), true]],
    onOptionClick: handleOptionClick,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: formContextValue
  }, /*#__PURE__*/React.createElement(FormField, {
    name: "field",
    hideLabel: true,
    onChange: handleFieldChange,
    multiline: true,
    maxRows: 11
  })));
  return {
    dialog: dialog,
    openDialog: openDialog
  };
};

var FormDefaultContent = function FormDefaultContent(props) {
  var fields = props.fields;
  return fields === null || fields === void 0 ? void 0 : fields.map(function (f, i) {
    return /*#__PURE__*/React.createElement(FormField, {
      key: f.name,
      name: f.name,
      sx: {
        mt: i === 0 ? 1 : 0,
        mb: 1
      }
    });
  });
};

var serverChangePropagation = false;

var logForm = function logForm(instanceId, msg) {

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
};

var useFormId = function useFormId(props) {
  var _ref = props !== null && props !== void 0 ? props : {},
      idFromProps = _ref.id;

  var formParentContext = useFormParentContext();
  return idFromProps !== undefined ? idFromProps : formParentContext === null || formParentContext === void 0 ? void 0 : formParentContext.id;
};
var useParentContextData = function useParentContextData(props) {
  var staticData = props.staticData;
  var formParentContext = useFormParentContext();
  var formId = useFormId(props);
  return {
    id: formId,
    staticData: _objectSpread2(_objectSpread2({}, formParentContext === null || formParentContext === void 0 ? void 0 : formParentContext.staticData), staticData)
  };
};

var FormContextProvider = function FormContextProvider(props) {
  var resourceName = props.resourceName,
      id = props.id,
      action = props.action,
      report = props.report,
      staticData = props.staticData,
      margin = props.margin,
      variant = props.variant,
      size = props.size,
      onDataChange = props.onDataChange,
      onFieldValueChange = props.onFieldValueChange,
      onCreate = props.onCreate,
      onUpdate = props.onUpdate,
      onDelete = props.onDelete,
      onExec = props.onExec,
      onGenerateReport = props.onGenerateReport,
      onGoBack = props.onGoBack,
      children = props.children;
  var instanceId = React.useId();

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      data = _React$useState2[0],
      setData = _React$useState2[1];

  var dataRef = React.useRef();
  dataRef.current = data;

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      modified = _React$useState4[0],
      setModified = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      locked = _React$useState6[0],
      setLocked = _React$useState6[1];

  var _React$useState7 = React.useState({}),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      fieldReferences = _React$useState8[0],
      setFieldReferences = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      fields = _React$useState10[0],
      setFields = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2);
      _React$useState12[0];
      var setFieldsStatus = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2);
      _React$useState14[0];
      var setFieldsError = _React$useState14[1];

  var _React$useState15 = React.useState(),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      fieldErrors = _React$useState16[0],
      setFieldErrors = _React$useState16[1];

  var _React$useState17 = React.useState(),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      initialData = _React$useState18[0],
      setInitialData = _React$useState18[1];

  var _React$useState19 = React.useState(),
      _React$useState20 = _slicedToArray(_React$useState19, 2);
      _React$useState20[0];
      var setInitialDataStatus = _React$useState20[1];

  var _React$useState21 = React.useState(false),
      _React$useState22 = _slicedToArray(_React$useState21, 2);
      _React$useState22[0];
      var setInitialDataError = _React$useState22[1];

  var _React$useState23 = React.useState(),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      actionResourceData = _React$useState24[0],
      setActionResourceData = _React$useState24[1];

  var _React$useState25 = React.useState(),
      _React$useState26 = _slicedToArray(_React$useState25, 2);
      _React$useState26[0];
      var setActionResourceDataStatus = _React$useState26[1];

  var _React$useState27 = React.useState(false),
      _React$useState28 = _slicedToArray(_React$useState27, 2);
      _React$useState28[0];
      var setActionResourceDataError = _React$useState28[1];

  var _React$useState29 = React.useState(),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      actionResponse = _React$useState30[0],
      setActionResponse = _React$useState30[1];

  var _React$useState31 = React.useState(),
      _React$useState32 = _slicedToArray(_React$useState31, 2),
      actionExecuted = _React$useState32[0],
      setActionExecuted = _React$useState32[1];

  var _React$useState33 = React.useState(false),
      _React$useState34 = _slicedToArray(_React$useState33, 2),
      createAllowed = _React$useState34[0],
      setCreateAllowed = _React$useState34[1];

  var _React$useState35 = React.useState(false),
      _React$useState36 = _slicedToArray(_React$useState35, 2),
      updateAllowed = _React$useState36[0],
      setUpdateAllowed = _React$useState36[1];

  var _React$useState37 = React.useState(false),
      _React$useState38 = _slicedToArray(_React$useState37, 2),
      deleteAllowed = _React$useState38[0],
      setDeleteAllowed = _React$useState38[1];

  var _React$useState39 = React.useState(),
      _React$useState40 = _slicedToArray(_React$useState39, 2);
      _React$useState40[0];
      var setFormOnChangeStatus = _React$useState40[1];

  var _React$useState41 = React.useState(),
      _React$useState42 = _slicedToArray(_React$useState41, 2);
      _React$useState42[0];
      var setFormOnChangeError = _React$useState42[1];

  var _React$useState43 = React.useState(),
      _React$useState44 = _slicedToArray(_React$useState43, 2);
      _React$useState44[0];
      var setFormActionSaveStatus = _React$useState44[1];

  var _React$useState45 = React.useState(),
      _React$useState46 = _slicedToArray(_React$useState45, 2);
      _React$useState46[0];
      var setFormActionSaveError = _React$useState46[1];

  var _React$useState47 = React.useState(),
      _React$useState48 = _slicedToArray(_React$useState47, 2);
      _React$useState48[0];
      var setFormActionDeleteStatus = _React$useState48[1];

  var _React$useState49 = React.useState(),
      _React$useState50 = _slicedToArray(_React$useState49, 2);
      _React$useState50[0];
      var setFormActionDeleteError = _React$useState50[1];

  var _React$useState51 = React.useState(),
      _React$useState52 = _slicedToArray(_React$useState51, 2);
      _React$useState52[0];
      var setFormActionExecStatus = _React$useState52[1];

  var _React$useState53 = React.useState(),
      _React$useState54 = _slicedToArray(_React$useState53, 2);
      _React$useState54[0];
      var setFormActionExecError = _React$useState54[1];

  var _useMessageDialog = useMessageDialog('sm'),
      messageDialog = _useMessageDialog.dialog,
      openMessageDialog = _useMessageDialog.openDialog;

  var _useMessageDialog2 = useMessageDialog('sm', false),
      answerRequiredDialog = _useMessageDialog2.dialog,
      openAnswerRequiredDialog = _useMessageDialog2.openDialog;

  var _useTextFieldDialog = useTextFieldDialog('md'),
      textFieldDialog = _useTextFieldDialog.dialog,
      openTextFieldDialog = _useTextFieldDialog.openDialog;

  var formParentContext = useFormParentContext();
  var handleFieldChangeRef = React.useRef();

  var _useResourceApi = useResourceApi(resourceName, openAnswerRequiredDialog),
      apiInitialized = _useResourceApi.apiInitialized,
      apiResource = _useResourceApi.apiResource,
      apiExec = _useResourceApi.exec,
      apiExecDownload = _useResourceApi.execDownload;

  var _useBaseAppContext = useBaseAppContext(),
      showTemporalMessage = _useBaseAppContext.showTemporalMessage,
      currentLanguage = _useBaseAppContext.currentLanguage,
      getPopupButton = _useBaseAppContext.getPopupButton;

  var _useParentContextData = useParentContextData({
    id: id,
    staticData: staticData
  }),
      formResourceId = _useParentContextData.id,
      mergedStaticData = _useParentContextData.staticData;

  var doReset = function doReset(data, changeInitialData) {
    logForm(instanceId, 'Resetejant informació del formulari', data, changeInitialData);
    setModified(false);
    setFieldErrors();

    if (changeInitialData) {
      var _formParentContext$on;

      setInitialData(data);
      setData(data);
      onDataChange === null || onDataChange === void 0 ? void 0 : onDataChange(data);
      formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on = formParentContext.onDataChange) === null || _formParentContext$on === void 0 ? void 0 : _formParentContext$on.call(formParentContext, data);
    } else {
      var _formParentContext$on2;

      var _data = _objectSpread2(_objectSpread2({}, initialData), _data);

      setData(_data);
      onDataChange === null || onDataChange === void 0 ? void 0 : onDataChange(_data);
      formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on2 = formParentContext.onDataChange) === null || _formParentContext$on2 === void 0 ? void 0 : _formParentContext$on2.call(formParentContext, _data);
    }
  };

  var getInitialFormData = React.useCallback(function (fields, id) {
    if (apiInitialized) {
      if (action) {
        logForm(instanceId, 'Configurant informació inicial de l\'acció amb els camps', fields);
        var _data2 = {};
        fields === null || fields === void 0 ? void 0 : fields.forEach(function (f) {
          return f.value && (_data2[f.name] = f.value);
        });
        doReset(_data2, true);
      } else if (report) {
        logForm(instanceId, 'Configurant informació inicial de l\'informe amb els camps', fields);
        var _data3 = {};
        fields === null || fields === void 0 ? void 0 : fields.forEach(function (f) {
          return f.value && (_data3[f.name] = f.value);
        });
        doReset(_data3, true);
      } else {
        if (id) {
          logForm(instanceId, 'Consultant informació inicial del recurs', id);
          apiExec('getOne', {
            data: {
              resourceId: id
            },
            callbacks: {
              setStatus: setInitialDataStatus,
              setError: setInitialDataError,
              setResponse: function setResponse(response) {
                doReset(response.data, true);
                setUpdateAllowed(!!response.links.get('update'));
                setDeleteAllowed(!!response.links.get('delete'));
              }
            },
            refresh: true
          });
        } else {
          logForm(instanceId, 'Configurant informació inicial amb els camps', fields);
          var _data4 = {};
          fields === null || fields === void 0 ? void 0 : fields.forEach(function (f) {
            return f.value && (_data4[f.name] = f.value);
          });
          doReset(_data4, true);
        }
      }
    }
  }, [apiInitialized, apiExec, formParentContext]);
  var doRevert = React.useCallback(function (force) {
    if (force) {
      doReset(initialData);
    } else {
      openMessageDialog(t('form.action.revert.title'), null, null, t('form.action.revert.confirm'), [getPopupButton('cancel', false, t('form.action.revert.cancel')), getPopupButton('revert', true, t('form.action.revert.ok'), true)], function (answerValue) {
        if (answerValue) {
          logForm('Desfent canvis', instanceId, initialData);
          doReset(initialData);
        }
      });
    }
  }, [initialData, doReset, openMessageDialog]);
  var doSave = React.useCallback(function (successCallback, errorCallback) {
    var mergedData = _objectSpread2(_objectSpread2({}, mergedStaticData), data);

    logForm(instanceId, formResourceId ? 'Modificant registre' : 'Creant registre', formResourceId, mergedData);
    setFieldErrors();
    apiExec(formResourceId ? 'update' : 'create', {
      id: formResourceId,
      data: mergedData,
      callbacks: {
        setStatus: setFormActionSaveStatus,
        setError: function setError(error) {
          showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('form.validation.error'), 'error');

          if ((error === null || error === void 0 ? void 0 : error.status) === 422) {
            var _error$errors, _formParentContext$on3;

            setFieldErrors((_error$errors = error.errors) !== null && _error$errors !== void 0 ? _error$errors : error.validationErrors);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on3 = formParentContext.onSaveError) === null || _formParentContext$on3 === void 0 ? void 0 : _formParentContext$on3.call(formParentContext, error, true);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback(error, true);
          } else {
            var _formParentContext$on4;

            setFormActionSaveError(error);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on4 = formParentContext.onSaveError) === null || _formParentContext$on4 === void 0 ? void 0 : _formParentContext$on4.call(formParentContext, error, false);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback(error, false);
          }
        },
        setResponse: function setResponse(response) {
          var _formParentContext$on5;

          var message = formResourceId ? t('form.action.update.success') : t('form.action.create.success');
          showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(message);
          var data = response.data;

          if (locked) {
            if (formResourceId) {
              doReset(data, true);
            } else {
              doReset(initialData, true);
            }
          }

          successCallback === null || successCallback === void 0 ? void 0 : successCallback(data);
          formResourceId ? onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(data) : onCreate === null || onCreate === void 0 ? void 0 : onCreate(data);
          formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on5 = formParentContext.onSaveSuccess) === null || _formParentContext$on5 === void 0 ? void 0 : _formParentContext$on5.call(formParentContext, data, locked);
        }
      }
    });
  }, [formResourceId, formParentContext, data, initialData, locked]);
  var doDelete = React.useCallback(function (successCallback, errorCallback) {
    openMessageDialog(t('form.action.delete.title'), null, null, t('form.action.delete.confirm'), [getPopupButton('cancel', false, t('form.action.delete.cancel')), getPopupButton('delete', true, t('form.action.delete.ok'), true)], function (answerValue) {
      if (answerValue) {
        logForm(instanceId, 'Esborrant element', formResourceId);
        apiExec('delete', {
          id: formResourceId,
          callbacks: {
            setStatus: function setStatus(status) {
              showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('form.action.delete.success'));
              setFormActionDeleteStatus(status);

              if (status === ASYNC_STATUS_SUCCESS) {
                var _formParentContext$on6;

                successCallback === null || successCallback === void 0 ? void 0 : successCallback();
                onDelete === null || onDelete === void 0 ? void 0 : onDelete(formResourceId);
                formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on6 = formParentContext.onDeleteSuccess) === null || _formParentContext$on6 === void 0 ? void 0 : _formParentContext$on6.call(formParentContext, formResourceId);
              }
            },
            setError: function setError(error) {
              var _formParentContext$on7;

              showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(error.message, 'error');
              errorCallback && errorCallback(error);
              setFormActionDeleteError(error);
              formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on7 = formParentContext.onDeleteError) === null || _formParentContext$on7 === void 0 ? void 0 : _formParentContext$on7.call(formParentContext, error);
            }
          }
        });
      }
    });
  }, [openMessageDialog, formResourceId, formParentContext]);
  var doExec = React.useCallback(function (successCallback, errorCallback, actionData) {
    var _ref2;

    var execData = (_ref2 = actionData !== null && actionData !== void 0 ? actionData : data) !== null && _ref2 !== void 0 ? _ref2 : {};
    logForm(instanceId, 'Executant acció', action, execData);
    apiExec('exec_' + action, {
      id: formResourceId,
      data: execData,
      callbacks: {
        setStatus: setFormActionExecStatus,
        setError: function setError(error) {
          if ((error === null || error === void 0 ? void 0 : error.status) === 422) {
            var _error$errors2, _formParentContext$on8;

            showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('form.validation.error'), 'error');
            setFieldErrors((_error$errors2 = error.errors) !== null && _error$errors2 !== void 0 ? _error$errors2 : error.validationErrors);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on8 = formParentContext.onExecError) === null || _formParentContext$on8 === void 0 ? void 0 : _formParentContext$on8.call(formParentContext, error, true);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback(error, true);
          } else {
            var _formParentContext$on9;

            showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(error.message, 'error');
            setFormActionExecError(error);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on9 = formParentContext.onExecError) === null || _formParentContext$on9 === void 0 ? void 0 : _formParentContext$on9.call(formParentContext, error, false);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback(error, false);
          }
        },
        setResponse: function setResponse(response) {
          var _formParentContext$on10;

          var isResponseDataEmptyBlob = response.data instanceof Blob && response.data.size == 0;
          var responseData = isResponseDataEmptyBlob ? null : response.data;
          !responseData && (showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('form.action.exec.success')));
          successCallback === null || successCallback === void 0 ? void 0 : successCallback(responseData);
          onExec === null || onExec === void 0 ? void 0 : onExec(responseData);
          formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on10 = formParentContext.onExecSuccess) === null || _formParentContext$on10 === void 0 ? void 0 : _formParentContext$on10.call(formParentContext, responseData);
          setActionResponse(responseData);
          setActionExecuted(true);
        }
      }
    });
  }, [formResourceId, formParentContext, data]);
  var doReportDownload = React.useCallback(function (successCallback, errorCallback, reportData) {
    var _ref3;

    var execData = (_ref3 = reportData !== null && reportData !== void 0 ? reportData : data) !== null && _ref3 !== void 0 ? _ref3 : {};
    logForm(instanceId, 'Generant informe', report, execData);
    apiExecDownload('generate_' + report, {
      id: formResourceId,
      data: execData,
      callbacks: {
        setStatus: setFormActionExecStatus,
        setError: function setError(error) {
          if ((error === null || error === void 0 ? void 0 : error.status) === 422) {
            var _error$errors3, _formParentContext$on11;

            showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(t('form.validation.error'), 'error');
            setFieldErrors((_error$errors3 = error.errors) !== null && _error$errors3 !== void 0 ? _error$errors3 : error.validationErrors);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on11 = formParentContext.onExecError) === null || _formParentContext$on11 === void 0 ? void 0 : _formParentContext$on11.call(formParentContext, error, true);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback(error, true);
          } else {
            var _formParentContext$on12;

            showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(error.message, 'error');
            setFormActionExecError(error);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on12 = formParentContext.onExecError) === null || _formParentContext$on12 === void 0 ? void 0 : _formParentContext$on12.call(formParentContext, error, false);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback(error, false);
          }
        },
        setResponse: function setResponse(response) {
          var _formParentContext$on13;

          successCallback === null || successCallback === void 0 ? void 0 : successCallback(response.data);
          onGenerateReport === null || onGenerateReport === void 0 ? void 0 : onGenerateReport(response.data);
          formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on13 = formParentContext.onGenerateReportSuccess) === null || _formParentContext$on13 === void 0 ? void 0 : _formParentContext$on13.call(formParentContext, response.data);
        }
      }
    });
  }, [formResourceId, formParentContext, data]);
  var handleFieldChange = React.useCallback(function (fieldName, value, stopPropagation) {
    var _formParentContext$on14;

    var field = fields === null || fields === void 0 ? void 0 : fields.find(function (f) {
      return f.name === fieldName;
    });
    logForm(instanceId, 'Processant modificació del camp', fieldName, value, stopPropagation);
    setData(function (prevData) {
      return _objectSpread2(_objectSpread2({}, prevData), {}, _defineProperty({}, fieldName, value));
    });
    onFieldValueChange === null || onFieldValueChange === void 0 ? void 0 : onFieldValueChange(fieldName, value);
    formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on14 = formParentContext.onFieldValueChange) === null || _formParentContext$on14 === void 0 ? void 0 : _formParentContext$on14.call(formParentContext, fieldName, value);

    if (!stopPropagation && field !== null && field !== void 0 && field.onChangeActive) {
      logForm(instanceId, 'Petició onChange pel camp', fieldName, value);

      var prevData = _objectSpread2(_objectSpread2({}, mergedStaticData), dataRef.current);

      apiExec('onChange', {
        data: {
          fieldName: fieldName,
          id: formResourceId,
          previous: prevData !== null && prevData !== void 0 ? prevData : {},
          fieldValue: value,
          current: _objectSpread2(_objectSpread2({}, prevData), {}, _defineProperty({}, fieldName, value)) // TODO eliminar a la llarga

        },
        callbacks: {
          setStatus: setFormOnChangeStatus,
          setError: function setError(error) {
            showTemporalMessage === null || showTemporalMessage === void 0 ? void 0 : showTemporalMessage(error.message, 'error');
            setFormOnChangeError(error);
          },
          setResponse: function setResponse(response) {
            var responseData = response.data;

            if (_typeof(responseData) === 'object' && responseData !== null) {
              Object.keys(responseData).forEach(function (key) {
                // No propagam els canvis si el camp que es canvia és el mateix
                // que ha originat el canvi. Així evitam bucles infinits.
                var stopPropagation = key === fieldName || !serverChangePropagation;
                logForm(instanceId, 'Propagant canvi procedent de resposta onChange per camp', fieldName, key, responseData[key], stopPropagation);
                handleFieldChange(key, responseData[key], stopPropagation);
              });
            }
          }
        }
      });
    }

    setModified(true);
  }, [fields, formResourceId, formParentContext === null || formParentContext === void 0 ? void 0 : formParentContext.onFieldValueChange]);
  var handleEnterKeyPress = React.useCallback(function () {
    doSave();
  }, [doSave]);
  var handleOpenTextFieldDialog = React.useCallback(function (fieldName) {
    var field = fields === null || fields === void 0 ? void 0 : fields.find(function (f) {
      return f.name === fieldName;
    });
    openTextFieldDialog(field.prompt, data === null || data === void 0 ? void 0 : data[fieldName], function (value) {
      setData(function (data) {
        return _objectSpread2(_objectSpread2({}, data), {}, _defineProperty({}, fieldName, value));
      });
    });
  }, [fields, data, openTextFieldDialog, setData]);
  var setFieldReference = React.useCallback(function (type, ref) {
    setFieldReferences(function (fieldReferences) {
      return _objectSpread2(_objectSpread2({}, fieldReferences), {}, _defineProperty({}, type, ref));
    });
  }, [setFieldReferences]);
  React.useEffect(function () {
    if (apiInitialized && action && formResourceId) {
      logForm(instanceId, 'Consultant informació inicial del recurs de l\'acció', formResourceId);
      apiExec('getOne', {
        data: {
          resourceId: formResourceId
        },
        callbacks: {
          setStatus: setActionResourceDataStatus,
          setError: setActionResourceDataError,
          setResponse: function setResponse(response) {
            setActionResourceData(response.data);
          }
        },
        refresh: true
      });
    }
  }, [apiInitialized, apiExec, action, formResourceId, actionResponse]);
  React.useEffect(function () {
    if (handleFieldChange) {
      handleFieldChangeRef.current = handleFieldChange;
    }
  }, [handleFieldChange]);
  React.useEffect(function () {
    if (fieldReferences['first']) {
      fieldReferences['first'].focus();
    }
  }, [fieldReferences]);
  React.useEffect(function () {
    if (apiInitialized) {
      if (action || report) {
        if (action) {
          logForm(instanceId, 'Consultant camps de l\'acció', action);
        } else {
          logForm(instanceId, 'Consultant camps de l\'informe', report);
        }
      } else {
        logForm(instanceId, 'Consultant camps del recurs', resourceName);
      }

      apiExec('fields', {
        data: action || report ? {
          action: action,
          report: report
        } : undefined,
        callbacks: {
          setStatus: setFieldsStatus,
          setResponse: function setResponse(response) {
            var _response$getEmbedded, _formParentContext$on15;

            var fields = (_response$getEmbedded = response.getEmbedded()) === null || _response$getEmbedded === void 0 ? void 0 : _response$getEmbedded.map(function (d) {
              return d.data;
            });
            logForm(instanceId, '\tCamps retornats', fields);
            setFields(fields);
            getInitialFormData(fields, formResourceId);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on15 = formParentContext.onFieldsSuccess) === null || _formParentContext$on15 === void 0 ? void 0 : _formParentContext$on15.call(formParentContext, fields);
          },
          setError: function setError(error) {
            var _formParentContext$on16;

            console.error(error);
            setFieldsError(error);
            formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on16 = formParentContext.onFieldsError) === null || _formParentContext$on16 === void 0 ? void 0 : _formParentContext$on16.call(formParentContext, error);
          }
        },
        refresh: true
      });
    }
  }, [apiInitialized, action, report, formResourceId, currentLanguage]);
  React.useEffect(function () {
    if (apiResource) {
      setCreateAllowed(!!apiResource.links.get('create'));
    }
  }, [apiResource]);
  React.useEffect(function () {
    var _formParentContext$on17;

    formParentContext === null || formParentContext === void 0 ? void 0 : (_formParentContext$on17 = formParentContext.onLockedChange) === null || _formParentContext$on17 === void 0 ? void 0 : _formParentContext$on17.call(formParentContext, locked);
  }, [locked]);
  var contextValue = {
    resourceName: resourceName,
    margin: margin,
    variant: variant,
    size: size,
    id: formResourceId,
    action: action,
    initialData: initialData,
    data: data,
    actionResourceData: actionResourceData,
    actionExecuted: actionExecuted,
    actionResponse: actionResponse,
    modified: modified,
    locked: locked,
    fields: fields,
    fieldErrors: fieldErrors,
    doReset: doReset,
    doRevert: doRevert,
    doSave: doSave,
    doDelete: doDelete,
    doExec: doExec,
    doReportDownload: doReportDownload,
    doGoBack: onGoBack,
    handleFieldChange: handleFieldChange,
    handleLockSwitch: function handleLockSwitch() {
      return setLocked(function (locked) {
        return !locked;
      });
    },
    handleEnterKeyPress: handleEnterKeyPress,
    handleOpenTextFieldDialog: handleOpenTextFieldDialog,
    setFieldReference: setFieldReference,
    createAllowed: createAllowed,
    updateAllowed: updateAllowed,
    deleteAllowed: deleteAllowed
  };
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: contextValue
  }, children, answerRequiredDialog, messageDialog, textFieldDialog);
};

var FormWithContextAccess = function FormWithContextAccess(props) {
  var titleCreate = props.titleCreate,
      titleUpdate = props.titleUpdate,
      toolbar = props.toolbar,
      apiRef = props.apiRef,
      defaultChildren = props.defaultChildren,
      children = props.children;

  var _useFormContext = useFormContext(),
      id = _useFormContext.id,
      data = _useFormContext.data,
      modified = _useFormContext.modified,
      locked = _useFormContext.locked,
      fields = _useFormContext.fields,
      doReset = _useFormContext.doReset,
      doRevert = _useFormContext.doRevert,
      doSave = _useFormContext.doSave,
      doDelete = _useFormContext.doDelete,
      doExec = _useFormContext.doExec,
      doReportDownload = _useFormContext.doReportDownload,
      doGoBack = _useFormContext.doGoBack,
      handleLockSwitch = _useFormContext.handleLockSwitch,
      setFieldReference = _useFormContext.setFieldReference,
      createAllowed = _useFormContext.createAllowed,
      updateAllowed = _useFormContext.updateAllowed,
      deleteAllowed = _useFormContext.deleteAllowed;

  var formParentContext = useFormParentContext();
  var saveAllowed = id ? updateAllowed : createAllowed;
  var showToolbar = toolbar !== null && toolbar !== void 0 ? toolbar : !formParentContext;
  React.useEffect(function () {
    if (apiRef) {
      apiRef.current = {
        doReset: doReset,
        doRevert: doRevert,
        doSave: doSave,
        doDelete: doDelete,
        doExec: doExec,
        doReportDownload: doReportDownload,
        getData: function getData() {
          return data;
        },
        doLockSwitch: handleLockSwitch,
        setFieldReference: setFieldReference,
        modified: modified
      };
    }
  }, [apiRef, doRevert, doSave, doDelete, doExec, doReportDownload, handleLockSwitch, setFieldReference, modified]);
  React.useEffect(function () {
    if (formParentContext && formParentContext.onFormRegister) {
      formParentContext.onFormRegister({
        modified: modified,
        locked: locked,
        doReset: doReset,
        doRevert: doRevert,
        doSave: doSave,
        doDelete: doDelete,
        doExec: doExec,
        doReportDownload: doReportDownload,
        getData: function getData() {
          return data;
        },
        doLockSwitch: handleLockSwitch
      });
    }
  }, [formParentContext, modified, locked, doReset, doRevert, doSave, doDelete, doExec, doReportDownload, data, handleLockSwitch]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showToolbar && /*#__PURE__*/React.createElement(FormToolbar, {
    title: id ? titleUpdate : titleCreate,
    modified: modified,
    locked: locked,
    onGoBackClick: doGoBack,
    onRevertClick: saveAllowed ? doRevert : undefined,
    onSaveClick: saveAllowed ? doSave : undefined,
    onDeleteClick: deleteAllowed ? doDelete : undefined,
    onLockClick: handleLockSwitch
  }), children !== null && children !== void 0 ? children : defaultChildren && /*#__PURE__*/React.createElement(FormDefaultContent, {
    fields: fields
  }));
};

var Form = function Form(props) {
  var resourceName = props.resourceName,
      id = props.id,
      action = props.action,
      report = props.report,
      titleCreate = props.titleCreate,
      titleUpdate = props.titleUpdate,
      staticData = props.staticData,
      margin = props.margin,
      variant = props.variant,
      size = props.size,
      toolbar = props.toolbar,
      onDataChange = props.onDataChange,
      onFieldValueChange = props.onFieldValueChange,
      onCreate = props.onCreate,
      onUpdate = props.onUpdate,
      onDelete = props.onDelete,
      onExec = props.onExec,
      onGenerateReport = props.onGenerateReport,
      onGoBack = props.onGoBack,
      apiRef = props.apiRef,
      defaultChildren = props.defaultChildren,
      children = props.children;
  return /*#__PURE__*/React.createElement(FormContextProvider, {
    resourceName: resourceName,
    id: id,
    action: action,
    report: report,
    staticData: staticData,
    margin: margin,
    variant: variant,
    size: size,
    onDataChange: onDataChange,
    onFieldValueChange: onFieldValueChange,
    onCreate: onCreate,
    onUpdate: onUpdate,
    onDelete: onDelete,
    onExec: onExec,
    onGenerateReport: onGenerateReport,
    onGoBack: onGoBack
  }, /*#__PURE__*/React.createElement(FormWithContextAccess, {
    titleCreate: titleCreate,
    titleUpdate: titleUpdate,
    toolbar: toolbar,
    defaultChildren: defaultChildren,
    apiRef: apiRef
  }, children));
};

Form.propTypes = {
  resourceName: PropTypes.string.isRequired,
  id: PropTypes.any,
  action: PropTypes.string,
  report: PropTypes.string,
  titleCreate: PropTypes.string,
  titleUpdate: PropTypes.string,
  staticData: PropTypes.object,
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  size: PropTypes.oneOf(['medium', 'small']),
  toolbar: PropTypes.bool,
  onDataChange: PropTypes.func,
  onFieldValueChange: PropTypes.func,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onExec: PropTypes.func,
  onGenerateReport: PropTypes.func,
  onGoBack: PropTypes.func,
  apiRef: PropTypes.shape({
    current: PropTypes.object
  }),
  defaultChildren: PropTypes.bool
};

var FORM_SAVE_ACTION_VALUE = 'save';
var FORM_EXEC_ACTION_VALUE = 'exec';
var FORM_GENERATE_ACTION_VALUE = 'generate';
var useFormDialog = function useFormDialog(resourceName, formChildren, actionChildren, reportChildren, events) {
  var _ref = events !== null && events !== void 0 ? events : {},
      onDataChange = _ref.onDataChange,
      onFieldValueChange = _ref.onFieldValueChange,
      onCreate = _ref.onCreate,
      onUpdate = _ref.onUpdate,
      onExec = _ref.onExec;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      id = _React$useState2[0],
      setId = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      staticData = _React$useState4[0],
      setStaticData = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      action = _React$useState6[0],
      setAction = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      report = _React$useState8[0],
      setReport = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      title = _React$useState10[0],
      setTitle = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      size = _React$useState12[0],
      setSize = _React$useState12[1];

  var _React$useState13 = React.useState(),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      callback = _React$useState14[0],
      setCallback = _React$useState14[1];

  var _React$useState15 = React.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      locked = _React$useState16[0],
      setLocked = _React$useState16[1];

  var _React$useState17 = React.useState(false),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      open = _React$useState18[0],
      setOpen = _React$useState18[1];

  var _React$useState19 = React.useState(false),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      showProgress = _React$useState20[0],
      setShowProgress = _React$useState20[1];

  var _React$useState21 = React.useState(false),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      actionExecuted = _React$useState22[0],
      setActionExecuted = _React$useState22[1];

  var _React$useState23 = React.useState(),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      actionExecutedChildren = _React$useState24[0],
      setActionExecutedChildren = _React$useState24[1];

  var _React$useState25 = React.useState(true),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      actionWithoutFields = _React$useState26[0],
      setActionWithoutFields = _React$useState26[1];

  var _React$useState27 = React.useState(false),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      reportGenerated = _React$useState28[0],
      setReportGenerated = _React$useState28[1];

  var _React$useState29 = React.useState(true),
      _React$useState30 = _slicedToArray(_React$useState29, 2);
      _React$useState30[0];
      var setReportWithoutFields = _React$useState30[1];

  var formApiRef = React.useRef();

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _useBaseAppContext = useBaseAppContext(),
      getPopupButton = _useBaseAppContext.getPopupButton;

  var openFormDialog = React.useCallback(function (id, staticData, titleCreate, titleUpdate, size, callback) {
    setId(id);
    setAction(null);
    setReport(null);
    setStaticData(staticData);
    setTitle(!id ? titleCreate : titleUpdate);
    setSize(size);
    setCallback(function () {
      return callback;
    });
    setOpen(true);
    setShowProgress(true);
    setActionExecuted(false);
    setActionExecutedChildren();
    setActionWithoutFields(false);
    setReportGenerated(false);
    setReportWithoutFields(false);
  }, []);
  var openActionDialog = React.useCallback(function (id, action, staticData, title, size, callback) {
    setId(id);
    setAction(action);
    setReport(null);
    setStaticData(staticData);
    setTitle(title);
    setSize(size);
    setCallback(function () {
      return callback;
    });
    setOpen(true);
    setShowProgress(true);
    setActionExecuted(false);
    setActionExecutedChildren();
    setActionWithoutFields(false);
    setReportGenerated(false);
    setReportWithoutFields(false);
  }, []);
  var openReportDialog = React.useCallback(function (id, report, staticData, title, size, callback) {
    setId(id);
    setAction(null);
    setReport(report);
    setStaticData(staticData);
    setTitle(title);
    setSize(size);
    setCallback(function () {
      return callback;
    });
    setOpen(true);
    setShowProgress(true);
    setActionExecuted(false);
    setActionExecutedChildren();
    setActionWithoutFields(false);
    setReportGenerated(false);
    setReportWithoutFields(false);
  }, []);

  var handleFormRegister = function handleFormRegister(formApi) {
    formApiRef.current = formApi;
  };

  var handleFieldsSuccess = React.useCallback(function (fields) {
    if (action && !(fields !== null && fields !== void 0 && fields.length)) {
      var _formApiRef$current, _formApiRef$current$d;

      setShowProgress(true);
      setActionWithoutFields(true);
      formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current = formApiRef.current) === null || _formApiRef$current === void 0 ? void 0 : (_formApiRef$current$d = _formApiRef$current.doExec) === null || _formApiRef$current$d === void 0 ? void 0 : _formApiRef$current$d.call(_formApiRef$current);
    } else if (report && !(fields !== null && fields !== void 0 && fields.length)) {
      var _formApiRef$current2, _formApiRef$current2$;

      setShowProgress(true);
      setReportWithoutFields(true);
      formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current2 = formApiRef.current) === null || _formApiRef$current2 === void 0 ? void 0 : (_formApiRef$current2$ = _formApiRef$current2.doReportDownload) === null || _formApiRef$current2$ === void 0 ? void 0 : _formApiRef$current2$.call(_formApiRef$current2);
    } else {
      setActionExecuted(false);
      setActionExecutedChildren();
      setShowProgress(false);
    }
  }, [id, action]);
  var handleFormSaveSuccess = React.useCallback(function (data) {
    setShowProgress(false);
    callback === null || callback === void 0 ? void 0 : callback(data);
    !locked && setOpen(false);
  }, [callback, locked]);
  var handleFormExecSuccess = React.useCallback(function (data) {
    setShowProgress(false);
    setActionExecuted(true);
    var response = callback === null || callback === void 0 ? void 0 : callback(data, true);

    if (response) {
      setActionExecutedChildren(response);
    } else {
      setOpen(false);
    }
  }, [id, callback]);
  var handleGenerateReportSuccess = React.useCallback(function (data) {
    setShowProgress(false);
    setReportGenerated(true);
    callback === null || callback === void 0 ? void 0 : callback(data, true);
    setOpen(false);
  }, [id, callback]);

  var handleFormError = function handleFormError() {
    setShowProgress(false);
  };

  var handleFormOptionClick = function handleFormOptionClick(value) {
    if (value === FORM_SAVE_ACTION_VALUE) {
      var _formApiRef$current3, _formApiRef$current3$;

      setShowProgress(true);
      formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current3 = formApiRef.current) === null || _formApiRef$current3 === void 0 ? void 0 : (_formApiRef$current3$ = _formApiRef$current3.doSave) === null || _formApiRef$current3$ === void 0 ? void 0 : _formApiRef$current3$.call(_formApiRef$current3);
    } else if (value === FORM_EXEC_ACTION_VALUE) {
      var _formApiRef$current4, _formApiRef$current4$;

      setShowProgress(true);
      formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current4 = formApiRef.current) === null || _formApiRef$current4 === void 0 ? void 0 : (_formApiRef$current4$ = _formApiRef$current4.doExec) === null || _formApiRef$current4$ === void 0 ? void 0 : _formApiRef$current4$.call(_formApiRef$current4);
    } else if (value === FORM_GENERATE_ACTION_VALUE) {
      var _formApiRef$current5, _formApiRef$current5$;

      setShowProgress(true);
      formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current5 = formApiRef.current) === null || _formApiRef$current5 === void 0 ? void 0 : (_formApiRef$current5$ = _formApiRef$current5.doReportDownload) === null || _formApiRef$current5$ === void 0 ? void 0 : _formApiRef$current5$.call(_formApiRef$current5);
    } else {
      setOpen(false);
    }
  };

  var handleClose = function handleClose() {
    handleFormOptionClick();
  };

  var getDialogOptions = React.useCallback(function () {
    if (action) {
      if (!actionExecuted) {
        return [getPopupButton('exec', FORM_EXEC_ACTION_VALUE, t('dialog.form.button.exec'), true, showProgress)];
      } else {
        return [getPopupButton('close', null, t('dialog.form.button.close'))];
      }
    } else if (report) {
      if (!reportGenerated) {
        return [getPopupButton('generate', FORM_GENERATE_ACTION_VALUE, t('dialog.form.button.generate'), true, showProgress)];
      } else {
        return [getPopupButton('close', null, t('dialog.form.button.close'))];
      }
    } else {
      if (id == null) {
        return [getPopupButton('close', null, t('dialog.form.button.close')), getPopupButton('create', FORM_SAVE_ACTION_VALUE, t('dialog.form.button.create'), true)];
      } else {
        return [getPopupButton('close', null, t('dialog.form.button.close')), getPopupButton('update', FORM_SAVE_ACTION_VALUE, t('dialog.form.button.update'), true)];
      }
    }
  }, [action, actionExecuted, showProgress]);
  var dialogWithFormParentContext = React.useMemo(function () {
    return /*#__PURE__*/React.createElement(FormParentProvider, {
      id: id,
      action: action,
      report: report,
      onFormRegister: handleFormRegister,
      onFieldsSuccess: handleFieldsSuccess,
      onSaveSuccess: handleFormSaveSuccess,
      onSaveError: handleFormError,
      onExecSuccess: handleFormExecSuccess,
      onExecError: handleFormError,
      onGenerateReportSuccess: handleGenerateReportSuccess,
      onGenerateReportError: handleFormError,
      onLockedChange: setLocked
    }, /*#__PURE__*/React.createElement(OptionsDialog, {
      open: open,
      size: size !== null && size !== void 0 ? size : 'md',
      loading: showProgress,
      title: title,
      additionalTitleButtons: !action && !report && /*#__PURE__*/React.createElement(FormButtons, {
        locked: locked,
        onLockClick: function onLockClick() {
          var _formApiRef$current6, _formApiRef$current6$;

          return formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current6 = formApiRef.current) === null || _formApiRef$current6 === void 0 ? void 0 : (_formApiRef$current6$ = _formApiRef$current6.doLockSwitch) === null || _formApiRef$current6$ === void 0 ? void 0 : _formApiRef$current6$.call(_formApiRef$current6);
        }
      }),
      showClose: true,
      options: getDialogOptions(),
      onOptionClick: handleFormOptionClick,
      onClose: handleClose
    }, /*#__PURE__*/React.createElement(Form, {
      resourceName: resourceName,
      staticData: staticData,
      action: action,
      report: report,
      defaultChildren: (!!action || !!report) && (!!action && !actionChildren || !!report && !reportChildren),
      toolbar: false,
      onDataChange: onDataChange,
      onFieldValueChange: onFieldValueChange,
      onCreate: onCreate,
      onUpdate: onUpdate,
      onExec: onExec
    }, action ? actionExecuted && actionExecutedChildren ? actionExecutedChildren : actionChildren : report ? reportChildren : formChildren)));
  }, [id, action, report, handleFormSaveSuccess, staticData, open, showProgress, actionWithoutFields, locked, onDataChange, onFieldValueChange, onCreate, onUpdate, onExec, formChildren, actionChildren, reportChildren]);
  return {
    dialog: dialogWithFormParentContext,
    openFormDialog: openFormDialog,
    openActionDialog: openActionDialog,
    openReportDialog: openReportDialog
  };
};

var _excluded$1 = ["id", "name"];

var GridCustomInput = function GridCustomInput(props) {
  var id = props.id,
      name = props.name,
      otherProps = _objectWithoutProperties(props, _excluded$1);

  var apiRef = useGridApiContext();

  var handleOnChange = function handleOnChange(value) {
    apiRef.current.setEditCellValue({
      id: id,
      field: name,
      value: value
    });
  };

  return /*#__PURE__*/React.createElement(FormField, _extends({
    name: name,
    variant: "standard",
    hideLabel: true,
    inline: true,
    onChange: handleOnChange
  }, otherProps, {
    sx: {
      ml: 1,
      mr: 1
    }
  }));
};

var Grid = function Grid(props) {
  var resourceName = props.resourceName,
      inlineEditable = props.inlineEditable,
      inlineFormStaticData = props.inlineFormStaticData,
      formPopupEditable = props.formPopupEditable,
      formPopupComponent = props.formPopupComponent,
      formPopupEvents = props.formPopupEvents,
      actionExecEnabled = props.actionExecEnabled,
      actionExecPopupComponent = props.actionExecPopupComponent;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentId = _React$useState2[0],
      setCurrentId = _React$useState2[1];

  var formApiRef = React.useRef();

  var _useFormDialog = useFormDialog(resourceName, formPopupComponent, actionExecPopupComponent, undefined, formPopupEvents),
      gridPopupDialog = _useFormDialog.dialog,
      openFormDialog = _useFormDialog.openFormDialog,
      openActionDialog = _useFormDialog.openActionDialog;

  var inlineRenderEditCell = function inlineRenderEditCell(params, editStartColumn) {
    var _params$colDef, _params$colDef2, _params$colDef3, _params$colDef4, _params$colDef4$formF, _params$colDef5;

    var autoFocus = editStartColumn.current && editStartColumn.current === params.field;
    return /*#__PURE__*/React.createElement(GridCustomInput, _extends({
      id: params.id,
      name: params.field,
      inline: true,
      disabled: (_params$colDef = params.colDef) === null || _params$colDef === void 0 ? void 0 : _params$colDef.inputFieldDisabled,
      readOnly: (_params$colDef2 = params.colDef) === null || _params$colDef2 === void 0 ? void 0 : _params$colDef2.inputFieldReadOnly,
      disableEnterKeyCapture: true,
      autoFocus: autoFocus
    }, typeof ((_params$colDef3 = params.colDef) === null || _params$colDef3 === void 0 ? void 0 : _params$colDef3.formFieldProps) === 'function' ? (_params$colDef4 = params.colDef) === null || _params$colDef4 === void 0 ? void 0 : (_params$colDef4$formF = _params$colDef4.formFieldProps) === null || _params$colDef4$formF === void 0 ? void 0 : _params$colDef4$formF.call(_params$colDef4, params.row) : (_params$colDef5 = params.colDef) === null || _params$colDef5 === void 0 ? void 0 : _params$colDef5.formFieldProps));
  };

  var popupActive = formPopupEditable || actionExecEnabled;
  var popupProps = popupActive ? {
    formPopupOpenFormDialog: openFormDialog,
    actionExecOpenActionDialog: openActionDialog
  } : {};
  var inlineProps = inlineEditable ? {
    inlineOnEditIdChange: setCurrentId,
    inlineFormApiRef: formApiRef,
    inlineRenderEditCell: inlineRenderEditCell
  } : {};
  var gridCoreComponent = /*#__PURE__*/React.createElement(GridCore, _extends({}, props, popupProps, inlineProps, {
    formPopupComponent: undefined,
    actionExecPopupComponent: undefined
  }));
  var gridComponent = inlineEditable ? /*#__PURE__*/React.createElement(FormParentProvider, {
    id: currentId,
    staticData: inlineFormStaticData,
    onFormRegister: function onFormRegister(formApi) {
      return formApiRef.current = formApi;
    }
  }, /*#__PURE__*/React.createElement(Form, {
    resourceName: resourceName
  }, gridCoreComponent)) : gridCoreComponent;
  return /*#__PURE__*/React.createElement(React.Fragment, null, gridComponent, popupActive ? gridPopupDialog : null);
};

Grid.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    editable: PropTypes.bool,
    flex: PropTypes.number
  })).isRequired,
  resourceName: PropTypes.string.isRequired,
  resourceFieldName: PropTypes.string,
  title: PropTypes.string,
  rows: PropTypes.array,
  fixedQuery: PropTypes.string,
  sortable: PropTypes.bool,
  fixedSortModel: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    sort: PropTypes.oneOf(['asc', 'desc'])
  })),
  defaultSortModel: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string.isRequired,
    sort: PropTypes.oneOf(['asc', 'desc']).isRequired
  })),
  selectable: PropTypes.bool,
  onSelectionChange: PropTypes.func,
  paginable: PropTypes.bool,
  quickFilter: PropTypes.bool,
  perspectives: PropTypes.array,
  height: PropTypes.number,
  autoHeight: PropTypes.bool,
  density: PropTypes.oneOf(['compact', 'standard', 'comfortable']),
  striped: PropTypes.bool,
  lovMode: PropTypes.bool,
  findQueryHref: PropTypes.string,
  apiRef: PropTypes.shape({
    current: PropTypes.object
  }),
  inlineEditable: PropTypes.bool,
  inlineFormStaticData: PropTypes.object,
  formPopupEditable: PropTypes.bool,
  formPopupComponent: PropTypes.element,
  formPopupEvents: PropTypes.object,
  formPopupTitleCreate: PropTypes.string,
  formPopupTitleUpdate: PropTypes.string,
  formPopupSize: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])]),
  formPopupStaticData: PropTypes.object,
  formRoutePath: PropTypes.string,
  actionExecEnabled: PropTypes.bool,
  actionExecPopupComponent: PropTypes.element,
  actionExecPopupSize: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])]),
  onRowClick: PropTypes.func,
  onRefresh: PropTypes.func,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onExec: PropTypes.func,
  onInlineEditIdChange: PropTypes.func,
  toolbar: PropTypes.bool,
  toolbarType: PropTypes.oneOf([TOOLBAR_TYPE_HEADER, TOOLBAR_TYPE_FORM]),
  toolbarExtraActions: PropTypes.any,
  toolbarHideExportAction: PropTypes.bool,
  toolbarHideCreateAction: PropTypes.bool,
  toolbarHideRefreshAction: PropTypes.bool,
  rowActionsColumnProps: PropTypes.object,
  rowAdditionalActions: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    showInMenu: PropTypes.bool
  }))]),
  rowHideEditAction: PropTypes.bool,
  rowHideDeleteAction: PropTypes.bool,
  rowReordering: PropTypes.bool,
  rowReorderingField: PropTypes.string,
  rowReorderingOnOrderChange: PropTypes.func,
  treeData: PropTypes.bool,
  treeDataStructureHandleRefresh: PropTypes.func,
  treeDataStructureIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  treeDataPathAttribute: PropTypes.string,
  treeDataProcessPath: PropTypes.func,
  treeDataGroupRowDataFromPath: PropTypes.func,
  treeDataGroupColumnProps: PropTypes.object,
  treeDataRowReordering: PropTypes.bool,
  treeDataRowReorderingField: PropTypes.string,
  treeDataRowReorderingSameParentOnly: PropTypes.bool,
  treeDataRowReorderingGetDragType: PropTypes.func,
  treeDataRowReorderingGetDropType: PropTypes.func,
  treeDataRowReorderingOnStructureOrderChange: PropTypes.func
};

var getAdditionalContent = function getAdditionalContent(position, toolbarAdditionalContent) {
  if (toolbarAdditionalContent) {
    var _toolbarAdditionalCon;

    return (_toolbarAdditionalCon = toolbarAdditionalContent.find(function (c) {
      return c.position === position;
    })) === null || _toolbarAdditionalCon === void 0 ? void 0 : _toolbarAdditionalCon.content;
  }
};

var ListToolbar = function ListToolbar(props) {
  var title = props.title,
      handleGoBack = props.handleGoBack,
      handleRefresh = props.handleRefresh,
      toolbarAdditionalContent = props.toolbarAdditionalContent;
  return /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true,
    sx: {
      display: 'flex',
      ml: -3,
      mr: -3,
      pl: 2,
      pr: 2,
      backgroundColor: '#efefef'
    }
  }, handleGoBack ? /*#__PURE__*/React.createElement(IconButton, {
    sx: {
      mr: 1
    },
    onClick: handleGoBack
  }, /*#__PURE__*/React.createElement(Icon, null, "arrow_back")) : null, getAdditionalContent(1, toolbarAdditionalContent), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title), getAdditionalContent(2, toolbarAdditionalContent), /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexGrow: 1
    }
  }), getAdditionalContent(3, toolbarAdditionalContent), handleRefresh ? /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleRefresh
  }, /*#__PURE__*/React.createElement(Icon, null, "refresh")) : null);
};

var ListItem = function ListItem(props) {
  var _rowStyles;

  var row = props.row,
      primaryField = props.primaryField,
      secondaryField = props.secondaryField,
      textAvatar = props.textAvatar,
      endAdornment = props.endAdornment,
      onRowClick = props.onRowClick,
      rowStyles = props.rowStyles;
  var textAvatarProcessed = textAvatar && typeof textAvatar === 'function' ? textAvatar(row) : textAvatar;
  var endAdornmentProcessed = endAdornment && typeof endAdornment === 'function' ? endAdornment(row) : endAdornment;
  var itemContent = /*#__PURE__*/React.createElement(React.Fragment, null, textAvatarProcessed && /*#__PURE__*/React.createElement(ListItemAvatar, {
    sx: onRowClick ? {} : {
      ml: 1
    }
  }, textAvatarProcessed), /*#__PURE__*/React.createElement(ListItemText, {
    primary: row[primaryField],
    secondary: row[secondaryField],
    sx: onRowClick ? {} : {
      mt: 2,
      mb: 2
    }
  }), endAdornmentProcessed);
  return /*#__PURE__*/React.createElement(ListItem$1, {
    divider: true,
    sx: _objectSpread2({
      pt: 0,
      pb: 0
    }, (_rowStyles = rowStyles === null || rowStyles === void 0 ? void 0 : rowStyles(row)) !== null && _rowStyles !== void 0 ? _rowStyles : {})
  }, onRowClick ? /*#__PURE__*/React.createElement(ListItemButton, {
    sx: {
      ml: -2,
      mr: -2
    },
    onClick: function onClick() {
      return onRowClick(row);
    }
  }, itemContent) : itemContent);
};

var List = function List(props) {
  var resourceName = props.resourceName,
      title = props.title,
      fixedQuery = props.fixedQuery,
      sort = props.sort,
      primaryField = props.primaryField,
      secondaryField = props.secondaryField,
      textAvatar = props.textAvatar,
      endAdornment = props.endAdornment,
      goBackActive = props.goBackActive,
      onRowClick = props.onRowClick,
      onRefresh = props.onRefresh,
      rowStyles = props.rowStyles,
      toolbar = props.toolbar,
      toolbarAdditionalContent = props.toolbarAdditionalContent,
      apiRef = props.apiRef;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fieldsStatus = _React$useState2[0],
      setFieldsStatus = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2);
      _React$useState4[0];
      var setFieldsError = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      fields = _React$useState6[0],
      setFields = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2);
      _React$useState8[0];
      var setFindStatus = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2);
      _React$useState10[0];
      var setFindError = _React$useState10[1];

  var _React$useState11 = React.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      rows = _React$useState12[0],
      setRows = _React$useState12[1];

  var navigate = useNavigate();

  var _useResourceApi = useResourceApi(resourceName),
      apiInitialized = _useResourceApi.apiInitialized,
      apiExec = _useResourceApi.exec;

  var handleRefresh = React.useCallback(function () {
    if (apiInitialized && fields) {
      apiExec('find', {
        data: {
          page: 'UNPAGED',
          sort: sort,
          query: fixedQuery
        },
        callbacks: {
          setStatus: setFindStatus,
          setResponse: function setResponse(response) {
            if (response) {
              var _response$getEmbedded;

              var _rows = (_response$getEmbedded = response.getEmbedded()) === null || _response$getEmbedded === void 0 ? void 0 : _response$getEmbedded.map(function (d) {
                return _objectSpread2(_objectSpread2({}, d.data), {}, {
                  _resource: d,
                  _links: d.links,
                  _templates: undefined
                });
              });

              setRows(_rows !== null && _rows !== void 0 ? _rows : []);
              onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
            }
          },
          setError: setFindError
        },
        refresh: true
      });
    }
  }, [apiInitialized, fields, apiExec, setFindStatus, setFindError, setRows, sort]);
  var handleGoBack = React.useCallback(function () {
    navigate(-1);
  }, [navigate]);
  React.useEffect(function () {
    if (apiInitialized && fieldsStatus === undefined) {
      apiExec('fields', {
        callbacks: {
          setStatus: setFieldsStatus,
          setResponse: function setResponse(response) {
            if (response) {
              var _response$getEmbedded2;

              var _fields = (_response$getEmbedded2 = response.getEmbedded()) === null || _response$getEmbedded2 === void 0 ? void 0 : _response$getEmbedded2.map(function (d) {
                return d.data;
              });

              setFields(_fields);
            }
          },
          setError: setFieldsError
        },
        refresh: true
      });
    }
  }, [apiInitialized, apiExec, setFieldsStatus, setFieldsError, setFields]);
  React.useEffect(function () {
    fields && handleRefresh();
  }, [fields]);
  React.useEffect(function () {
    if (apiRef) {
      apiRef.current = {
        doRefresh: handleRefresh
      };
    }
  }, [apiRef, handleRefresh]);
  var showToolbar = toolbar !== null && toolbar !== void 0 ? toolbar : true;
  return rows ? /*#__PURE__*/React.createElement(React.Fragment, null, showToolbar && /*#__PURE__*/React.createElement(ListToolbar, {
    title: title,
    handleGoBack: goBackActive ? handleGoBack : null,
    handleRefresh: handleRefresh,
    toolbarAdditionalContent: toolbarAdditionalContent
  }), /*#__PURE__*/React.createElement(List$1, {
    disablePadding: true,
    sx: {
      ml: -3,
      mr: -3
    }
  }, rows.map(function (r) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: r.id,
      row: r,
      primaryField: primaryField,
      secondaryField: secondaryField,
      textAvatar: textAvatar,
      endAdornment: endAdornment,
      onRowClick: onRowClick,
      rowStyles: rowStyles
    });
  }))) : null;
};

List.propTypes = {
  resourceName: PropTypes.string.isRequired,
  title: PropTypes.string,
  fixedQuery: PropTypes.string,
  sort: PropTypes.arrayOf(PropTypes.string),
  primaryField: PropTypes.string,
  secondaryField: PropTypes.string,
  textAvatar: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]),
  endAdornment: PropTypes.elementType,
  goBackActive: PropTypes.bool,
  onRowClick: PropTypes.func,
  onRefresh: PropTypes.func,
  rowStyles: PropTypes.func,
  toolbar: PropTypes.bool,
  toolbarAdditionalContent: PropTypes.arrayOf(PropTypes.object),
  apiRef: PropTypes.shape({
    current: PropTypes.object
  })
};

var useActionDialog = function useActionDialog(resourceName, params) {
  var _resource$_links;

  var _ref = params !== null && params !== void 0 ? params : {},
      id = _ref.id,
      action = _ref.action,
      staticData = _ref.staticData,
      icon = _ref.icon,
      size = _ref.size,
      actionFormChildren = _ref.actionFormChildren,
      resourceActionResponseGenerator = _ref.resourceActionResponseGenerator,
      events = _ref.events;

  var _useResourceApi = useResourceApi(resourceName),
      apiInitialized = _useResourceApi.apiInitialized,
      apiExec = _useResourceApi.exec;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      actionMenuAnchorEl = _React$useState2[0],
      setActionMenuAnchorEl = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      resource = _React$useState4[0],
      setResource = _React$useState4[1];

  var isActionLink = function isActionLink(rel) {
    return (rel === null || rel === void 0 ? void 0 : rel.startsWith('exec_')) && !(rel !== null && rel !== void 0 && rel.endsWith('/fields')) && (!action || rel === 'exec_' + action);
  };

  var actionLinks = resource === null || resource === void 0 ? void 0 : (_resource$_links = resource._links) === null || _resource$_links === void 0 ? void 0 : _resource$_links.getAll().filter(function (l) {
    return isActionLink(l.rel);
  });
  var hasActionLinks = actionLinks && actionLinks.length > 0;
  var hasMultipleActionLinks = actionLinks && actionLinks.length > 1;
  React.useEffect(function () {
    if (apiInitialized) {
      apiExec('getOne', {
        data: {
          resourceId: id
        },
        callbacks: {
          setResponse: function setResponse(response) {
            var resource = _objectSpread2(_objectSpread2({}, response.data), {}, {
              _resource: response,
              _links: response.links
            });

            setResource(resource);
          }
        },
        refresh: true
      });
    }
  }, [apiInitialized, apiExec]);

  var _useFormDialog = useFormDialog(resourceName, null, actionFormChildren, null, events),
      actionDialog = _useFormDialog.dialog,
      openActionDialog = _useFormDialog.openActionDialog;

  var handleMenuOpen = function handleMenuOpen(event) {
    event.stopPropagation();
    event.preventDefault();
    setActionMenuAnchorEl(event.target);
  };

  var handleMenuClose = function handleMenuClose() {
    setActionMenuAnchorEl();
  };

  var handleMenuActionClick = function handleMenuActionClick(rel) {
    var _link$title;

    var link = resource._links.get(rel);

    openActionDialog(resource.id, action, staticData, (_link$title = link.title) !== null && _link$title !== void 0 ? _link$title : rel.substring('exec_'.length), size, function (response, actionExecuted) {
      return resourceActionResponseGenerator === null || resourceActionResponseGenerator === void 0 ? void 0 : resourceActionResponseGenerator(resource, rel, response, actionExecuted);
    });
    setActionMenuAnchorEl();
  };

  var handleActionClick = hasMultipleActionLinks ? function (event) {
    return handleMenuOpen(event);
  } : function () {
    return handleMenuActionClick(actionLinks === null || actionLinks === void 0 ? void 0 : actionLinks[0].rel);
  };
  var actionButton = hasActionLinks ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "exec",
    onClick: handleActionClick
  }, /*#__PURE__*/React.createElement(Icon, null, hasMultipleActionLinks ? 'more_vert' : icon !== null && icon !== void 0 ? icon : 'settings')) : null;
  var actionMenu = hasActionLinks && hasMultipleActionLinks ? /*#__PURE__*/React.createElement(Menu$1, {
    id: resourceName + '-' + resource.id + '-actionMenu',
    anchorEl: actionMenuAnchorEl,
    open: !!actionMenuAnchorEl,
    onClose: function onClose() {
      return handleMenuClose();
    },
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, actionLinks === null || actionLinks === void 0 ? void 0 : actionLinks.map(function (link) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: link.rel,
      onClick: function onClick() {
        return handleMenuActionClick(link.rel);
      }
    }, link.title);
  })) : null;
  return {
    actionButton: actionButton,
    actionDialog: actionDialog,
    actionMenu: actionMenu,
    actionMenuClose: setActionMenuAnchorEl
  };
};

var useReportDialog = function useReportDialog(resourceName, params) {
  var _resource$_links;

  var _ref = params !== null && params !== void 0 ? params : {},
      id = _ref.id,
      report = _ref.report,
      staticData = _ref.staticData,
      icon = _ref.icon,
      size = _ref.size,
      reportFormChildren = _ref.reportFormChildren,
      events = _ref.events;

  var _useResourceApi = useResourceApi(resourceName),
      apiInitialized = _useResourceApi.apiInitialized,
      apiExec = _useResourceApi.exec;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      reportMenuAnchorEl = _React$useState2[0],
      setReportMenuAnchorEl = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      resource = _React$useState4[0],
      setResource = _React$useState4[1];

  var isReportLink = function isReportLink(rel) {
    return (rel === null || rel === void 0 ? void 0 : rel.startsWith('generate_')) && !(rel !== null && rel !== void 0 && rel.endsWith('/fields')) && (!report || rel === 'generate_' + report);
  };

  var reportLinks = resource === null || resource === void 0 ? void 0 : (_resource$_links = resource._links) === null || _resource$_links === void 0 ? void 0 : _resource$_links.getAll().filter(function (l) {
    return isReportLink(l.rel);
  });
  var hasReportLinks = reportLinks && reportLinks.length > 0;
  var hasMultipleReportLinks = reportLinks && reportLinks.length > 1;
  React.useEffect(function () {
    if (apiInitialized) {
      apiExec('getOne', {
        data: {
          resourceId: id
        },
        callbacks: {
          setResponse: function setResponse(response) {
            var resource = _objectSpread2(_objectSpread2({}, response.data), {}, {
              _resource: response,
              _links: response.links
            });

            setResource(resource);
          }
        },
        refresh: true
      });
    }
  }, [apiInitialized, apiExec]);

  var _useFormDialog = useFormDialog(resourceName, null, null, reportFormChildren, events),
      reportDialog = _useFormDialog.dialog,
      openReportDialog = _useFormDialog.openReportDialog;

  var handleMenuOpen = function handleMenuOpen(event) {
    event.stopPropagation();
    event.preventDefault();
    setReportMenuAnchorEl(event.target);
  };

  var handleMenuClose = function handleMenuClose() {
    setReportMenuAnchorEl();
  };

  var handleMenuReportClick = function handleMenuReportClick(rel) {
    var _link$title;

    var link = resource._links.get(rel);

    openReportDialog(resource.id, report, staticData, (_link$title = link.title) !== null && _link$title !== void 0 ? _link$title : rel.substring('generate_'.length), size);
    setReportMenuAnchorEl();
  };

  var handleReportClick = hasMultipleReportLinks ? function (event) {
    return handleMenuOpen(event);
  } : function () {
    return handleMenuReportClick(reportLinks === null || reportLinks === void 0 ? void 0 : reportLinks[0].rel);
  };
  var reportButton = hasReportLinks ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "generate",
    onClick: handleReportClick
  }, /*#__PURE__*/React.createElement(Icon, null, hasMultipleReportLinks ? 'more_vert' : icon !== null && icon !== void 0 ? icon : 'settings')) : null;
  var reportMenu = hasReportLinks && hasMultipleReportLinks ? /*#__PURE__*/React.createElement(Menu$1, {
    id: resourceName + '-' + resource.id + '-reportMenu',
    anchorEl: reportMenuAnchorEl,
    open: !!reportMenuAnchorEl,
    onClose: function onClose() {
      return handleMenuClose();
    },
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, reportLinks === null || reportLinks === void 0 ? void 0 : reportLinks.map(function (link) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: link.rel,
      onClick: function onClick() {
        return handleMenuReportClick(link.rel);
      }
    }, link.title);
  })) : null;
  return {
    reportButton: reportButton,
    reportDialog: reportDialog,
    reportMenu: reportMenu,
    reportMenuClose: setReportMenuAnchorEl
  };
};

var ContentDialogContext = /*#__PURE__*/React.createContext({});
var useContentDialogContext = function useContentDialogContext() {
  var context = React.useContext(ContentDialogContext);

  if (context === undefined) {
    throw new Error('useContentDialogContext must be used within a ContentDialogContext');
  }

  return context;
};
var useContentDialog = function useContentDialog(size) {
  var showClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      title = _React$useState2[0],
      setTitle = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      titleIcon = _React$useState4[0],
      setTitleIcon = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      titleIconColor = _React$useState6[0],
      setTitleIconColor = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      content = _React$useState8[0],
      setContent = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      options = _React$useState10[0],
      setOptions = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      callback = _React$useState12[0],
      setCallback = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      open = _React$useState14[0],
      setOpen = _React$useState14[1];

  var _React$useState15 = React.useState(),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      disableClose = _React$useState16[0],
      setDisableClose = _React$useState16[1];

  var openDialog = function openDialog(title, titleIcon, titleIconColor, content, options, callback, disableClose) {
    setTitle(title);
    setTitleIcon(titleIcon);
    setTitleIconColor(titleIconColor);
    setContent(content);
    setOptions(options);
    setCallback(function () {
      return callback;
    });
    setOpen(true);
    setDisableClose(disableClose);
  };

  var handleOptionClick = React.useCallback(function (value) {
    if (callback) {
      callback(value, function () {
        return setOpen(false);
      });
    } else {
      setOpen(false);
    }
  }, [callback, setOpen]);

  var handleClose = function handleClose() {
    if (!disableClose) {
      handleOptionClick();
    }
  };

  var dialog = /*#__PURE__*/React.createElement(OptionsDialog, {
    open: open,
    size: size,
    title: title,
    titleIcon: titleIcon,
    titleIconColor: titleIconColor,
    showClose: showClose,
    options: options,
    onOptionClick: handleOptionClick,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(ContentDialogContext.Provider, {
    value: {
      setCallback: setCallback
    }
  }, content));
  return {
    dialog: dialog,
    openDialog: openDialog
  };
};

var DIALOG_CANCEL_ACTION_VALUE = 'cancel';
var DIALOG_ADD_ACTION_VALUE = 'add';

var usePermissionUpdate$1 = function usePermissionUpdate(resourceName, resourceId, apiExec) {
  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      permissionsUpdateStatus = _React$useState2[0],
      setPermissionsUpdateStatus = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      permissionsUpdateError = _React$useState4[0],
      setPermissionsUpdateError = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      permissionsUpdateFieldErrors = _React$useState6[0],
      setPermissionsUpdateFieldErrors = _React$useState6[1];

  var doPermissionUpdate = React.useCallback(function (sidName, sidType, permissionsGranted, responseCallback) {
    setPermissionsUpdateError();
    setPermissionsUpdateFieldErrors();
    apiExec('permissionsUpdate', {
      id: resourceName,
      getOneData: {
        resourceId: resourceName,
        id: String(resourceId),
        includePermissions: true
      },
      data: {
        id: String(resourceId),
        sidName: sidName ? sidName : undefined,
        sidType: sidType,
        permissionsGranted: permissionsGranted
      },
      callbacks: {
        setStatus: setPermissionsUpdateStatus,
        setError: function setError(error) {
          if ((error === null || error === void 0 ? void 0 : error.status) === 422) {
            var _error$errors;

            setPermissionsUpdateFieldErrors((_error$errors = error.errors) !== null && _error$errors !== void 0 ? _error$errors : error.validationErrors);
          } else {
            setPermissionsUpdateError(error);
          }
        },
        setResponse: function setResponse(response) {
          responseCallback(response.data);
        }
      }
    });
  }, [resourceName, resourceId, apiExec]);
  return {
    permissionsUpdateStatus: permissionsUpdateStatus,
    permissionsUpdateError: permissionsUpdateError,
    permissionsUpdateFieldErrors: permissionsUpdateFieldErrors,
    doPermissionUpdate: doPermissionUpdate
  };
};

var PermissionResourceIdForm = function PermissionResourceIdForm(props) {
  var resourceName = props.resourceName,
      resourceId = props.resourceId,
      permissionsAllowed = props.permissionsAllowed,
      doRefresh = props.doRefresh,
      showTemporalMessage = props.showTemporalMessage;

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _useResourceApi = useResourceApi('resources'),
      apiExec = _useResourceApi.exec;

  var _useContentDialogCont = useContentDialogContext(),
      setCallback = _useContentDialogCont.setCallback;

  var _React$useState7 = React.useState({
    sidType: 'PRINCIPAL',
    sidName: '',
    read: false,
    write: false,
    create: false,
    delete: false,
    admin: false
  }),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      data = _React$useState8[0],
      setData = _React$useState8[1];

  var _usePermissionUpdate = usePermissionUpdate$1(resourceName, resourceId, apiExec),
      doPermissionUpdate = _usePermissionUpdate.doPermissionUpdate,
      permissionsUpdateError = _usePermissionUpdate.permissionsUpdateError,
      permissionsUpdateFieldErrors = _usePermissionUpdate.permissionsUpdateFieldErrors;

  var handleFieldChange = function handleFieldChange(event, field) {
    var value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setData(function (data) {
      return _objectSpread2(_objectSpread2({}, data), {}, _defineProperty({}, field, value));
    });
  };

  var dialogCallback = React.useCallback(function (value, closeCallback) {
    if (DIALOG_ADD_ACTION_VALUE === value) {
      var permissionsGranted = [];
      data.read && permissionsGranted.push('READ');
      data.write && permissionsGranted.push('WRITE');
      data.create && permissionsGranted.push('CREATE');
      data.delete && permissionsGranted.push('DELETE');
      data.admin && permissionsGranted.push('ADMINISTRATION');
      doPermissionUpdate(data.sidName, data.sidType, permissionsGranted, function () {
        showTemporalMessage(t('permission.action.add.success'));
        doRefresh();
        closeCallback();
      });
    } else {
      closeCallback();
    }
  }, [data, doRefresh]);
  React.useEffect(function () {
    setCallback(function () {
      return dialogCallback;
    });
  }, [dialogCallback]);
  React.useEffect(function () {
    if (permissionsUpdateError) {
      showTemporalMessage(permissionsUpdateError, 'error');
    }
  }, [permissionsUpdateError]);
  var sidNameFieldError = permissionsUpdateFieldErrors && permissionsUpdateFieldErrors.find(function (e) {
    return e.field === 'sidName';
  });
  return data ? /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    spacing: 2,
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(TextField, {
    select: true,
    label: t('permission.field.sidType'),
    value: data.sidType,
    onChange: function onChange(event) {
      return handleFieldChange(event, 'sidType');
    },
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "PRINCIPAL",
    value: "PRINCIPAL"
  }, t('permission.type.PRINCIPAL')), /*#__PURE__*/React.createElement(MenuItem, {
    key: "GRANTED_AUTHORITY",
    value: "GRANTED_AUTHORITY"
  }, t('permission.type.GRANTED_AUTHORITY')))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('permission.field.sidName'),
    value: data.sidName,
    onChange: function onChange(event) {
      return handleFieldChange(event, 'sidName');
    },
    error: !!sidNameFieldError,
    helperText: sidNameFieldError ? sidNameFieldError.message : undefined,
    variant: "outlined",
    required: true,
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormGroup, {
    sx: {
      ml: 2
    }
  }, (permissionsAllowed === null || permissionsAllowed === void 0 ? void 0 : permissionsAllowed.includes('READ')) && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      value: data.read,
      onChange: function onChange(event) {
        return handleFieldChange(event, 'read');
      }
    }),
    label: t('permission.field.read')
  }), (permissionsAllowed === null || permissionsAllowed === void 0 ? void 0 : permissionsAllowed.includes('WRITE')) && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      value: data.write,
      onChange: function onChange(event) {
        return handleFieldChange(event, 'write');
      }
    }),
    label: t('permission.field.write')
  }), (permissionsAllowed === null || permissionsAllowed === void 0 ? void 0 : permissionsAllowed.includes('CREATE')) && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      value: data.create,
      onChange: function onChange(event) {
        return handleFieldChange(event, 'create');
      }
    }),
    label: t('permission.field.create')
  }), (permissionsAllowed === null || permissionsAllowed === void 0 ? void 0 : permissionsAllowed.includes('DELETE')) && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      value: data.delete,
      onChange: function onChange(event) {
        return handleFieldChange(event, 'delete');
      }
    }),
    label: t('permission.field.delete')
  }), (permissionsAllowed === null || permissionsAllowed === void 0 ? void 0 : permissionsAllowed.includes('ADMINISTRATION')) && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      value: data.admin,
      onChange: function onChange(event) {
        return handleFieldChange(event, 'admin');
      }
    }),
    label: t('permission.field.admin')
  })))) : null;
};

var PermissionResourceId = function PermissionResourceId(props) {
  var resourceName = props.resourceName,
      resourceId = props.resourceId;

  var _useTranslation2 = useTranslation('components'),
      t = _useTranslation2.t;

  var _useResourceApi2 = useResourceApi('resources'),
      apiInitialized = _useResourceApi2.apiInitialized,
      apiExec = _useResourceApi2.exec;

  var _useContentDialog = useContentDialog(),
      dialog = _useContentDialog.dialog,
      openDialog = _useContentDialog.openDialog;

  var _useBaseAppContext = useBaseAppContext(),
      showTemporalMessage = _useBaseAppContext.showTemporalMessage,
      getPopupButton = _useBaseAppContext.getPopupButton;

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      resourceGetOneStatus = _React$useState10[0],
      setResourceGetOneStatus = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      resourceGetOneError = _React$useState12[0],
      setResourceGetOneError = _React$useState12[1];

  var _React$useState13 = React.useState(),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      resourceData = _React$useState14[0],
      setResourceData = _React$useState14[1];

  var _React$useState15 = React.useState(),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      permissionsAllowed = _React$useState16[0],
      setPermissionsAllowed = _React$useState16[1];

  var _React$useState17 = React.useState([]),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      gridColumns = _React$useState18[0],
      setGridColumns = _React$useState18[1];

  var _React$useState19 = React.useState([]),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      gridRows = _React$useState20[0],
      setGridRows = _React$useState20[1];

  var _usePermissionUpdate2 = usePermissionUpdate$1(resourceName, resourceId, apiExec),
      doPermissionUpdate = _usePermissionUpdate2.doPermissionUpdate,
      permissionsUpdateError = _usePermissionUpdate2.permissionsUpdateError;

  var _useMessageDialog = useMessageDialog('sm'),
      confirmMessageDialog = _useMessageDialog.dialog,
      openConfirmMessageDialog = _useMessageDialog.openDialog;

  var canUpdatePermissions = resourceData === null || resourceData === void 0 ? void 0 : resourceData.canUpdatePermissions;
  var refresh = React.useCallback(function () {
    apiExec('getOne', {
      data: {
        resourceId: resourceName,
        id: String(resourceId),
        includePermissions: true
      },
      callbacks: {
        setStatus: setResourceGetOneStatus,
        setError: setResourceGetOneError,
        setResponse: function setResponse(response) {
          var _response$data, _response$data$resour, _response$data2;

          setResourceData(response.data);
          var gridRows = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$resour = _response$data.resourceIdPermissionsGrantedList) === null || _response$data$resour === void 0 ? void 0 : _response$data$resour.map(function (p, i) {
            var _p$permissionsGranted, _p$permissionsGranted2, _p$permissionsGranted3, _p$permissionsGranted4, _p$permissionsGranted5;

            return {
              id: i,
              sidType: p.sidType,
              sidName: p.sidName,
              read: (_p$permissionsGranted = p.permissionsGranted) === null || _p$permissionsGranted === void 0 ? void 0 : _p$permissionsGranted.includes('READ'),
              write: (_p$permissionsGranted2 = p.permissionsGranted) === null || _p$permissionsGranted2 === void 0 ? void 0 : _p$permissionsGranted2.includes('WRITE'),
              create: (_p$permissionsGranted3 = p.permissionsGranted) === null || _p$permissionsGranted3 === void 0 ? void 0 : _p$permissionsGranted3.includes('CREATE'),
              delete: (_p$permissionsGranted4 = p.permissionsGranted) === null || _p$permissionsGranted4 === void 0 ? void 0 : _p$permissionsGranted4.includes('DELETE'),
              admin: (_p$permissionsGranted5 = p.permissionsGranted) === null || _p$permissionsGranted5 === void 0 ? void 0 : _p$permissionsGranted5.includes('ADMINISTRATION')
            };
          });
          setGridRows(gridRows);
          setPermissionsAllowed((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.permissionsAllowed);
        }
      },
      refresh: true
    });
  }, [apiExec, setResourceGetOneStatus, setResourceGetOneError, setResourceData, setGridRows, setPermissionsAllowed]);
  var permissionDelete = React.useCallback(function (gridRow) {
    openConfirmMessageDialog(t('permission.action.delete.title'), null, null, t('permission.action.delete.confirm'), [getPopupButton('cancel', false, t('permission.action.delete.cancel')), getPopupButton('delete', true, t('permission.action.delete.ok'), true)], function (answerValue) {
      if (answerValue) {
        doPermissionUpdate(gridRow.sidName, gridRow.sidType, [], function () {
          showTemporalMessage(t('permission.action.delete.success'));
          refresh();
        });
      }
    });
  }, [doPermissionUpdate, showTemporalMessage, refresh]);
  var permissionCheckboxChange = React.useCallback(function (id, permission, value) {
    var gridRow = gridRows[id];
    var permissionsGranted = []; // Si no hi ha permission s'esborren tots els permisos del SID.

    if (permission) {
      gridRow.read && permissionsGranted.push('READ');
      gridRow.write && permissionsGranted.push('WRITE');
      gridRow.create && permissionsGranted.push('CREATE');
      gridRow.delete && permissionsGranted.push('DELETE');
      gridRow.admin && permissionsGranted.push('ADMINISTRATION');
      var permissionIndex = permissionsGranted.indexOf(permission);

      if (value) {
        if (permissionIndex === -1) permissionsGranted.push(permission);
      } else {
        if (permissionIndex !== -1) permissionsGranted.splice(permissionIndex, 1);
      }
    }

    doPermissionUpdate(gridRow.sidName, gridRow.sidType, permissionsGranted, function (responseData) {
      setGridRows(function (gridRows) {
        return gridRows.map(function (p, i) {
          return i === id ? _objectSpread2(_objectSpread2({}, p), {}, {
            read: responseData === null || responseData === void 0 ? void 0 : responseData.includes('READ'),
            write: responseData === null || responseData === void 0 ? void 0 : responseData.includes('WRITE'),
            create: responseData === null || responseData === void 0 ? void 0 : responseData.includes('CREATE'),
            delete: responseData === null || responseData === void 0 ? void 0 : responseData.includes('DELETE'),
            admin: responseData === null || responseData === void 0 ? void 0 : responseData.includes('ADMINISTRATION')
          }) : p;
        });
      });
    });
  }, [gridRows, doPermissionUpdate]);
  var createNew = React.useCallback(function () {
    var options = [{
      value: DIALOG_CANCEL_ACTION_VALUE,
      contained: false,
      startIcon: 'clear',
      description: t('permission.dialog.option.cancel')
    }, {
      value: DIALOG_ADD_ACTION_VALUE,
      contained: true,
      startIcon: 'add',
      description: t('permission.dialog.option.add')
    }];
    openDialog(t('permission.dialog.title'), null, null, /*#__PURE__*/React.createElement(PermissionResourceIdForm, {
      resourceName: resourceName,
      resourceId: resourceId,
      permissionsAllowed: permissionsAllowed,
      doRefresh: refresh,
      showTemporalMessage: showTemporalMessage
    }), options);
  }, [openDialog, permissionsAllowed, refresh, showTemporalMessage]);
  React.useEffect(function () {
    if (apiInitialized) {
      refresh();
    }
  }, [apiInitialized, refresh]);
  React.useEffect(function () {
    if (permissionsAllowed) {
      var _gridColumns = [{
        field: 'sidType',
        headerName: t('permission.field.sidType'),
        valueFormatter: function valueFormatter(params) {
          if ('PRINCIPAL' === params.value) {
            return t('permission.type.PRINCIPAL');
          } else if ('GRANTED_AUTHORITY' === params.value) {
            return t('permission.type.GRANTED_AUTHORITY');
          } else {
            return '';
          }
        },
        flex: 1
      }, {
        field: 'sidName',
        headerName: t('permission.field.sidName'),
        flex: 4
      }];

      if (permissionsAllowed.includes('READ')) {
        _gridColumns.push({
          field: 'read',
          headerName: t('permission.field.read'),
          renderCell: function renderCell(params) {
            return /*#__PURE__*/React.createElement(Checkbox, {
              checked: params.value,
              onClick: function onClick(event) {
                return permissionCheckboxChange(params.id, 'READ', event.target.checked);
              }
            });
          },
          flex: 1
        });
      }

      if (permissionsAllowed.includes('WRITE')) {
        _gridColumns.push({
          field: 'write',
          headerName: t('permission.field.write'),
          renderCell: function renderCell(params) {
            return /*#__PURE__*/React.createElement(Checkbox, {
              checked: params.value,
              onClick: function onClick(event) {
                return permissionCheckboxChange(params.id, 'WRITE', event.target.checked);
              }
            });
          },
          flex: 1
        });
      }

      if (permissionsAllowed.includes('CREATE')) {
        _gridColumns.push({
          field: 'create',
          headerName: t('permission.field.create'),
          renderCell: function renderCell(params) {
            return /*#__PURE__*/React.createElement(Checkbox, {
              checked: params.value,
              onClick: function onClick(event) {
                return permissionCheckboxChange(params.id, 'CREATE', event.target.checked);
              }
            });
          },
          flex: 1
        });
      }

      if (permissionsAllowed.includes('DELETE')) {
        _gridColumns.push({
          field: 'delete',
          headerName: t('permission.field.delete'),
          renderCell: function renderCell(params) {
            return /*#__PURE__*/React.createElement(Checkbox, {
              checked: params.value,
              onClick: function onClick(event) {
                return permissionCheckboxChange(params.id, 'DELETE', event.target.checked);
              }
            });
          },
          flex: 1
        });
      }

      if (permissionsAllowed.includes('ADMINISTRATION')) {
        _gridColumns.push({
          field: 'admin',
          headerName: t('permission.field.admin'),
          renderCell: function renderCell(params) {
            return /*#__PURE__*/React.createElement(Checkbox, {
              checked: params.value,
              onClick: function onClick(event) {
                return permissionCheckboxChange(params.id, 'ADMINISTRATION', event.target.checked);
              }
            });
          },
          flex: 1
        });
      }

      _gridColumns.push({
        field: ' ',
        type: 'actions',
        getActions: function getActions(params) {
          return [/*#__PURE__*/React.createElement(GridActionsCellItem$1, {
            icon: /*#__PURE__*/React.createElement(Icon, null, "delete"),
            onClick: function onClick() {
              return permissionDelete(params.row);
            },
            label: t('permission.action.delete.label')
          })];
        },
        flex: .5
      });

      setGridColumns(_gridColumns);
    }
  }, [permissionsAllowed, permissionCheckboxChange]);
  React.useEffect(function () {
    if (resourceGetOneError) {
      showTemporalMessage(resourceGetOneError, 'error');
    }
  }, [resourceGetOneError]);
  React.useEffect(function () {
    if (permissionsUpdateError) {
      showTemporalMessage(permissionsUpdateError, 'error');
    }
  }, [permissionsUpdateError]);
  return canUpdatePermissions ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      flexGrow: 1
    }
  }, t('permission.title')), /*#__PURE__*/React.createElement(IconButton, {
    title: t('permission.action.add.label'),
    onClick: function onClick() {
      return createNew();
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "add")), /*#__PURE__*/React.createElement(IconButton, {
    title: t('permission.action.refresh'),
    onClick: function onClick() {
      return refresh();
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "refresh"))), /*#__PURE__*/React.createElement(DataGrid, {
    rows: gridRows,
    columns: gridColumns,
    hideFooter: true,
    autoHeight: true,
    loading: resourceGetOneStatus === ASYNC_STATUS_PENDING,
    components: {
      LoadingOverlay: LinearProgress,
      NoRowsOverlay: GridNoRowsOverlay
    }
  }), dialog, confirmMessageDialog) : null;
};

var usePermissionUpdate = function usePermissionUpdate(module, role, apiExec) {
  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      permissionsUpdateStatus = _React$useState2[0],
      setPermissionsUpdateStatus = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      permissionsUpdateError = _React$useState4[0],
      setPermissionsUpdateError = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      permissionsUpdateFieldErrors = _React$useState6[0],
      setPermissionsUpdateFieldErrors = _React$useState6[1];

  var doPermissionUpdate = React.useCallback(function (resourceName, permissionsGranted, responseCallback) {
    setPermissionsUpdateError();
    setPermissionsUpdateFieldErrors();
    apiExec('permissionsUpdate', {
      id: resourceName,
      getOneData: {
        resourceId: resourceName,
        module: module,
        role: role,
        includePermissions: true,
        noParentOnly: true,
        includeAll: true
      },
      data: {
        module: module,
        sidType: 'GRANTED_AUTHORITY',
        sidName: role,
        permissionsGranted: permissionsGranted
      },
      callbacks: {
        setStatus: setPermissionsUpdateStatus,
        setError: function setError(error) {
          if ((error === null || error === void 0 ? void 0 : error.status) === 422) {
            var _error$errors;

            setPermissionsUpdateFieldErrors((_error$errors = error.errors) !== null && _error$errors !== void 0 ? _error$errors : error.validationErrors);
          } else {
            setPermissionsUpdateError(error);
          }
        },
        setResponse: function setResponse(response) {
          responseCallback(response.data);
        }
      }
    });
  }, [module, role, apiExec]);
  return {
    permissionsUpdateStatus: permissionsUpdateStatus,
    permissionsUpdateError: permissionsUpdateError,
    permissionsUpdateFieldErrors: permissionsUpdateFieldErrors,
    doPermissionUpdate: doPermissionUpdate
  };
};

var PermissionResourceModule = function PermissionResourceModule(props) {
  var module = props.module,
      role = props.role;

  var _useTranslation = useTranslation('components'),
      t = _useTranslation.t;

  var _useResourceApi = useResourceApi('resources'),
      apiInitialized = _useResourceApi.apiInitialized,
      apiExec = _useResourceApi.exec;

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      resourceFindStatus = _React$useState8[0],
      setResourceFindStatus = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      resourceFindError = _React$useState10[0],
      setResourceFindError = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      gridRows = _React$useState12[0],
      setGridRows = _React$useState12[1];

  var _React$useState13 = React.useState([]),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      gridColumns = _React$useState14[0],
      setGridColumns = _React$useState14[1];

  var _useBaseAppContext = useBaseAppContext(),
      showTemporalMessage = _useBaseAppContext.showTemporalMessage;

  var _usePermissionUpdate = usePermissionUpdate(module, role, apiExec),
      doPermissionUpdate = _usePermissionUpdate.doPermissionUpdate;

  var refresh = React.useCallback(function () {
    if (role) {
      setGridRows();
      apiExec('find', {
        data: {
          module: module,
          role: role,
          includePermissions: true,
          noParentOnly: true,
          includeAll: true
        },
        callbacks: {
          setStatus: setResourceFindStatus,
          setError: setResourceFindError,
          setResponse: function setResponse(response) {
            var _response$embedded;

            setGridRows((_response$embedded = response.embedded) === null || _response$embedded === void 0 ? void 0 : _response$embedded.map(function (e, i) {
              return _objectSpread2({
                id: i
              }, e.data);
            }));
          }
        },
        refresh: true
      });
    }
  }, [apiExec, module, role]);
  var permissionCheckboxChange = React.useCallback(function (id, permission, value) {
    var gridRow = gridRows[id];
    var permissionsGranted = []; // Si no hi ha permission s'esborren tots els permisos del SID.

    if (permission) {
      permissionsGranted.push.apply(permissionsGranted, _toConsumableArray(gridRow.permissionsGranted));

      if (value) {
        permissionsGranted.push(permission);
      } else {
        var index = permissionsGranted.indexOf(permission);
        if (index != -1) permissionsGranted.splice(index, 1);
      }
    }

    doPermissionUpdate(gridRow.name, permissionsGranted, function (responseData) {
      setGridRows(function (gridRows) {
        return gridRows.map(function (p, i) {
          return i === id ? _objectSpread2(_objectSpread2({}, p), {}, {
            permissionsGranted: responseData
          }) : p;
        });
      });
    });
  }, [gridRows]);
  React.useEffect(function () {
    if (apiInitialized) {
      refresh();
    }
  }, [apiInitialized, refresh]);
  var permissionRenderCell = React.useCallback(function (params, permission) {
    var permissionsAllowed = params.row.permissionsAllowed;
    var permissionsGranted = params.row.permissionsGranted;
    return permissionsAllowed !== null && permissionsAllowed !== void 0 && permissionsAllowed.includes(permission) ? /*#__PURE__*/React.createElement(Checkbox, {
      checked: permissionsGranted === null || permissionsGranted === void 0 ? void 0 : permissionsGranted.includes(permission),
      onClick: function onClick(event) {
        return permissionCheckboxChange(params.id, permission, event.target.checked);
      }
    }) : null;
  }, [gridRows]);
  React.useEffect(function () {
    var gridColumns = [{
      field: 'description',
      headerName: t('permission.field.sidName'),
      flex: 4
    }, {
      field: 'read',
      headerName: t('permission.field.read'),
      renderCell: function renderCell(params) {
        return permissionRenderCell(params, 'READ');
      },
      flex: 1
    }, {
      field: 'write',
      headerName: t('permission.field.write'),
      renderCell: function renderCell(params) {
        return permissionRenderCell(params, 'WRITE');
      },
      flex: 1
    }, {
      field: 'create',
      headerName: t('permission.field.create'),
      renderCell: function renderCell(params) {
        return permissionRenderCell(params, 'CREATE');
      },
      flex: 1
    }, {
      field: 'delete',
      headerName: t('permission.field.delete'),
      renderCell: function renderCell(params) {
        return permissionRenderCell(params, 'DELETE');
      },
      flex: 1
    }];
    var rowsWithAdditionalPermissions = gridRows === null || gridRows === void 0 ? void 0 : gridRows.filter(function (r) {
      var _r$permissionsAllowed;

      var additionalPermissions = (_r$permissionsAllowed = r.permissionsAllowed) === null || _r$permissionsAllowed === void 0 ? void 0 : _r$permissionsAllowed.filter(function (p) {
        return p !== 'READ' && p !== 'WRITE' && p !== 'CREATE' && p !== 'DELETE';
      });
      return additionalPermissions && additionalPermissions.length;
    });

    if (rowsWithAdditionalPermissions && rowsWithAdditionalPermissions.length) {
      gridColumns.push({
        field: ' ',
        headerName: t('permission.field.others'),
        renderCell: function renderCell(params) {
          var _params$row$permissio, _params$row$permissio2;

          var additionalPermissions = (_params$row$permissio = params.row.permissionsAllowed) === null || _params$row$permissio === void 0 ? void 0 : _params$row$permissio.filter(function (p) {
            return p !== 'READ' && p !== 'WRITE' && p !== 'CREATE' && p !== 'DELETE';
          });
          var additionalPermissionsGranted = (_params$row$permissio2 = params.row.permissionsGranted) === null || _params$row$permissio2 === void 0 ? void 0 : _params$row$permissio2.filter(function (p) {
            return p !== 'READ' && p !== 'WRITE' && p !== 'CREATE' && p !== 'DELETE';
          });

          var _React$useState15 = React.useState(additionalPermissionsGranted),
              _React$useState16 = _slicedToArray(_React$useState15, 2),
              value = _React$useState16[0],
              setValue = _React$useState16[1];

          if (additionalPermissions && additionalPermissions.length > 0) {
            return /*#__PURE__*/React.createElement(TextField, {
              select: true,
              value: value,
              onChange: function onChange(event) {
                gridRows[params.id];

                if (event.target.value.length > value.length) {
                  var diff = event.target.value.filter(function (p) {
                    return !value.includes(p);
                  });
                  permissionCheckboxChange(params.id, diff[0], true);
                } else {
                  var _diff = value.filter(function (p) {
                    return !event.target.value.includes(p);
                  });

                  permissionCheckboxChange(params.id, _diff[0], false);
                }

                setValue(event.target.value);
              },
              variant: "standard",
              fullWidth: true,
              SelectProps: {
                multiple: true,
                renderValue: function renderValue(selected) {
                  return selected.join(', ');
                }
              }
            }, additionalPermissions.map(function (p) {
              return /*#__PURE__*/React.createElement(MenuItem, {
                key: p,
                value: p
              }, /*#__PURE__*/React.createElement(Checkbox, {
                checked: value.includes(p)
              }), /*#__PURE__*/React.createElement(ListItemText, {
                primary: p
              }));
            }));
          }
        },
        flex: 2
      });
    }

    setGridColumns(gridColumns);
  }, [gridRows, permissionRenderCell]);
  React.useEffect(function () {
    if (resourceFindError) {
      showTemporalMessage(resourceFindError, 'error');
    }
  }, [resourceFindError]);
  return gridRows ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      flexGrow: 1
    }
  }, t('permission.title')), /*#__PURE__*/React.createElement(IconButton, {
    title: t('permission.action.refresh'),
    onClick: function onClick() {
      return refresh();
    }
  }, /*#__PURE__*/React.createElement(Icon, null, "refresh"))), /*#__PURE__*/React.createElement(DataGrid, {
    rows: gridRows,
    columns: gridColumns,
    hideFooter: true,
    autoHeight: true,
    loading: resourceFindStatus === ASYNC_STATUS_PENDING,
    components: {
      LoadingOverlay: LinearProgress,
      NoRowsOverlay: GridNoRowsOverlay
    }
  })) : null;
};

var _excluded = ["to", "children"];

var ButtonLink = function ButtonLink(props) {
  var to = props.to,
      children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({
    component: Link,
    to: to
  }, otherProps), children);
};

var componentsCa = {
  baseapp: {
    menu: {
      home: 'Inici'
    },
    auth: {
      logout: 'Tancar sessió'
    },
    error: {
      '404': 'No trobat',
      '503': 'Sense connexió'
    }
  },
  grid: {
    toolbar: {
      download: 'Descarregar',
      refresh: 'Refrescar',
      create: 'Crear'
    },
    column: {
      treeGroup: 'Grup'
    },
    action: {
      delete: {
        title: 'Esborrar element',
        confirm: 'Estau segur que voleu esborrar aquest element (aquesta acció no es pot desfer)?',
        cancel: 'Cancel.la',
        ok: 'D\'acord',
        success: 'Element esborrat'
      },
      sort: {
        success: 'Element reordenat'
      }
    },
    button: {
      update: 'Modificar',
      delete: 'Esborrar',
      cancel: 'Cancel·lar',
      save: 'Desar'
    },
    empty: 'Sense dades'
  },
  form: {
    action: {
      create: {
        success: 'Element creat'
      },
      update: {
        success: 'Element modificat'
      },
      delete: {
        title: 'Esborrar element',
        confirm: 'Estau segur que voleu esborrar aquest element (aquesta acció no es pot desfer)?',
        cancel: 'Cancel.la',
        ok: 'D\'acord',
        success: 'Element esborrat'
      },
      exec: {
        success: 'Acció executada correctament'
      },
      revert: {
        title: 'Desfer canvis',
        confirm: 'Estau segur que voleu desfer els canvis fets al formulari?',
        cancel: 'Cancel.la',
        ok: 'D\'acord'
      }
    },
    buttons: {
      revert: {
        title: 'Desfer canvis'
      },
      lock: {
        title: 'Activi aquesta opció per a crear múltiples registres sense sortir de la finestra'
      },
      save: {
        title: 'Desar'
      },
      delete: {
        title: 'Esborrar'
      }
    },
    validation: {
      error: 'S\'han produït errors de validació'
    },
    field: {
      reference: {
        loading: 'Carregant...',
        noOptions: 'Sense opcions',
        clear: 'Esborrar',
        close: 'Tancar',
        open: 'Obrir',
        pageMessage: 'Mostrant {{size}} de {{totalElements}} elements',
        advanced: {
          select: 'Seleccionar',
          cancel: 'Cancel·lar'
        }
      }
    }
  },
  dialog: {
    form: {
      button: {
        save: 'Desar',
        exec: 'Executar',
        generate: 'Generar',
        close: 'Tancar',
        create: 'Crear',
        update: 'Actualitzar'
      }
    },
    textfield: {
      action: {
        save: 'Desar',
        cancel: 'Cancel·lar'
      }
    }
  },
  permission: {
    title: 'Permisos',
    field: {
      sidType: 'Tipus',
      sidName: 'Nom',
      read: 'Llegir',
      write: 'Modificar',
      create: 'Crear',
      delete: 'Esborrar',
      admin: 'Administrar',
      others: 'Altres'
    },
    type: {
      PRINCIPAL: 'Principal',
      GRANTED_AUTHORITY: 'Granted authority'
    },
    action: {
      refresh: 'Refrescar',
      add: {
        label: 'Afegir nou permís',
        success: 'Permís afegit'
      },
      delete: {
        title: 'Esborrar element',
        confirm: 'Estau segur que voleu esborrar aquest element (aquesta acció no es pot desfer)?',
        cancel: 'Cancel.la',
        ok: 'D\'acord',
        label: 'Esborrar',
        success: 'Permís esborrat'
      }
    },
    dialog: {
      title: 'Afegir nou permís',
      option: {
        cancel: 'Cancel·lar',
        add: 'Afegir'
      }
    }
  },
  hook: {
    resourceApi: {
      options: {
        title: 'Atenció',
        ok: 'D\'acord',
        cancel: 'Cancel·lar'
      }
    }
  }
};

var componentsEn = {
  baseapp: {
    menu: {
      home: 'Home'
    },
    auth: {
      logout: 'Log out'
    },
    error: {
      '404': 'Not found',
      '503': 'No connection'
    }
  },
  grid: {
    toolbar: {
      download: 'Download',
      refresh: 'Refresh',
      create: 'Create'
    },
    column: {
      treeGroup: 'Group'
    },
    action: {
      delete: {
        title: 'Delete item',
        confirm: 'Are you sure you want to delete this item (this action can not be undone)?',
        cancel: 'Cancel',
        ok: 'Ok',
        success: 'Element deleted'
      },
      sort: {
        success: 'Element sorted'
      }
    },
    button: {
      update: 'Update',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save'
    },
    empty: 'No data'
  },
  form: {
    action: {
      create: {
        success: 'Element created'
      },
      update: {
        success: 'Element updated'
      },
      delete: {
        title: 'Delete item',
        confirm: 'Are you sure you want to delete this item (this action can not be undone)?',
        cancel: 'Cancel',
        ok: 'Ok',
        success: 'Element deleted'
      },
      exec: {
        success: 'Action executed successfully'
      },
      revert: {
        title: 'Undo changes',
        confirm: 'Are you sure you want to revert the changes in the form?',
        cancel: 'Cancel',
        ok: 'Ok'
      }
    },
    buttons: {
      revert: {
        title: 'Revert changes'
      },
      lock: {
        title: 'Activate this option to create multiple registers without exiting this window'
      },
      save: {
        title: 'Save'
      },
      delete: {
        title: 'Delete'
      }
    },
    validation: {
      error: 'There are validation errors'
    },
    field: {
      reference: {
        loading: 'Loading...',
        noOptions: 'No options',
        clear: 'Clear',
        close: 'Close',
        open: 'Open',
        pageMessage: 'Showing {{size}} out of {{totalElements}} elements',
        advanced: {
          select: 'Select',
          cancel: 'Cancel'
        }
      }
    }
  },
  dialog: {
    form: {
      button: {
        save: 'Save',
        exec: 'Execute',
        generate: 'Generate',
        close: 'Close',
        create: 'Create',
        update: 'Update'
      }
    },
    textfield: {
      action: {
        save: 'Save',
        cancel: 'Cancel'
      }
    }
  },
  permission: {
    title: 'Permission',
    field: {
      sidType: 'Type',
      sidName: 'Name',
      read: 'Read',
      write: 'Write',
      create: 'Create',
      delete: 'Delete',
      admin: 'Administer',
      others: 'Others'
    },
    type: {
      PRINCIPAL: 'Principal',
      GRANTED_AUTHORITY: 'Granted authority'
    },
    action: {
      refresh: 'Refresh',
      add: {
        label: 'Add new permission',
        success: 'Permission added'
      },
      delete: {
        title: 'Delete item',
        confirm: 'Are you sure you want to delete this item (this action can not be undone)?',
        cancel: 'Cancel',
        ok: 'Ok',
        label: 'Delete',
        success: 'Permission deleted'
      }
    },
    dialog: {
      title: 'Add new permission',
      option: {
        cancel: 'Cancel',
        add: 'Add'
      }
    }
  },
  hook: {
    resourceApi: {
      options: {
        title: 'Attention',
        ok: 'Ok',
        cancel: 'Cancel'
      }
    }
  }
};

var componentsEs = {
  baseapp: {
    menu: {
      home: 'Inicio'
    },
    auth: {
      logout: 'Cerrar sesión'
    },
    error: {
      '404': 'No encontrado',
      '503': 'Sin connexión'
    }
  },
  grid: {
    toolbar: {
      download: 'Descargar',
      refresh: 'Refrescar',
      create: 'Crear'
    },
    column: {
      treeGroup: 'Grupo'
    },
    action: {
      delete: {
        title: 'Borrar elemento',
        confirm: '¿Está seguro de que quiere borrar este elemento (esta acción no se puede deshacer)?',
        cancel: 'Cancelar',
        ok: 'De acuerdo',
        success: 'Elemento borrado'
      },
      sort: {
        success: 'Elemento eliminado'
      }
    },
    button: {
      update: 'Modificar',
      delete: 'Borrar',
      cancel: 'Cancelar',
      save: 'Guardar'
    },
    empty: 'Sin datos'
  },
  form: {
    action: {
      create: {
        success: 'Elemento creado'
      },
      update: {
        success: 'Elemento modificado'
      },
      delete: {
        title: 'Borrar elemento',
        confirm: '¿Está seguro de que quiere borrar este elemento (esta acción no se puede deshacer)?',
        cancel: 'Cancelar',
        ok: 'De acuerdo',
        success: 'Elemento borrado'
      },
      exec: {
        success: 'Acción ejecutada correctamente'
      },
      revert: {
        title: 'Deshacer cambios',
        confirm: '¿Está seguro de que quiere deshacer los cambios hechos al formulario?',
        cancel: 'Cancelar',
        ok: 'De acuerdo'
      }
    },
    buttons: {
      revert: {
        title: 'Deshacer cambios'
      },
      lock: {
        title: 'Active esta opción para crear múltiples registros sin salir de la ventana'
      },
      save: {
        title: 'Guardar'
      },
      delete: {
        title: 'Borrar'
      }
    },
    validation: {
      error: 'Se han producido errores de validación'
    },
    field: {
      reference: {
        loading: 'Cargando...',
        noOptions: 'Sin opciones',
        clear: 'Borrar',
        close: 'Cerrar',
        open: 'Abrir',
        pageMessage: 'Mostrando {{size}} de {{totalElements}} elementos',
        advanced: {
          select: 'Seleccionar',
          cancel: 'Cancelar'
        }
      }
    }
  },
  dialog: {
    form: {
      button: {
        save: 'Guardar',
        exec: 'Ejecutar',
        generate: 'Generar',
        close: 'Cerrar',
        create: 'Crear',
        update: 'Actualizar'
      }
    },
    textfield: {
      action: {
        save: 'Guardar',
        cancel: 'Cancelar'
      }
    }
  },
  permission: {
    title: 'Permisos',
    field: {
      sidType: 'Tipo',
      sidName: 'Nombre',
      read: 'Leer',
      write: 'Modificar',
      create: 'Crear',
      delete: 'Borrar',
      admin: 'Administrar',
      others: 'Otros'
    },
    type: {
      PRINCIPAL: 'Principal',
      GRANTED_AUTHORITY: 'Granted authority'
    },
    action: {
      refresh: 'Refrescar',
      add: {
        label: 'Añadir nuevo permiso',
        success: 'Permiso añadido'
      },
      delete: {
        title: 'Borrar elemento',
        confirm: '¿Está seguro de que quiere borrar este elemento (esta acción no se puede deshacer)?',
        cancel: 'Cancelar',
        ok: 'De acuerdo',
        label: 'Borrar',
        success: 'Permiso borrado'
      }
    },
    dialog: {
      title: 'Añadir nuevo permiso',
      option: {
        cancel: 'Cancelar',
        add: 'Añadir'
      }
    }
  },
  hook: {
    resourceApi: {
      options: {
        title: 'Atención',
        ok: 'De acuerdo',
        cancel: 'Cancelar'
      }
    }
  }
};

var addComponentResourceBundles = function addComponentResourceBundles(i18n) {
  i18n.addResourceBundle('ca', 'components', componentsCa);
  i18n.addResourceBundle('es', 'components', componentsEs);
  i18n.addResourceBundle('en', 'components', componentsEn);
};

var getWidth = function getWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

var useCurrentWidth = function useCurrentWidth() {
  // save current window width in the state object
  var _React$useState = React.useState(getWidth()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      width = _React$useState2[0],
      setWidth = _React$useState2[1]; // in this case useEffect will execute only once because
  // it does not have any dependencies.


  React.useEffect(function () {
    // timeoutId for debounce mechanism
    var timeoutId = null;

    var resizeListener = function resizeListener() {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId); // change width from the state object after 100 milliseconds

      timeoutId = setTimeout(function () {
        return setWidth(getWidth());
      }, 100);
    }; // set resize listener


    window.addEventListener('resize', resizeListener); // clean up function

    return function () {
      // remove resize listener
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  return width;
};

var useExcelPaste = function useExcelPaste(callback, ref) {
  useEffect(function () {
    var handlePasteAnywhere = function handlePasteAnywhere(event) {
      var text = event.clipboardData.getData('text');
      var rows = text.trim().split(/\r\n|\n|\r/).map(function (row) {
        return row.split('\t');
      });
      callback(rows);
    };

    var element = ref ? ref.current : window;
    element.addEventListener('paste', handlePasteAnywhere);
    return function () {
      element.removeEventListener('paste', handlePasteAnywhere);
    };
  }, [callback, ref]);
};

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

var autoLogin = true;

var logKeycloakAuth = function logKeycloakAuth(instanceId, msg) {

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
};

var NestedKeycloakAuthProvider = function NestedKeycloakAuthProvider(props) {
  var instanceId = React.useId();
  var keycloakEventHandlerRef = props.keycloakEventHandlerRef,
      children = props.children;

  var _useKeycloak = useKeycloak(),
      keycloak = _useKeycloak.keycloak,
      initialized = _useKeycloak.initialized;

  var _React$useState = React.useState({
    initialized: initialized
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      authInfo = _React$useState2[0],
      setAuthInfo = _React$useState2[1];

  var currentAuthInfo = function currentAuthInfo(keycloak, initialized) {
    return {
      initialized: initialized,
      loggedIn: initialized ? keycloak === null || keycloak === void 0 ? void 0 : keycloak.authenticated : undefined,
      authToken: initialized ? keycloak === null || keycloak === void 0 ? void 0 : keycloak.token : undefined,
      userProfile: initialized && keycloak !== null && keycloak !== void 0 && keycloak.tokenParsed ? {
        id: keycloak.tokenParsed.preferred_username,
        name: keycloak.tokenParsed.name,
        givenName: keycloak.tokenParsed.given_name,
        familyName: keycloak.tokenParsed.family_name,
        imageUrl: keycloak.tokenParsed.picture,
        email: keycloak.tokenParsed.email
      } : undefined,
      login: keycloak === null || keycloak === void 0 ? void 0 : keycloak.login,
      logout: keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout
    };
  };

  var handleKeycloakEvent = React.useCallback(function (event, error) {
    if (event === 'onAuthRefreshSuccess') {
      var _authInfo = currentAuthInfo(keycloak, initialized);

      logKeycloakAuth(instanceId, 'Processing onAuthRefreshSuccess event', _authInfo);
      setAuthInfo(_authInfo);
    } else if (event === 'onAuthRefreshError') {
      logKeycloakAuth(instanceId, 'Processing onAuthRefreshError event'); // Hi ha un moment en el qual ja no es pot refrescar més el token automàticament i, quan
      // això passa, s'arriba aquí. Aquest temps es configura a Keycloak al realm amb el
      // paràmetre SSO Session Max i per defecte te un valor de 10 hores.

      if (!(keycloak !== null && keycloak !== void 0 && keycloak.authenticated)) {
        var _keycloak$logout;

        keycloak === null || keycloak === void 0 ? void 0 : (_keycloak$logout = keycloak.logout) === null || _keycloak$logout === void 0 ? void 0 : _keycloak$logout.call(keycloak);
      }
    } else if (event === 'onReady') {
      logKeycloakAuth(instanceId, 'Processing onReady event', error, keycloak === null || keycloak === void 0 ? void 0 : keycloak.authenticated, keycloak);
    }
  }, [setAuthInfo, keycloak, initialized]);
  React.useEffect(function () {
    if (keycloakEventHandlerRef) {
      keycloakEventHandlerRef.current = handleKeycloakEvent;
    }
  }, [keycloakEventHandlerRef, handleKeycloakEvent]);
  React.useEffect(function () {
    if (initialized) {
      if (!keycloak.authenticated && autoLogin) {
        keycloak.login();
      }

      setAuthInfo(currentAuthInfo(keycloak, initialized));
    }
  }, [keycloak, initialized, setAuthInfo]);
  React.useEffect(function () {

    return function () {
    };
  }, [initialized, keycloak]);
  return initialized ? /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: authInfo
  }, children) : null;
};

var KeycloakAuthProvider = function KeycloakAuthProvider(props) {
  var children = props.children;
  var keycloakEventHandlerRef = React.useRef();
  var client = new Keycloak({
    url: envVariable('REACT_APP_AUTH_KEYCLOAK_URL'),
    realm: envVariable('REACT_APP_AUTH_KEYCLOAK_REALM'),
    clientId: envVariable('REACT_APP_AUTH_KEYCLOAK_CLIENTID')
  });
  var initOptions = {
    pkceMethod: 'S256'
  };
  var handleKeycloakEvent = React.useCallback(function (event, error) {
    if (keycloakEventHandlerRef.current) {
      keycloakEventHandlerRef.current(event, error);
    }
  }, [keycloakEventHandlerRef]);
  return /*#__PURE__*/React.createElement(ReactKeycloakProvider, {
    authClient: client,
    initOptions: initOptions,
    onEvent: handleKeycloakEvent
  }, /*#__PURE__*/React.createElement(NestedKeycloakAuthProvider, {
    keycloakEventHandlerRef: keycloakEventHandlerRef
  }, children));
};

var hexToRgb = function hexToRgb(h, t) {
  var r = 0,
      g = 0,
      b = 0;

  if (h.length == 4) {
    r = parseInt(h[1] + h[1], 16);
    g = parseInt(h[2] + h[2], 16);
    b = parseInt(h[3] + h[3], 16);
  } else if (h.length == 7) {
    r = parseInt(h[1] + h[2], 16);
    g = parseInt(h[3] + h[4], 16);
    b = parseInt(h[5] + h[6], 16);
  }

  return t === undefined ? 'rgb(' + r + ',' + g + ',' + b + ')' : 'rgba(' + r + ',' + g + ',' + b + ',' + t + ')';
};

var ODD_OPACITY = 0.15;
var themeSettings = {
  components: {
    MuiDataGrid: {
      styleOverrides: {
        row: experimental_sx({
          '&.striped-odd': {
            '&:hover, &.Mui-hovered': {
              backgroundColor: function backgroundColor(theme) {
                return alpha(theme.palette.primary.main, ODD_OPACITY);
              },
              '@media (hover: none)': {
                backgroundColor: 'transparent'
              }
            }
          },
          '&.striped-even': {
            backgroundColor: function backgroundColor(theme) {
              return theme.palette.grey[100];
            },
            '&:hover, &.Mui-hovered': {
              backgroundColor: function backgroundColor(theme) {
                return alpha(theme.palette.primary.main, ODD_OPACITY);
              },
              '@media (hover: none)': {
                backgroundColor: 'transparent'
              }
            }
          }
        })
      }
    }
  }
};

export { ASYNC_STATUS_ERROR, ASYNC_STATUS_IDLE, ASYNC_STATUS_PENDING, ASYNC_STATUS_SUCCESS, AppMenusProvider, BaseApp, BaseAppProvider, ButtonLink, Form, FormField, Grid, IconAvatar, KettingProvider, KeycloakAuthProvider, List, NotFound, PermissionResourceId, PermissionResourceModule, SessionProvider, TOOLBAR_TYPE_FORM, TOOLBAR_TYPE_HEADER, TextAvatar, addComponentResourceBundles, countDecimalPositions, dateFormatInput, dateFormatLocale, themeSettings as defaultTheme, envVariable, getDecimalSeparator, hexToRgb, numberFormat, numberFormatCurrency, numberFormatEur, numberFormatField, tryParseDecimal, useActionDialog, useAppMenusContext, useAsync, useAuthContext, useBaseAppContext, useCallQueue, useContentDialog, useCurrentWidth, useExcelPaste, useFormContext, useFormDialog, useFormId, useKettingContext, useMessageDialog, usePrevious, useReportDialog, useResourceApi, useSessionContext };
